<template>
  <div
    v-if="tableOpening"
    translate="no"
    @click="onClickOutside"
    id="modal-container"
    class="modal-container-top-screen"
  >
    <div
      id="modal"
      class="modal-bigger"
      :class="{'light-blue-bgr': stateOfModal=='RECEIPT_VIEW' || stateOfModal=='TEMP_RECEIPTS',
               'light-green-bgr': stateOfModal=='FINAL_RECEIPTS'}"
    >
      <div id="header-and-content-container">
        <div id="open-table-modal-header" v-if="stateOfHeader=='SHOW_TABLE_OPENING_INFO'">
          <div id="table-and-close-button">
            <h3
              id="item-name"
            >{{ tableOpening.table.type=='BEACH_CHAIR' || tableOpening.table.type=='UMBRELLA_AT_HOTEL' ? labels.tableOpenings.beachChairHeader[language] : tableOpening.table.type=='HOTEL_ROOM'? labels.tableOpenings.hotelRoomHeader[language] : tableOpening.table.type=='TABLE' || tableOpening.table.type=='TABLE_AT_HOTEL' ? labels.tableOpenings.tableHeader[language] : labels.tableOpenings.spotHeader[language] }}: {{tableOpening.table.tableNumber}} {{tableOpening.alias}} {{tableOpening.table.familySection!=null ? ' | '+tableOpening.table.familySection : ''}}</h3>
            <div @click="onCloseClick" id="close-modal">
              <font-awesome-icon id="times" icon="times" />
            </div>
          </div>

          <div v-if="tableOpening.id==null" id="item-description-container">
            <div id="header-details-container">
              <h6 class="item-description">Κλειστό</h6>
            </div>
            <div id="all-buttons-container">
              <div id="action-buttons-container" v-if="stateOfModal=='SHOW_ORDERS'">
                <button
                  v-if="tableOpening.table.type!='HOTEL_ROOM'"
                  id="open-table-button"
                  @click="addNewOrderToTable()"
                  class="action-button"
                >
                  Άνοιγμα τραπεζιού
                  <font-awesome-icon icon="door-open" />
                </button>
              </div>
            </div>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>

          <div
            v-if="assignedTablesOnly && tableOpening.id!=null &&(tableOpening.openingUserId==null || !waiterIds.includes(tableOpening.openingUserId)) && (tableOpening.table.type=='BEACH_CHAIR' || tableOpening.table.type=='TABLE' || tableOpening.table.type=='TABLE_AT_HOTEL' || tableOpening.table.type=='UMBRELLA_AT_HOTEL')"
            id="item-description-container"
          >
            <div id="header-details-container">
              <h6
                class="item-description"
              >Θα πρέπει να κάνετε ανάθεση τραπεζιού πάνω σας, ώστε να κάνετε αλλαγές σε αυτό</h6>
            </div>
            <div id="all-buttons-container">
              <div id="action-buttons-container" v-if="stateOfModal=='SHOW_ORDERS'">
                <button
                  v-if="tableOpening.table.type!='HOTEL_ROOM'"
                  id="assign-table-button"
                  @click="assignTable(currentUserId)"
                  class="action-button"
                >Ανάθεση τραπεζιού</button>
              </div>
            </div>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>

          <div v-else-if="tableOpening.id!=null" id="item-description-container">
            <div id="header-details-container" v-if="!hideDetails">
              <h6
                class="item-description"
              >{{labels.tableOpenings.totalCost[language]}} {{(tableOpening.totalPrice + tableOpening.amountTreated + tableOpening.amountCanceled).toFixed(2)}}€</h6>
              <h6
                class="item-description"
                v-if="tableOpening.minimumConsumption>0 && tableOpening.totalPrice!=0 && tableOpening.totalPrice<tableOpening.minimumConsumption"
              >{{labels.tableOpenings.minimumConsumption[language]}} {{tableOpening.minimumConsumption.toFixed(2)}}€</h6>
              <div
                class="payed-already-container"
                v-if="tableOpening.currentlyOpen && (tableOpening.amountPayedByCard > 0  || tableOpening.amountPayedByCash > 0) "
              >
                <h6
                  class="payed-already-info"
                  style="margin-right: 2px;"
                >{{labels.tableOpenings.alreadyPaid[language]}}</h6>
                <font-awesome-icon
                  class="payed-already-icon-cash"
                  style="margin-right: 4px"
                  icon="money-bill"
                />
                <h6
                  class="payed-already-info"
                >{{tableOpening.amountPayedByCash.toFixed(2)}}{{' | '}}</h6>
                <font-awesome-icon
                  class="payed-already-icon-card"
                  style="margin-left: 6px; margin-right: 4px;"
                  icon="credit-card"
                />
                <font-awesome-icon
                  v-if="tableOpening.restaurant.publishesReceipts"
                  class="payed-already-icon-bank"
                  style="margin-left: 2px; margin-right: 4px;"
                  icon="store-alt"
                />
                <h6 class="payed-already-info">{{tableOpening.amountPayedByCard.toFixed(2)}}</h6>
              </div>
              <div
                class="payed-already-container"
                v-if="tableOpening.currentlyOpen && (tableOpening.amountChargedToRoom > 0) "
              >
                <font-awesome-icon
                  class="bed-payed-already-icon-cash"
                  style="margin-right: 6px; margin-left: 2px;"
                  icon="bed"
                />
                <h6
                  class="payed-already-info"
                  style="margin-right: 6px;"
                >{{labels.tableOpenings.chargedToRoom[language]}} {{(tableOpening.amountChargedToRoom).toFixed(2)}}€</h6>
              </div>

              <hr
                style="margin-top:2px; margin-bottom:2px"
                v-if="(tableOpening.amountTreated > 0 || tableOpening.amountCanceled > 0 || tableOpening.amountOfDiscounts > 0) && tableOpening.currentlyOpen"
              />

              <div
                class="payed-already-container"
                v-if="tableOpening.currentlyOpen && (tableOpening.amountOfDiscounts > 0) "
              >
                <font-awesome-icon
                  class="discounts-icon"
                  style="margin-right: 8px; margin-left: 4px;"
                  icon="percent"
                />
                <h6
                  class="payed-already-info"
                  style="margin-right: 6px;"
                >{{labels.tableOpenings.discountApplied[language]}} {{(tableOpening.amountOfDiscounts).toFixed(2)}}€</h6>
              </div>

              <div
                class="payed-already-container"
                v-if="tableOpening.currentlyOpen && (tableOpening.amountTreated > 0) "
              >
                <font-awesome-icon
                  class="treated-icon-cash"
                  style="margin-right: 8px; margin-left: 3px;"
                  icon="gift"
                />
                <h6
                  class="payed-already-info"
                  style="margin-right: 6px;"
                >{{labels.tableOpenings.treated[language]}} {{(tableOpening.amountTreated).toFixed(2)}}€</h6>
              </div>

              <div
                class="payed-already-container"
                v-if="tableOpening.currentlyOpen && (tableOpening.amountCanceled > 0) "
              >
                <font-awesome-icon
                  class="canceled-icon-cash"
                  style="margin-right: 8px; margin-left: 4px;"
                  icon="trash-alt"
                />
                <h6
                  class="payed-already-info"
                  style="margin-right: 6px;"
                >{{labels.tableOpenings.canceled[language]}} {{(tableOpening.amountCanceled).toFixed(2)}}€</h6>
              </div>
              <hr
                style="margin-top:4px"
                v-if="tableOpening.currentlyOpen && ((tableOpening.amountPayedByCard > 0  || tableOpening.amountPayedByCash > 0 || tableOpening.amountChargedToRoom > 0 || tableOpening.amountTreated > 0 || tableOpening.amountCanceled > 0 || tableOpening.amountOfDiscounts > 0) || (tableOpening.note!=null && tableOpening.note.trim().length!=0))"
              />

              <h6
                class="item-description"
                v-if="tableOpening.currentlyOpen && (tableOpening.amountPayedByCard > 0  || tableOpening.amountPayedByCash > 0 || tableOpening.amountChargedToRoom > 0 || tableOpening.amountTreated > 0 || tableOpening.amountCanceled > 0 )"
              >{{labels.tableOpenings.remainingToBePaid[language]}} {{amountRemainingToBePaidToFixed}}€</h6>

              <h6
                v-if="tableOpening.note!=null && tableOpening.note.trim().length!=0"
                class="item-description"
                style="color: #d70b89; margin-left:4px"
              >
                <font-awesome-icon icon="sticky-note" style="margin-right: 2px;" />
                {{tableOpening.note}}
              </h6>

              <div class="payed-already-container" v-if="!tableOpening.currentlyOpen">
                <h6
                  class="payed-already-info"
                  style="margin-right: 6px; font-size:15px;"
                >{{labels.tableOpenings.amountCollected[language]}} {{(tableOpening.totalPrice - tableOpening.amountChargedToRoom).toFixed(2)}}€</h6>
              </div>

              <div class="payed-already-container" v-if="!tableOpening.currentlyOpen">
                <h6 class="payed-already-info" style="margin-right: 6px;">
                  <font-awesome-icon
                    class="payed-already-icon-cash"
                    style="margin-right: 4px"
                    icon="money-bill"
                  />
                  {{ labels.payment.cash[language] }} {{tableOpening.amountPayedByCash.toFixed(2)}}€
                </h6>
              </div>
              <div class="payed-already-container" v-if="!tableOpening.currentlyOpen">
                <h6 class="payed-already-info" style="margin-right: 6px;">
                  <font-awesome-icon
                    class="payed-already-icon-card"
                    style="margin-left: 4px; margin-right: 4px;"
                    icon="credit-card"
                  />
                  <font-awesome-icon
                    v-if="tableOpening.restaurant.publishesReceipts "
                    class="payed-already-icon-bank"
                    style="margin-left: 0px; margin-right: 4px;"
                    icon="store-alt"
                  />
                  {{ tableOpening.restaurant.publishesReceipts ? labels.payment.card[language] + ' & Τράπεζα' : labels.payment.card[language]}} {{tableOpening.amountPayedByCard.toFixed(2)}}€
                </h6>
              </div>
              <div
                class="payed-already-container"
                v-if="!tableOpening.currentlyOpen && isHotel && tableOpening.table.type!='HOTEL_ROOM'"
              >
                <h6 class="payed-already-info" style="margin-right: 6px;">
                  <font-awesome-icon
                    class="bed-payed-already-icon-cash"
                    style="margin-right: 2px"
                    icon="bed"
                  />
                  {{labels.tableOpenings.chargedToRoom[language]}} {{tableOpening.amountChargedToRoom.toFixed(2)}}€
                </h6>
              </div>

              <div v-if="!tableOpening.currentlyOpen" class="payed-already-container">
                <h6 class="payed-already-info" style="margin-right: 6px;">
                  <font-awesome-icon
                    class="discounts-icon"
                    style="margin-right: 4px"
                    icon="percent"
                  />
                  {{labels.tableOpenings.discountApplied[language]}} {{tableOpening.amountOfDiscounts.toFixed(2)}}€
                </h6>
              </div>

              <div v-if="!tableOpening.currentlyOpen" class="payed-already-container">
                <h6 class="payed-already-info" style="margin-right: 6px;">
                  <font-awesome-icon
                    class="treated-icon-cash"
                    style="margin-right: 4px"
                    icon="gift"
                  />
                  {{labels.tableOpenings.treated[language]}} {{tableOpening.amountTreated.toFixed(2)}}€
                </h6>
              </div>

              <div v-if="!tableOpening.currentlyOpen" class="payed-already-container">
                <h6 class="payed-already-info" style="margin-right: 6px;">
                  <font-awesome-icon
                    class="canceled-icon-cash"
                    style="margin-right: 5px"
                    icon="trash-alt"
                  />
                  {{labels.tableOpenings.canceled[language]}} {{tableOpening.amountCanceled.toFixed(2)}}€
                </h6>
              </div>
            </div>
            <div v-else id="header-details-container">
              <h6
                class="item-description"
              >{{labels.tableOpenings.toBePaidWholeWord[language]}} {{amountRemainingToBePaidToFixed}}€</h6>
            </div>
            <h6 id="table-opening-date">
              {{tableOpening.openingDate.slice(0,-3)}}{{hideDetails ? '' : ' | id: ' + tableOpening.id}}
              <button
                v-if="tableOpening.currentlyOpen && stateOfModal=='SHOW_ORDERS' && isAtLeastOneOrderNotifiesUser && isAtLeastOneOrderNotExecuted"
                class="action-button"
                id="execute-button"
                @click="executeOrders(true)"
              >
                <font-awesome-icon
                  v-if="!ongoingModalAction"
                  icon="bell"
                  style="margin-left: 2px;"
                />
                <clip-loader
                  v-if="ongoingModalAction"
                  :loading="ongoingModalAction"
                  size="12px"
                  color="#6c757d"
                />
              </button>

              <button
                v-if="tableOpening.currentlyOpen && stateOfModal=='SHOW_ORDERS' && isAtLeastOneOrderNotifiesUser && !isAtLeastOneOrderNotExecuted"
                class="action-button"
                id="re-execute-button"
                @click="executeOrders(false)"
              >
                <font-awesome-icon
                  v-if="!ongoingModalAction"
                  icon="check"
                  style="margin-left: 2px;"
                />
                <clip-loader
                  v-if="ongoingModalAction"
                  :loading="ongoingModalAction"
                  size="14px"
                  color="#198b4a"
                />
              </button>

              <button
                v-if="tableOpening.id!=null && tableOpening.currentlyOpen && stateOfModal=='SHOW_ORDERS' && assignedTablesOnly && waiterOfcurrentUser && waiterOfcurrentUser.ableToViewAllOpenTables && waiterOfcurrentUser.ableToEditOtherOpenTables && (tableOpening.table.type=='BEACH_CHAIR' || tableOpening.table.type=='TABLE' || tableOpening.table.type=='TABLE_AT_HOTEL' || tableOpening.table.type=='UMBRELLA_AT_HOTEL')"
                class="action-button"
                id="change-user-button"
                @click="changeStateOfHeader('EDIT_USER')"
              >
                <font-awesome-icon icon="user" style="margin-left: 2px;" />
              </button>

              <button
                v-if="tableOpening.currentlyOpen && stateOfModal=='SHOW_ORDERS'"
                class="action-button"
                id="add-note-button"
                @click="changeStateOfHeader('EDIT_NOTE')"
              >
                <font-awesome-icon icon="sticky-note" style="margin-left: 2px;" />
              </button>

              <button
                v-if="tableOpening.currentlyOpen && stateOfModal=='SHOW_ORDERS' && userCanEditMinimumConsumption"
                class="action-button"
                style="margin-right:3px; width:26px"
                id="edit-min-consumption-button"
                @click="changeStateOfHeader('EDIT_MINIMUM_CONSUMPTION')"
              >
                <font-awesome-icon icon="dollar-sign" style="margin-left: 2px;" />
              </button>

              <button
                v-if="selectedOrderProducts.length==0 && userCanDiscount && amountRemainingToBePaidToFixed!='0.00' && amountRemainingToBePaidToFixed!='-0.00' && tableOpening.currentlyOpen && stateOfModal=='SHOW_ORDERS'"
                class="action-button"
                id="add-discount-button"
                @click="changeStateOfHeader('DISCOUNT_STATE')"
              >
                <font-awesome-icon icon="percent" style="margin-left: 2px;" />
              </button>
              <button
                v-if="stateOfModal != 'RECEIPT_VIEW' && stateOfModal!='TEMP_RECEIPTS' && stateOfModal!='FINAL_RECEIPTS' && stateOfModal!='SELF_DELIVERY_RECEIPT' && tableOpening.restaurant.publishesReceipts && userCanPublishReceipts && userCanAccessCashRegister"
                style="margin-left:8px;"
                class="action-button"
                id="switch-to-receipts-view-button"
                @click="changeModalState('RECEIPT_VIEW')"
              >
                <font-awesome-icon
                  icon="cash-register"
                  style="margin-right: 2px; margin-bottom: 1px;"
                />
                {{labels.tableOpenings.cashRegister[language]}}
              </button>
              <button
                v-else-if="stateOfModal == 'RECEIPT_VIEW' && tableOpening.restaurant.publishesReceipts && tableOpening.table.typeOfReceipt=='TEMP_RECEIPT'"
                class="action-button"
                id="switch-to-self-delivery-receipt-btn"
                @click="changeModalState('SELF_DELIVERY_RECEIPT')"
              >{{labels.tableOpenings.receiptSelfDelivery[language]}}</button>
              <button
                v-if="stateOfModal == 'RECEIPT_VIEW' && tableOpening.restaurant.publishesReceipts"
                class="action-button"
                id="restart-cash-register-btn"
                @click="restartCashRegister()"
              >
                <span v-if="!restartingCashRegister">Restart</span>
                <font-awesome-icon
                  v-if="!restartingCashRegister"
                  icon="cash-register"
                  style="margin-left: 6px"
                />
                <clip-loader
                  v-if="restartingCashRegister"
                  :loading="restartingCashRegister"
                  size="12px"
                  color="#ffffff"
                />
              </button>
            </h6>
            <div
              id="all-buttons-container"
              v-if="tableOpening.currentlyOpen && !tableOpening.transferred"
            >
              <div id="action-buttons-container" v-if="stateOfModal=='SHOW_ORDERS'">
                <button
                  v-if="userCanCloseTable"
                  class="action-button"
                  id="go-to-close-table-opening-button"
                  @click="changeModalState('CLOSE_TABLE_OPENING')"
                >{{labels.tableOpenings.closeTable[language]}}</button>
                <button
                  v-if="userCanTransferTable"
                  class="action-button"
                  id="transfer-table-opening-button"
                  @click="changeModalState('TRANSFER_ORDERS_OF_TABLE')"
                >{{labels.tableOpenings.transferTable[language]}}</button>
                <button
                  v-if="tableOpening.table.type!='HOTEL_ROOM' && selectedOrderProducts.length==0"
                  id="new-order-button"
                  @click="addNewOrderToTable()"
                  class="action-button"
                >
                  <font-awesome-icon icon="plus" />
                </button>
                <button
                  v-if="tableOpening.table.type!='HOTEL_ROOM' && selectedOrderProducts.length>0"
                  id="repeat-order-button"
                  @click="reOrder()"
                  class="action-button"
                >
                  <clip-loader
                    v-if="ongoingModalAction"
                    :loading="ongoingModalAction"
                    size="15px"
                    color="#ffffff"
                  />
                  <font-awesome-icon v-if="!ongoingModalAction" icon="history" />
                </button>
                <button
                  class="action-button"
                  :class="{greenEye: hideDetails,
                        greyEye: !hideDetails}"
                  @click="toggleDetails()"
                >
                  <font-awesome-icon v-if="!hideDetails" icon="eye-slash" />
                  <font-awesome-icon v-else icon="eye" />
                </button>
              </div>
              <button
                id="print-whole-order-button"
                class="action-button"
                v-if="stateOfModal=='SHOW_ORDERS' && userCanPrintBill && tableOpening.table.typeOfReceipt!='DISPATCH_NOTE'"
                @click="printWholeTableOpening()"
              >
                <clip-loader
                  v-if="printingTableOpening"
                  :loading="printingTableOpening"
                  size="16px"
                  color="#ffffff"
                />
                <font-awesome-icon v-else icon="print" />
              </button>
              <div id="action-buttons-container" v-if="stateOfModal!='SHOW_ORDERS'">
                <button
                  class="action-button"
                  id="back-to-orders-button"
                  @click="changeModalState(stateOfModal=='TEMP_RECEIPTS' || stateOfModal=='FINAL_RECEIPTS' || stateOfModal=='SELF_DELIVERY_RECEIPT' || (stateOfModal=='INVOICE_DETAILS' && tableOpening.table.typeOfReceipt=='FINAL_RECEIPT') ? 'RECEIPT_VIEW' : stateOfModal=='INVOICE_DETAILS' ? 'TEMP_RECEIPTS' : stateOfModal=='CARD_TERMINAL_SELECTION' && selectedOrderProductsForReceipt.length > 0 ? 'RECEIPT_VIEW': stateOfModal=='CARD_TERMINAL_SELECTION' && selectedTempReceipts.length > 0 ? 'TEMP_RECEIPTS' : stateOfModal=='CARD_TERMINAL_SELECTION' && selectedOnCreditReceipt!=null ? 'FINAL_RECEIPTS': 'SHOW_ORDERS')"
                >
                  <font-awesome-icon icon="arrow-left" style="margin-right:4px;" />
                  {{labels.tableOpenings.return[language]}}
                </button>
                <button
                  v-if="stateOfModal=='RECEIPT_VIEW' && tableOpening.table.typeOfReceipt=='TEMP_RECEIPT'"
                  class="action-button"
                  id="temp-history-receipts-button"
                  @click="changeModalState('TEMP_RECEIPTS')"
                >
                  Ιστορικό προσωρινών
                  <font-awesome-icon icon="history" />
                </button>
                <button
                  v-if="stateOfModal=='RECEIPT_VIEW'"
                  class="action-button"
                  id="final-history-receipts-button"
                  @click="changeModalState('FINAL_RECEIPTS')"
                >
                  Ιστορικό τελικών
                  <font-awesome-icon icon="history" />
                </button>
              </div>
            </div>
            <div
              id="all-buttons-container"
              v-else-if="!tableOpening.currentlyOpen && stateOfModal=='SHOW_ORDERS'"
            >
              <div
                id="table-closed-container-info"
              >{{isFromHistoryScreen ? labels.tableOpenings.closedTable[language] : labels.tableOpenings.tableHasClosed[language]}}</div>
              <button
                v-if="tableOpening.table.type!='HOTEL_ROOM' && !isFromHistoryScreen"
                id="open-table-button"
                style="margin-bottom: 6px"
                @click="addNewOrderToTable()"
                class="action-button"
              >
                Άνοιγμα
                <font-awesome-icon icon="door-open" />
              </button>

              <button
                v-if="isFromHistoryScreen && userCanReopenTable && tableOpening.table.typeOfReceipt!='DISPATCH_NOTE'"
                id="open-table-button"
                style="margin-bottom: 6px; display: flex; align-items: center"
                @click="reopenTable()"
                class="action-button"
              >
                <span>Επαναφορά</span>
                <clip-loader
                  v-if="ongoingModalAction"
                  :loading="ongoingModalAction"
                  style="margin-left:6px"
                  size="13px"
                  color="#ffffff"
                />
                <font-awesome-icon v-else style="margin-left:6px" icon="history" />
              </button>
              <button
                class="action-button"
                style="margin-bottom: 6px; margin-left:12px;"
                :class="{greenEye: hideDetails,
                        greyEye: !hideDetails}"
                @click="toggleDetails()"
              >
                <font-awesome-icon v-if="!hideDetails" icon="eye-slash" />
                <font-awesome-icon v-else icon="eye" />
              </button>
              <button
                id="print-whole-order-button"
                class="action-button"
                v-if="stateOfModal=='SHOW_ORDERS' && userCanPrintBill && tableOpening.table.typeOfReceipt!='DISPATCH_NOTE'"
                @click="printWholeTableOpening()"
              >
                <clip-loader
                  v-if="printingTableOpening"
                  :loading="printingTableOpening"
                  size="16px"
                  color="#ffffff"
                />
                <font-awesome-icon v-else icon="print" />
              </button>
            </div>
            <div
              id="all-buttons-container"
              v-else-if="!tableOpening.currentlyOpen && stateOfModal=='RECEIPT_VIEW'"
            >
              <div id="action-buttons-container">
                <button
                  class="action-button"
                  id="back-to-orders-button"
                  @click="changeModalState('SHOW_ORDERS')"
                >
                  <font-awesome-icon icon="arrow-left" style="margin-right:4px;" />
                  {{labels.tableOpenings.return[language]}}
                </button>
                <button
                  v-if="stateOfModal=='RECEIPT_VIEW' && tableOpening.table.typeOfReceipt=='TEMP_RECEIPT'"
                  class="action-button"
                  id="temp-history-receipts-button"
                  @click="changeModalState('TEMP_RECEIPTS')"
                >
                  Ιστορικό προσωρινών
                  <font-awesome-icon icon="history" />
                </button>
                <button
                  v-if="stateOfModal=='RECEIPT_VIEW'"
                  class="action-button"
                  id="final-history-receipts-button"
                  @click="changeModalState('FINAL_RECEIPTS')"
                >
                  Ιστορικό τελικών
                  <font-awesome-icon icon="history" />
                </button>
              </div>
            </div>
            <div
              id="all-buttons-container"
              v-else-if="!tableOpening.currentlyOpen && (stateOfModal=='TEMP_RECEIPTS' || stateOfModal=='FINAL_RECEIPTS' || stateOfModal=='SELF_DELIVERY_RECEIPT' || (stateOfModal=='CARD_TERMINAL_SELECTION' && selectedOrderProductsForReceipt.length > 0))"
            >
              <div id="action-buttons-container">
                <button
                  class="action-button"
                  id="back-to-orders-button"
                  @click="changeModalState('RECEIPT_VIEW')"
                >
                  <font-awesome-icon icon="arrow-left" style="margin-right: 4px;" />
                  {{labels.tableOpenings.return[language]}}
                </button>
              </div>
            </div>
            <div
              id="all-buttons-container"
              v-else-if="!tableOpening.currentlyOpen && stateOfModal=='CARD_TERMINAL_SELECTION' && (selectedTempReceipts.length > 0 || selectedOnCreditReceipt!=null)"
            >
              <div id="action-buttons-container">
                <button
                  class="action-button"
                  id="back-to-orders-button"
                  @click="changeModalState(selectedTempReceipts.length > 0 ? 'TEMP_RECEIPTS':'FINAL_RECEIPTS')"
                >
                  <font-awesome-icon icon="arrow-left" style="margin-right: 4px;" />
                  {{labels.tableOpenings.return[language]}}
                </button>
              </div>
            </div>
            <div id="all-buttons-container" v-else-if="tableOpening.transferred">
              <div
                id="table-closed-container-info"
                style="width:100%;"
              >{{labels.tableOpenings.tableHasBeenTransferred[language]}}</div>
              <button
                class="action-button"
                style="margin-bottom: 6px; margin-left:12px;"
                :class="{greenEye: hideDetails,
                        greyEye: !hideDetails}"
                @click="toggleDetails()"
              >
                <font-awesome-icon v-if="!hideDetails" icon="eye-slash" />
                <font-awesome-icon v-else icon="eye" />
              </button>
            </div>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
            <h6 v-if="successfullAction" id="success-message-container">{{successfullMessage}}</h6>
          </div>
        </div>
        <div id="open-table-modal-header" v-if="stateOfHeader=='EDIT_NOTE'">
          <div id="table-and-close-button">
            <h3
              id="item-name"
            >{{ tableOpening.table.type=='BEACH_CHAIR' || tableOpening.table.type=='UMBRELLA_AT_HOTEL' ? labels.tableOpenings.beachChairHeader[language] : tableOpening.table.type=='HOTEL_ROOM'? labels.tableOpenings.hotelRoomHeader[language] : tableOpening.table.type=='TABLE' || tableOpening.table.type=='TABLE_AT_HOTEL' ? labels.tableOpenings.tableHeader[language] : labels.tableOpenings.spotHeader[language] }}: {{tableOpening.table.tableNumber}} {{tableOpening.alias}} {{tableOpening.table.familySection!=null ? ' | '+tableOpening.table.familySection : ''}}</h3>
            <div @click="onCloseClick" id="close-modal">
              <font-awesome-icon id="times" icon="times" />
            </div>
          </div>
          <h6 id="write-note-header">Γράψτε την σημείωση σας</h6>
          <div id="edit-note-container">
            <textarea v-model="tableOpeningNote" id="note-textarea"></textarea>
            <div v-if="!ongoingModalAction" id="note-buttons-container">
              <button
                @click="editTableOpeningNote()"
                class="action-button"
                id="save-note-button"
              >Αποθήκευση</button>
              <button
                class="action-button"
                id="cancel-note-button"
                @click="changeStateOfHeader('SHOW_TABLE_OPENING_INFO')"
              >Άκυρο</button>
            </div>
            <clip-loader
              v-if="ongoingModalAction"
              :loading="ongoingModalAction"
              size="18px"
              color="#003340"
            />
          </div>
          <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
        </div>

        <div id="open-table-modal-header" v-if="stateOfHeader=='DISCOUNT_STATE'">
          <h6 id="add-discount-header">Κάντε έκπτωση στο τραπέζι</h6>
          <h6 id="total-for-discount">Προς εξόφληση: {{amountRemainingToBePaidToFixed}}€</h6>

          <hr style="margin-top:6px; margin-bottom:2px; width: 100%" />
          <div id="discount-state-container">
            <div v-if="typeOfDiscount=='PERCENTAGE'" id="pda-discount-input-container">
              <h6 class="payment-type-title" style="margin-bottom: 0px">Έκπτωση %</h6>
              <input
                id="pda-discount-input"
                style="margin-bottom: 0px"
                @input="adjustFinalPriceAfterDiscount()"
                v-model="closeTableDiscount"
                type="number"
                placeholder="πχ 10%"
              />
            </div>

            <h6
              v-if="typeOfDiscount=='PERCENTAGE' && closeTableDiscount>0 && finalPriceAfterDiscount!=null && finalPriceAfterDiscount!=undefined"
              id="pda-discount-header"
            >Τελική τιμή: {{finalPriceAfterDiscount}}€</h6>

            <h6
              v-if="typeOfDiscount=='FINAL_PRICE'"
              class="payment-type-title"
              style="margin-bottom:0px"
            >Έκπτωση</h6>
            <div v-if="typeOfDiscount=='FINAL_PRICE'" id="pda-discount-input-container">
              <h6 id="pda-discount-header" style="margin-bottom: 0px">Τελική τιμή:</h6>
              <input
                id="pda-discount-input"
                style="margin-bottom: 0px"
                @input="adjustCloseTableDiscount()"
                v-model="finalPriceAfterDiscount"
                type="number"
                placeholder="πχ 3€"
              />
            </div>

            <div id="pda-discount-options">
              <div
                class="pda-discount-option"
                @click="selectDiscountType('PERCENTAGE')"
                style="margin-right: 12px;"
              >
                <input
                  class="pda-discount-type-input"
                  type="radio"
                  value="PERCENTAGE"
                  v-model="typeOfDiscount"
                />
                <h6 class="pda-discount-option-title">Ποσοστό</h6>
              </div>
              <div class="pda-discount-option" @click="selectDiscountType('FINAL_PRICE')">
                <input
                  class="pda-discount-type-input"
                  type="radio"
                  value="FINAL_PRICE"
                  v-model="typeOfDiscount"
                />
                <h6 class="pda-discount-option-title">Τελική τιμή</h6>
              </div>
            </div>

            <h6
              v-if="typeOfDiscount=='FINAL_PRICE'"
              style="display: inline-block; font-size: 13px"
              class="mb-2 alert alert-secondary pl-1 pt-1 pb-1"
            >*ΠΡΟΣΟΧΗ* Γράψτε την τελική τιμή που θα έχει το τραπέζι μετά την έκπτωση</h6>
          </div>

          <div id="edit-note-container">
            <div v-if="!ongoingModalAction" id="note-buttons-container" style="margin-bottom: 15px">
              <button
                @click="putDiscount()"
                class="action-button"
                id="save-discount-button"
              >Αποθήκευση</button>
              <button
                class="action-button"
                id="cancel-note-button"
                @click="changeStateOfHeader('SHOW_TABLE_OPENING_INFO')"
              >Άκυρο</button>
            </div>
            <clip-loader
              v-if="ongoingModalAction"
              :loading="ongoingModalAction"
              size="18px"
              color="#003340"
            />
          </div>
          <h6
            v-if="errorAtModalAction"
            id="error-message-container"
            style="margin-top:0px !important; margin-left:12px !important"
          >{{errorMessage}}</h6>
        </div>

        <div id="open-table-modal-header" v-if="stateOfHeader=='EDIT_USER'">
          <div id="table-and-close-button">
            <h3
              id="item-name"
            >{{ tableOpening.table.type=='BEACH_CHAIR' || tableOpening.table.type=='UMBRELLA_AT_HOTEL' ? labels.tableOpenings.beachChairHeader[language] : tableOpening.table.type=='HOTEL_ROOM'? labels.tableOpenings.hotelRoomHeader[language] : tableOpening.table.type=='TABLE' || tableOpening.table.type=='TABLE_AT_HOTEL' ? labels.tableOpenings.tableHeader[language] : labels.tableOpenings.spotHeader[language] }}: {{tableOpening.table.tableNumber}} {{tableOpening.alias}} {{tableOpening.table.familySection!=null ? ' | '+tableOpening.table.familySection : ''}}</h3>
            <div @click="onCloseClick" id="close-modal">
              <font-awesome-icon id="times" icon="times" />
            </div>
          </div>
          <h6 id="select-user-header">Eπιλέξτε χρήστη που θα αναλάβει το τραπέζι</h6>
          <div id="edit-user-container">
            <select
              id="room-to-charge-select"
              style="width: 60%; margin-left:6px; margin-top:6px; margin-bottom:10px"
              @change="clearErrors()"
              v-model="assignedUserId"
            >
              <option
                v-for="waiter in waiters"
                :key="waiter.userId"
                :value="waiter.userId"
              >{{waiter.name}}</option>
            </select>

            <div v-if="!ongoingModalAction" id="change-user-buttons-container">
              <button
                @click="assignTable(assignedUserId)"
                class="action-button"
                id="save-assigned-user-button"
              >Αποθήκευση</button>
              <button
                class="action-button"
                id="cancel-note-button"
                @click="changeStateOfHeader('SHOW_TABLE_OPENING_INFO')"
              >Άκυρο</button>
            </div>
            <clip-loader
              v-if="ongoingModalAction"
              :loading="ongoingModalAction"
              size="18px"
              color="#003340"
            />
          </div>
          <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
        </div>

        <div id="open-table-modal-header" v-if="stateOfHeader=='EDIT_MINIMUM_CONSUMPTION'">
          <div id="table-and-close-button">
            <h3
              id="item-name"
            >{{ tableOpening.table.type=='BEACH_CHAIR' || tableOpening.table.type=='UMBRELLA_AT_HOTEL' ? labels.tableOpenings.beachChairHeader[language] : tableOpening.table.type=='HOTEL_ROOM'? labels.tableOpenings.hotelRoomHeader[language] : tableOpening.table.type=='TABLE' || tableOpening.table.type=='TABLE_AT_HOTEL' ? labels.tableOpenings.tableHeader[language] : labels.tableOpenings.spotHeader[language] }}: {{tableOpening.table.tableNumber}} {{tableOpening.alias}} {{tableOpening.table.familySection!=null ? ' | '+tableOpening.table.familySection : ''}}</h3>
            <div @click="onCloseClick" id="close-modal">
              <font-awesome-icon id="times" icon="times" />
            </div>
          </div>
          <h6 id="edit-consumption-header" style="color: #01a317">Ποσό ελάχιστης κατανάλωσης</h6>
          <div id="edit-consumption-container">
            <input
              id="edit-consumption-input"
              style="margin-bottom: 10px; margin-left: 6px; margin-top: 4px"
              v-model="minimumConsumptionOfSelectedTable"
              @input="clearErrors()"
              type="number"
              placeholder="πχ 30€"
            />

            <div v-if="!ongoingModalAction" id="edit-consumption-buttons-container">
              <button
                @click="editTableOpeningMinimumConsumption()"
                class="action-button"
                style="background-color: #01d51d"
                id="save-assigned-user-button"
              >Αποθήκευση</button>
              <button
                class="action-button"
                id="cancel-note-button"
                @click="changeStateOfHeader('SHOW_TABLE_OPENING_INFO')"
              >Άκυρο</button>
            </div>
            <clip-loader
              v-if="ongoingModalAction"
              :loading="ongoingModalAction"
              size="18px"
              color="#003340"
            />
          </div>
          <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
        </div>

        <div v-if="loadingOrders" id="modal-content-container">
          <clip-loader :loading="loadingOrders"></clip-loader>
        </div>
        <div id="modal-content-container" v-else-if="errorWhileLoadingOrders">
          <h5 style="color: red;">{{labels.tableOpenings.somethingWrongTryAgain[language]}}</h5>
        </div>

        <!-------- RECEIPT_VIEW STATE -------->
        <div v-else-if="stateOfModal=='RECEIPT_VIEW'" id="modal-content-container">
          <div v-if="tableOpening.table.typeOfReceipt == 'TEMP_RECEIPT'">
            <h6
              id="choose-products-for-temp-receipt-title"
              v-if="isAtleastOneProductPendingReceipt"
            >
              {{labels.tableOpenings.selectProductsForTempReceipt[language]}}
              <button
                v-if="isAtleastOneProductPendingReceipt"
                class="action-button"
                id="total-receipt-cash-button"
                @click="selectAllItemsForReceipt()"
              >{{labels.tableOpenings.selectAll[language]}}</button>
            </h6>

            <h6
              v-else
              id="published-receipt-for-all-products-title"
            >{{labels.tableOpenings.publishedTempReceiptForAllProducts[language]}}</h6>
            <div
              class="order-content-container"
              v-for="order in ordersOfSelectedTableOpening"
              :key="order.id"
            >
              <ReceiptProduct
                ref="receiptProduct"
                v-for="(orderContent, indexOfOrderContent) in order.products"
                :key="indexOfOrderContent"
                :orderContent="orderContent"
                :language="language"
                :hideDetails="hideDetails"
                :tableOpening="tableOpening"
                @select-order-product-for-receipt="selectOrderProductForReceipt"
              ></ReceiptProduct>
            </div>
          </div>

          <!--Below is for spots that don't publish temp receipt firstly-->
          <div v-else>
            <h6
              id="choose-products-for-final-receipt-title"
              v-if="isAtleastOneProductPendingReceipt"
            >
              {{labels.tableOpenings.selectProductsForFinalReceipt[language]}}
              <button
                v-if="isAtleastOneProductPendingReceipt"
                class="action-button"
                id="total-receipt-cash-button"
                @click="selectAllItemsForReceipt()"
              >{{labels.tableOpenings.selectAll[language]}}</button>
            </h6>

            <h6
              v-else
              id="published-receipt-for-all-products-title"
            >{{labels.tableOpenings.publishedFinalReceiptForAllProducts[language]}}</h6>
            <div
              class="order-content-container"
              v-for="order in ordersOfSelectedTableOpening"
              :key="order.id"
            >
              <ReceiptProduct
                ref="receiptProduct"
                v-for="(orderContent, indexOfOrderContent) in order.products"
                :key="indexOfOrderContent"
                :orderContent="orderContent"
                :language="language"
                :hideDetails="hideDetails"
                :tableOpening="tableOpening"
                @select-order-product-for-receipt="selectOrderProductForReceipt"
              ></ReceiptProduct>
            </div>
          </div>
        </div>

        <!-------- TEMP_RECEIPTS STATE -------->
        <div v-else-if="stateOfModal=='TEMP_RECEIPTS'" id="modal-content-container">
          <clip-loader
            v-if="ongoingModalAction"
            style="margin-top:8px; margin-bottom:2px;"
            :loading="ongoingModalAction"
            size="22px"
            color="#393939"
          />
          <div v-else>
            <h6 id="temp-receipts-list-title">
              <font-awesome-icon icon="list-ul" style="margin-right:4px;" />Λίστα προσωρινών αποδείξεων
            </h6>
            <div id="closed-receipts-toggle-container">
              <label class="switch">
                <input type="checkbox" v-model="showClosedTempReceipts" />
                <span class="slider round"></span>
              </label>
              <h6
                id="show-also-closed-receipts-title"
                @click="toggleTempReceipts()"
              >Δες τις κλειστές προσωρινές αποδείξεις</h6>
            </div>

            <h6
              class="no-temp-receipts-msg"
              v-if="tempReceiptsToShow.length==0 && !showClosedTempReceipts"
            >Δεν υπάρχουν ανοικτές προσωρινές αποδείξεις</h6>
            <h6
              class="no-temp-receipts-msg"
              v-if="tempReceiptsToShow.length==0 && showClosedTempReceipts"
            >Δεν υπάρχουν κλειστές προσωρινές αποδείξεις</h6>

            <TempReceipt
              v-for="receipt in tempReceiptsToShow"
              :receipt="receipt"
              :userCanReprintReceipt="userCanReprintReceipt"
              :key="receipt.id"
              @print-temp-receipt="printTempReceipt"
              @select-temp-receipt="selectTempReceipt"
            ></TempReceipt>
          </div>
        </div>

        <!-------- INVOICE_DETAILS STATE -------->
        <div v-else-if="stateOfModal=='INVOICE_DETAILS'" id="modal-content-container">
          <h6 id="invoice-details-title">Στοιχεία πελάτη</h6>

          <div id="invoice-info-container">
            <h6 class="invoice-info-title">Χώρα</h6>
            <select
              id="invoice-country-selectw"
              class="invoice-info-input"
              style="height: 30px"
              v-model="invoiceCountry"
              @change="clearErrors()"
            >
              <option value="GR">Ελλάδα</option>
              <option value="AL">Αλβανία</option>
              <option value="AD">Ανδόρα</option>
              <option value="AT">Αυστρία</option>
              <option value="VA">Βατικανό</option>
              <option value="BE">Βέλγιο</option>
              <option value="MK">Βόρεια Μακεδονία</option>
              <option value="BA">Βοσνία και Ερζεγοβίνη</option>
              <option value="BG">Βουλγαρία</option>
              <option value="FR">Γαλλία</option>
              <option value="DE">Γερμανία</option>
              <option value="DK">Δανία</option>
              <option value="CH">Ελβετία</option>
              <option value="EE">Εσθονία</option>
              <option value="GB">Ηνωμένο Βασίλειο</option>
              <option value="US">ΗΠΑ (Αμερική)</option>
              <option value="IE">Ιρλανδία</option>
              <option value="IS">Ισλανδία</option>
              <option value="ES">Ισπανία</option>
              <option value="IT">Ιταλία</option>
              <option value="HR">Κροατία</option>
              <option value="CY">Κύπρος</option>
              <option value="LV">Λετονία</option>
              <option value="BY">Λευκορωσία</option>
              <option value="LT">Λιθουανία</option>
              <option value="LI">Λιχτενστάιν</option>
              <option value="LU">Λουξεμβούργο</option>
              <option value="MT">Μάλτα</option>
              <option value="MD">Μολδαβία</option>
              <option value="MC">Μονακό</option>
              <option value="ME">Μαυροβούνιο</option>
              <option value="NO">Νορβηγία</option>
              <option value="NL">Ολλανδία</option>
              <option value="HU">Ουγγαρία</option>
              <option value="UA">Ουκρανία</option>
              <option value="PL">Πολωνία</option>
              <option value="PT">Πορτογαλία</option>
              <option value="RO">Ρουμανία</option>
              <option value="RU">Ρωσία</option>
              <option value="SM">Άγιος Μαρίνος</option>
              <option value="RS">Σερβία</option>
              <option value="SK">Σλοβακία</option>
              <option value="SI">Σλοβενία</option>
              <option value="SE">Σουηδία</option>
              <option value="CZ">Τσεχία</option>
              <option value="TR">Τουρκία</option>
              <option value="FI">Φινλανδία</option>
            </select>

            <h6 class="invoice-info-title">ΑΦΜ</h6>
            <div class="invoice-search-container">
              <input class="invoice-info-input" @input="clearErrors()" v-model="vat" />
              <button
                v-if="invoiceCountry==null || invoiceCountry=='GR'"
                class="action-button"
                id="search-company-button"
                @click="searchCompanyByVat()"
              >
                <clip-loader
                  v-if="ongoingModalAction"
                  :loading="ongoingModalAction"
                  size="17px"
                  color="#ffffff"
                />
                <font-awesome-icon v-else id="icon" icon="search" />
              </button>
            </div>

            <h6 class="invoice-info-title">Επωνυμία εταιρείας</h6>
            <input
              class="invoice-info-input"
              :disabled="ongoingModalAction"
              @input="clearErrors()"
              v-model="companyName"
            />

            <h6 class="invoice-info-title">Οδός με αριθμό μαζί</h6>
            <input
              :disabled="ongoingModalAction"
              class="invoice-info-input"
              @input="clearErrors()"
              v-model="address"
            />

            <h6 class="invoice-info-title">Πόλη</h6>
            <input
              :disabled="ongoingModalAction"
              class="invoice-info-input"
              @input="clearErrors()"
              v-model="city"
            />

            <h6 class="invoice-info-title">Τ.Κ.</h6>
            <input
              :disabled="ongoingModalAction"
              class="invoice-info-input"
              @input="clearErrors()"
              v-model="postalCode"
            />

            <h6 :disabled="ongoingModalAction" class="invoice-info-title">Προαιρετικά σχόλια</h6>
            <input class="invoice-info-input" @input="clearErrors()" v-model="invoiceComments" />

            <h6 id="invoice-payment-method">Τρόπος πληρωμής</h6>
            <select class="no-bottom-margin" v-model="paymentMethodforInvoice">
              <option value="CASH">Μετρητά</option>
              <option value="CARD_TERMINAL">Κάρτα</option>
              <option value="ON_CREDIT">Επί πιστώσει</option>
              <option
                value="BANK_ACCOUNT"
                v-if="!restaurantsThatDontSupportBankPayment.includes(tableOpening.restaurant.id)"
              >Λογ. Τράπεζας</option>
            </select>

            <h6
              v-if="paymentMethodforInvoice=='CARD_TERMINAL' && cardTerminals.length>=1"
              id="invoice-payment-method"
            >Τερματικό κάρτας</h6>
            <select
              @change="clearErrors()"
              v-model="selectedCardTerminal"
              v-if="paymentMethodforInvoice=='CARD_TERMINAL' && cardTerminals.length>=1"
              class="no-bottom-margin"
            >
              <option :value="null" disabled>Κλικ εδώ για επιλογή τερματικού</option>
              <option
                v-for="cardTerminal in cardTerminals"
                :key="cardTerminal.id"
                :value="cardTerminal.id"
              >{{cardTerminal.friendlyName}}</option>
            </select>
          </div>
        </div>

        <!-------- FINAL_RECEIPTS STATE -------->
        <div v-else-if="stateOfModal=='FINAL_RECEIPTS'" id="modal-content-container">
          <clip-loader
            v-if="ongoingModalAction"
            style="margin-top:8px; margin-bottom:2px;"
            :loading="ongoingModalAction"
            size="22px"
            color="#393939"
          />
          <div v-else>
            <h6 id="final-receipts-list-title">
              <font-awesome-icon icon="list-ul" style="margin-right:4px;" />Λίστα τελικών αποδείξεων
            </h6>

            <h6
              class="no-temp-receipts-msg"
              v-if="finalReceiptsOfSelectedTableOpening.length==0"
            >Δεν έχετε εκδώσει κάποια τελική απόδειξη ακόμη</h6>

            <FinalReceipt
              v-for="receipt in finalReceiptsOfSelectedTableOpening"
              :receipt="receipt"
              :adminAccounts="adminAccounts"
              :restaurantId="tableOpening.restaurant.id"
              :key="receipt.id"
              :authToken="authToken"
              :userCanReprintReceipt="userCanReprintReceipt"
              :jwt="jwt"
              @print-final-receipt="printFinalReceipt"
              @fetch-final-receipts-and-orders="fetchFinalReceiptsAndOrders"
              @send-payment-to-pos="selectTerminalOrSendPaymentToPos"
            ></FinalReceipt>
          </div>
        </div>

        <div v-else-if="stateOfModal=='SELF_DELIVERY_RECEIPT'" id="modal-content-container">
          <div id="close-table-opening-container">
            <div>
              <h6 class="payment-type-title">Πατήστε το επιθυμητό ποσό</h6>
              <div>
                <input
                  type="number"
                  class="payed-by-input"
                  placeholder="π.χ. 10€"
                  @input="onAmountForSelfDeliveryChange()"
                  v-model="amountForSelfDeliveryReceipt"
                />
              </div>
            </div>

            <button
              class="action-button"
              id="publish-self-delivery-temp-receipt-btn"
              style="margin-right: 0px !important; margin-top: 10px;"
              @click="generateTempSelfDeliveryReceipt()"
            >
              <clip-loader :loading="ongoingModalAction" size="18px" color="#ffffff" />
              {{ongoingModalAction ? '' : 'Έκδοση δελτίου αυτοπαράδοσης'}}
            </button>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>
        </div>

        <!-------- SHOW ORDERS STATE -------->
        <div
          v-else-if="stateOfModal=='SHOW_ORDERS' && stateOfHeader!='DISCOUNT_STATE'"
          id="modal-content-container"
        >
          <div
            class="order-content-container"
            v-for="(order, indexOfOrder) in ordersOfSelectedTableOpening"
            :key="order.id"
          >
            <hr v-if="indexOfOrder>0 && !hideDetails" style="margin-top: 18px; margin-bottom: 18px" />
            <div class="order-header-container">
              <div class="order-header-info-container" v-if="!hideDetails">
                <h6 class="order-header-info">
                  {{ labels.delivery.order[language] }}: {{order.dailyOrderNumber}} {{order.pda ? '| PDA':''}} {{order.pda && order.customerName != null && order.customerName.trim().length!=0 ? order.customerName :''}}
                  <font-awesome-icon
                    v-if="!order.pda"
                    style="color:green; margin-left:4px;"
                    icon="user"
                  />
                  <font-awesome-icon
                    v-if="order.pda"
                    style="color: #3d3d3d; margin-left:4px;"
                    icon="mobile-alt"
                  />
                </h6>
                <h6 v-if="order.orderTransfer" class="order-header-info">
                  Μεταφορά από {{order.transferredFrom!=null && order.transferredFrom.trim().length>0 ? order.transferredFrom : 'άλλο σημείο'}}
                  <font-awesome-icon style="color: #3d3d3d; margin-left: 2px;" icon="forward" />
                </h6>
                <h6
                  class="order-header-info"
                >{{labels.tableOpenings.totalCost[language]}} {{order.price.toFixed(2)}}€</h6>
                <h6 class="order-header-date">{{order.date}}</h6>
              </div>
              <div
                class="order-buttons"
                v-if="!hideDetails && userCanReprintOrder && tableOpening.table.typeOfReceipt!='DISPATCH_NOTE'"
              >
                <button class="action-button print-just-order-button" @click="printOrder(order)">
                  <clip-loader
                    v-if="printingOrderId == order.id"
                    :loading="printingOrderId == order.id"
                    size="16px"
                    color="#ffffff"
                  />
                  <font-awesome-icon v-else icon="print" />
                </button>
              </div>
            </div>
            <ProductInOrder
              ref="productToBePaid"
              v-for="(orderContent, indexOfOrderContent) in order.products"
              :key="indexOfOrderContent"
              :orderContent="orderContent"
              :language="language"
              :hideDetails="hideDetails"
              :tableOpening="tableOpening"
              @select-order-product="selectOrderProduct"
            ></ProductInOrder>

            <div
              class="order-note-container"
              v-if="order.comment!=null && order.comment.trim().length!=0 && !hideDetails"
            >
              <span class="note-title">{{labels.tableOpenings.noteOfOrders[language]}}</span>
              <span class="order-note-content">{{order.comment}}</span>
            </div>
          </div>
          <!-- <div class="order-note-container" v-if="ordersConcatedNote!='' && hideDetails">
            <span class="note-title">{{labels.tableOpenings.noteOfOrders[language]}}</span>
            <span class="order-note-content">{{ordersConcatedNote}}</span>
          </div>-->
        </div>

        <!-------- CLOSE TABLE STATE -------->
        <div v-else-if="stateOfModal=='CLOSE_TABLE_OPENING'" id="modal-content-container">
          <div id="close-table-opening-container">
            <div
              v-if="assignedTablesOnly && waiterOfcurrentUser && waiterOfcurrentUser.ableToViewAllOpenTables && waiterOfcurrentUser.ableToEditOtherOpenTables"
            >
              <h6 class="payment-type-title">Χρήστης που θα χρεωθεί το τραπέζι</h6>
              <select
                v-model="userIdToCloseTable"
                id="room-to-charge-select"
                style="width: 96%"
                :disabled="ongoingModalAction"
                @change="clearErrors()"
              >
                <option
                  v-for="waiter in waiters"
                  :key="waiter.userId"
                  :value="waiter.userId"
                >{{waiter.name}}</option>
              </select>

              <hr style="margin-top:6px; margin-bottom:10px" />
            </div>

            <div
              v-if="amountRemainingToBePaidToFixed !='0.00' &&
                    amountRemainingToBePaidToFixed !='-0.00' "
            >
              <h6 class="total-selected-price-title" style="margin-bottom: 2px !important;">
                {{labels.tableOpenings.remainingToBePaidWholeWord[language]}}
                <span
                  style="color: #007bff;"
                >{{amountRemainingToBePaidToFixed}}€</span>
              </h6>
              <h6 class="payment-type-title">{{labels.payment.paymentType[language]}}</h6>
              <div
                v-if="userCanPartialCashPaid"
                class="payment-option align-center mb-7"
                style="margin-right: 16px;"
              >
                <input
                  @change="onPaymentTypeChange()"
                  class="close-table-payment-type-input"
                  type="radio"
                  value="CASH"
                  :disabled="ongoingModalAction"
                  v-model="paymentType"
                />
                <h6
                  class="close-table-payment"
                  @click="selectPaymentType('CASH')"
                  :class="{'cash-selected-payment' : paymentType=='CASH'}"
                >{{ labels.payment.cash[language] }}</h6>
                <font-awesome-icon
                  class="payment-type-icon"
                  :class="{ greenColor: paymentType == 'CASH' }"
                  icon="money-bill"
                  @click="selectPaymentType('CASH')"
                />
              </div>
              <div v-if="userCanPartialCardPaid" class="payment-option align-center mb-7">
                <input
                  @change="onPaymentTypeChange()"
                  class="close-table-payment-type-input"
                  type="radio"
                  value="CARD_TERMINAL"
                  v-model="paymentType"
                  :disabled="ongoingModalAction"
                />
                <h6
                  class="close-table-payment"
                  @click="selectPaymentType('CARD_TERMINAL')"
                  :class="{'card-selected-payment' : paymentType=='CARD_TERMINAL'}"
                >{{ labels.payment.cardAtTheStore[language]}}</h6>
                <font-awesome-icon
                  class="payment-type-icon"
                  :class="{ cardTerminalColor: paymentType == 'CARD_TERMINAL' }"
                  icon="credit-card"
                  @click="selectPaymentType('CARD_TERMINAL')"
                />
              </div>
              <div
                v-if="tableOpening.restaurant.publishesReceipts && userCanBePaidByBank"
                class="payment-option align-center mb-7"
                style="margin-right: 16px;"
              >
                <input
                  @change="onPaymentTypeChange()"
                  class="close-table-payment-type-input"
                  type="radio"
                  value="BANK_ACCOUNT"
                  v-model="paymentType"
                  :disabled="ongoingModalAction"
                />
                <h6
                  class="close-table-payment"
                  @click="selectPaymentType('BANK_ACCOUNT')"
                  :class="{'bank-account-selected-payment' : paymentType=='BANK_ACCOUNT'}"
                >{{ labels.payment.bankAccount[language] }}</h6>
                <font-awesome-icon
                  class="payment-type-icon"
                  style="height:14px; margin-top:0px"
                  :class="{ bankAccountColor: paymentType == 'BANK_ACCOUNT' }"
                  icon="store-alt"
                  @click="selectPaymentType('BANK_ACCOUNT')"
                />
              </div>
              <div
                class="payment-option align-center mb-7"
                v-if="!tableOpening.restaurant.publishesReceipts"
              >
                <input
                  @change="onPaymentTypeChange()"
                  class="close-table-payment-type-input"
                  type="radio"
                  value="CASH_AND_CARD_TERMINAL"
                  v-model="paymentType"
                  :disabled="ongoingModalAction"
                />
                <h6
                  class="close-table-payment"
                  @click="selectPaymentType('CASH_AND_CARD_TERMINAL')"
                  :class="{'cash-and-card-selected-payment' : paymentType=='CASH_AND_CARD_TERMINAL'}"
                >{{ labels.payment.cashAndCard[language]}}</h6>
              </div>

              <div
                class="payment-option align-center mb-7"
                v-if="hotelRooms.length>0 && tableOpening.table.type!='HOTEL_ROOM'"
              >
                <input
                  @change="onPaymentTypeChange()"
                  class="close-table-payment-type-input"
                  type="radio"
                  value="ROOM_CHARGE"
                  :disabled="ongoingModalAction"
                  v-model="paymentType"
                />
                <h6
                  class="close-table-payment"
                  :class="{'room-charge-selected-payment' : paymentType=='ROOM_CHARGE'}"
                  @click="selectPaymentType('ROOM_CHARGE')"
                >{{ labels.payment.chargeAtRoom[language]}}</h6>
              </div>

              <div v-if="paymentType == 'CASH_AND_CARD_TERMINAL'">
                <h6
                  class="amount-paid-by-title"
                >{{labels.tableOpenings.amoutToBePaidViaCash[language]}}</h6>
                <input
                  type="number"
                  class="payed-by-input"
                  v-model="amountPayedByCash"
                  @change="typeCashAmount()"
                  @keypress.enter="closeTable()"
                />

                <h6
                  class="amount-paid-by-title"
                >{{labels.tableOpenings.amoutToBePaidViaCard[language]}}</h6>
                <input
                  type="number"
                  class="payed-by-input"
                  style="margin-bottom: 10px;"
                  v-model="amountPayedByCard"
                  @change="typeCardAmount()"
                  @keypress.enter="closeTable()"
                />
              </div>

              <div v-if="paymentType=='ROOM_CHARGE'">
                <h6 class="payment-type-title">{{labels.tableOpenings.chooseChargingRoom[language]}}</h6>
                <select
                  v-model="selectedRoomIdToChargeOnClose"
                  id="room-to-charge-select"
                  :disabled="ongoingModalAction"
                  @click="clearErrors()"
                >
                  <option
                    v-for="hotelRoom in hotelRooms"
                    :key="hotelRoom.id"
                    :value="hotelRoom.id"
                  >{{hotelRoom.tableNumber}}</option>
                </select>
              </div>

              <div v-if="paymentType=='CASH'">
                <hr style="margin-top:6px; margin-bottom:10px" />

                <div id="received-amount-input-container">
                  <h6 id="received-amount-header" style="margin-bottom: 0px">Ποσό είσπραξης</h6>
                  <input
                    id="change-input"
                    style="margin-bottom: 0px"
                    @input="adjustChangeToBeGiven()"
                    v-model="amountReceived"
                    :disabled="ongoingModalAction"
                    type="number"
                    placeholder="πχ 10€"
                  />
                </div>

                <div id="change-amount-input-container" style="align-items: center">
                  <h6 id="change-header" style="margin-bottom: 0px">Ρέστα: {{changeToBeGiven}}</h6>
                </div>
              </div>

              <div
                v-if="paymentType!='CASH_AND_CARD_TERMINAL' && paymentType!='ROOM_CHARGE' && userCanDiscount"
              >
                <hr style="margin-top:6px; margin-bottom:10px" />

                <div v-if="typeOfDiscount=='PERCENTAGE'" id="pda-discount-input-container">
                  <h6 class="payment-type-title" style="margin-bottom: 0px">Έκπτωση %</h6>
                  <input
                    id="pda-discount-input"
                    style="margin-bottom: 0px"
                    @input="adjustFinalPriceAfterDiscount()"
                    v-model="closeTableDiscount"
                    type="number"
                    :disabled="ongoingModalAction"
                    placeholder="πχ 10%"
                  />
                </div>

                <h6
                  v-if="typeOfDiscount=='PERCENTAGE' && closeTableDiscount>0 && finalPriceAfterDiscount!=null && finalPriceAfterDiscount!=undefined"
                  id="pda-discount-header"
                >Τελική τιμή: {{finalPriceAfterDiscount}}€</h6>

                <h6
                  v-if="typeOfDiscount=='FINAL_PRICE'"
                  class="payment-type-title"
                  style="margin-bottom:0px"
                >Έκπτωση</h6>
                <div v-if="typeOfDiscount=='FINAL_PRICE'" id="pda-discount-input-container">
                  <h6 id="pda-discount-header" style="margin-bottom: 0px">Τελική τιμή:</h6>
                  <input
                    id="pda-discount-input"
                    style="margin-bottom: 0px"
                    @input="adjustCloseTableDiscount()"
                    v-model="finalPriceAfterDiscount"
                    :disabled="ongoingModalAction"
                    type="number"
                    placeholder="πχ 3€"
                  />
                </div>

                <div id="pda-discount-options">
                  <div
                    class="pda-discount-option"
                    @click="selectDiscountType('PERCENTAGE')"
                    style="margin-right: 12px;"
                  >
                    <input
                      class="pda-discount-type-input"
                      type="radio"
                      value="PERCENTAGE"
                      :disabled="ongoingModalAction"
                      v-model="typeOfDiscount"
                    />
                    <h6 class="pda-discount-option-title">Ποσοστό</h6>
                  </div>
                  <div class="pda-discount-option" @click="selectDiscountType('FINAL_PRICE')">
                    <input
                      class="pda-discount-type-input"
                      type="radio"
                      value="FINAL_PRICE"
                      :disabled="ongoingModalAction"
                      v-model="typeOfDiscount"
                    />
                    <h6 class="pda-discount-option-title">Τελική τιμή</h6>
                  </div>
                </div>

                <h6
                  v-if="typeOfDiscount=='FINAL_PRICE'"
                  style="display: inline-block; font-size: 13px"
                  class="mb-2 alert alert-secondary pl-1 pt-1 pb-1"
                >*ΠΡΟΣΟΧΗ* Γράψτε την τελική τιμή που θα έχει το τραπέζι μετά την έκπτωση</h6>
              </div>

              <div
                v-if="((amountPendingReceipt + totalPriceOfOpenTempReceipts > 0) || (amountPendingReceipt + totalPriceOfOpenTempReceipts <= 0 && tableOpening.minimumConsumption>0 && amountRemainingToBePaidToFixed !='0.00' && amountRemainingToBePaidToFixed !='-0.00')) && (paymentType=='CASH' || paymentType=='BANK_ACCOUNT' || (paymentType=='CARD_TERMINAL' && cardTerminals.length==0)) && ((finalPriceAfterDiscount!=0) || (finalPriceAfterDiscount=='' && closeTableDiscount==null)) && tableOpening.restaurant.publishesReceipts && userCanPublishReceipts"
              >
                <hr style="margin-top:6px; margin-bottom:10px" />
                <h6 class="payment-type-title">Να βγεί και η τελική απόδειξη μαζί;</h6>
                <div
                  class="payment-option"
                  v-if="paymentType=='CASH' && (remainingOpenTempReceipts.length==0 || (remainingOpenTempReceipts.length>0 && tableOpening.restaurant.canSkipFinalReceipt)) && !userPublishesReceiptAlways"
                >
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="NO_RECEIPT_AFTER_CLOSE"
                    v-model="typeOfReceiptAfterClose"
                    :disabled="ongoingModalAction"
                  />
                  <h6
                    @click="selectTypeOfReceiptAfterClose('NO_RECEIPT_AFTER_CLOSE')"
                  >Χωρίς απόδειξη</h6>
                </div>

                <div
                  class="payment-option"
                  v-if="(paymentType=='BANK_ACCOUNT' || (paymentType=='CARD_TERMINAL' && cardTerminals.length==0)) && tableOpening.restaurant.canPayCardWithoutReceipt && !userPublishesReceiptAlways"
                >
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="NO_RECEIPT_AFTER_CLOSE"
                    :disabled="ongoingModalAction"
                    v-model="typeOfReceiptAfterClose"
                  />
                  <h6
                    @click="selectTypeOfReceiptAfterClose('NO_RECEIPT_AFTER_CLOSE')"
                  >Χωρίς απόδειξη</h6>
                </div>

                <div
                  class="payment-option"
                  v-if="tableOpening.table.type=='HOTEL_ROOM' || tableOpening.table.supportsOnCreditPayment"
                >
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="RECEIPT_FOR_NON_PUBLISHED"
                    :disabled="ongoingModalAction"
                    v-model="typeOfReceiptAfterClose"
                  />
                  <h6
                    @click="selectTypeOfReceiptAfterClose('RECEIPT_FOR_NON_PUBLISHED')"
                  >Απόδειξη για τα προϊόντα που δεν έχει εκδοθεί προηγουμένως παραστατικό</h6>
                </div>

                <div
                  class="payment-option"
                  v-if="userPublishesReceiptAlways && tableOpening.table.type!='HOTEL_ROOM' && !tableOpening.table.supportsOnCreditPayment"
                >
                  <input
                    v-if="amountRemainingToBePaid < (amountPendingReceipt + totalPriceOfOpenTempReceipts)"
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    :disabled="ongoingModalAction"
                    value="RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID"
                    v-model="typeOfReceiptAfterClose"
                  />

                  <input
                    v-else
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="RECEIPT_FOR_ALL_REMAINING"
                    :disabled="ongoingModalAction"
                    v-model="typeOfReceiptAfterClose"
                  />

                  <h6
                    @click="selectTypeOfReceiptAfterClose(amountRemainingToBePaid < (amountPendingReceipt + totalPriceOfOpenTempReceipts) ? 'RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID' : 'RECEIPT_FOR_ALL_REMAINING')"
                  >
                    Απόδειξη για ότι απομένει προς πληρωμή
                    <span
                      v-if="closeTableDiscount==null || closeTableDiscount==0"
                      style="color:#016ee3; font-weight:600"
                    >{{amountRemainingToBePaidToFixed}}€</span>
                  </h6>
                </div>

                <div
                  class="payment-option"
                  v-if="amountRemainingToBePaid<(amountPendingReceipt + totalPriceOfOpenTempReceipts) && tableOpening.table.type!='HOTEL_ROOM' && !tableOpening.table.supportsOnCreditPayment && !userPublishesReceiptAlways"
                >
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    :disabled="ongoingModalAction"
                    value="RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID"
                    v-model="typeOfReceiptAfterClose"
                  />
                  <h6
                    @click="selectTypeOfReceiptAfterClose('RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID')"
                  >
                    Απόδειξη για ότι απομένει προς πληρωμή
                    <span
                      v-if="closeTableDiscount==null || closeTableDiscount==0"
                      style="color:#016ee3; font-weight:600"
                    >{{amountRemainingToBePaidToFixed}}€</span>
                  </h6>
                </div>

                <div
                  class="payment-option"
                  v-if="tableOpening.table.type!='HOTEL_ROOM' && !tableOpening.table.supportsOnCreditPayment && !userPublishesReceiptAlways"
                >
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="RECEIPT_FOR_ALL_REMAINING"
                    :disabled="ongoingModalAction"
                    v-model="typeOfReceiptAfterClose"
                  />
                  <h6 @click="selectTypeOfReceiptAfterClose('RECEIPT_FOR_ALL_REMAINING')">
                    {{amountRemainingToBePaid<(amountPendingReceipt + totalPriceOfOpenTempReceipts) ? 'Απόδειξη για όλα, μαζί με αυτά που έχετε κλείσει και δεν εκδώσατε απόδειξη' : 'Απόδειξη για ότι απομένει προς πληρωμή'}}
                    <span
                      v-if="closeTableDiscount==null || closeTableDiscount==0"
                      style="color:#016ee3; font-weight:600"
                    >{{(amountRemainingToBePaid<(amountPendingReceipt + totalPriceOfOpenTempReceipts)) ? (amountPendingReceipt + totalPriceOfOpenTempReceipts).toFixed(2) : amountRemainingToBePaidToFixed}}€</span>
                  </h6>
                </div>

                <div
                  v-if="remainingOpenTempReceipts.length>0 && tableOpening.table.type!='HOTEL_ROOM' && !tableOpening.table.supportsOnCreditPayment && !restaurantsThatDontSupportReceiptOnlyForOpen.includes(tableOpening.restaurant.id) && !userPublishesReceiptAlways"
                  class="payment-option"
                >
                  <input
                    class="input"
                    type="radio"
                    value="RECEIPT_ONLY_FOR_OPEN"
                    v-model="typeOfReceiptAfterClose"
                    :disabled="ongoingModalAction"
                    @change="clearErrors()"
                  />
                  <h6 @click="selectTypeOfReceiptAfterClose('RECEIPT_ONLY_FOR_OPEN')">
                    Απόδειξη μόνο για τις ανοιχτές προσωρινές αποδείξεις
                    <span
                      v-if="closeTableDiscount==null || closeTableDiscount==0"
                      style="color:#016ee3; font-weight:600"
                    >{{totalPriceOfOpenTempReceipts.toFixed(2)}}€</span>
                  </h6>
                </div>
              </div>

              <div
                v-if="(amountPendingReceipt + totalPriceOfOpenTempReceipts > 0) && paymentType=='ROOM_CHARGE' && tableOpening.restaurant.publishesReceipts && userCanPublishReceipts"
              >
                <hr style="margin-top:6px; margin-bottom:10px" />
                <h6 class="payment-type-title">Να βγεί και απόδειξη επί πιστώσει;</h6>
                <div
                  class="payment-option"
                  v-if="!tableOpening.restaurant.hotelizerIntegrationEnabled || (tableOpening.restaurant.hotelizerIntegrationEnabled && tableOpening.restaurant.hotelizerReceipt!='ON_CREDIT')"
                >
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="NO_RECEIPT_AFTER_CLOSE"
                    :disabled="ongoingModalAction"
                    v-model="typeOfReceiptAfterClose"
                  />
                  <h6
                    @click="selectTypeOfReceiptAfterClose('NO_RECEIPT_AFTER_CLOSE')"
                  >Χωρίς απόδειξη</h6>
                </div>

                <div
                  class="payment-option"
                  v-if="!tableOpening.restaurant.hotelizerIntegrationEnabled || (tableOpening.restaurant.hotelizerIntegrationEnabled && tableOpening.restaurant.hotelizerReceipt!='NO_RECEIPT')"
                >
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID"
                    :disabled="ongoingModalAction"
                    v-model="typeOfReceiptAfterClose"
                  />
                  <h6
                    @click="selectTypeOfReceiptAfterClose('RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID')"
                  >Απόδειξη επί πιστώσει. Θα επισυναπτεί στο δωμάτιο χρέωσης</h6>
                </div>
              </div>

              <div
                v-if="paymentType=='CARD_TERMINAL' && (amountPendingReceipt + totalPriceOfOpenTempReceipts > 0 || (amountPendingReceipt + totalPriceOfOpenTempReceipts <= 0 && tableOpening.minimumConsumption>0 && amountRemainingToBePaidToFixed !='0.00' && amountRemainingToBePaidToFixed !='-0.00') || tableOpening.table.type=='HOTEL_ROOM' || tableOpening.table.supportsOnCreditPayment) && ((finalPriceAfterDiscount!=0) || (finalPriceAfterDiscount=='' && closeTableDiscount==null)) && cardTerminals.length>0 && userCanPublishReceipts"
              >
                <hr style="margin-top:6px; margin-bottom:10px" />
                <h6 class="payment-type-title">Επιλέξτε τερματικό κάρτας</h6>
                <div
                  v-for="cardTerminal in cardTerminals"
                  :key="cardTerminal.id"
                  class="payment-option"
                  style="margin-right: 16px;"
                >
                  <input
                    class="input"
                    type="radio"
                    :value="cardTerminal.id"
                    :disabled="ongoingModalAction"
                    @change="onSelectCardTerminal()"
                    v-model="selectedCardTerminal"
                  />
                  <h6
                    @click="selectCardTerminalOnTableClose(cardTerminal.id)"
                  >{{ cardTerminal.friendlyName }}</h6>
                </div>

                <div
                  v-if="tableOpening.restaurant.canPayCardWithoutReceipt"
                  class="payment-option"
                  style="margin-right: 16px;"
                >
                  <input
                    class="input"
                    type="radio"
                    value="JUST_MARK_PAID"
                    @change="onSelectCardTerminal()"
                    v-model="selectedCardTerminal"
                  />
                  <h6
                    @click="selectCardTerminalOnTableClose('JUST_MARK_PAID')"
                  >Απλά μαρκάρισμα ότι πληρώθηκαν με κάρτα (Χωρίς απόδειξη)</h6>
                </div>
              </div>

              <div
                v-if="paymentType=='CARD_TERMINAL' && ((finalPriceAfterDiscount!=0) || (finalPriceAfterDiscount=='' && closeTableDiscount==null)) && ((amountPendingReceipt + totalPriceOfOpenTempReceipts > 0) || tableOpening.table.type=='HOTEL_ROOM' || tableOpening.table.supportsOnCreditPayment) && cardTerminals.length>0 && selectedCardTerminal!='JUST_MARK_PAID' && selectedCardTerminal!=null"
              >
                <!-- <h6
                  v-if="tableOpening.table.type!='HOTEL_ROOM'"
                  class="payment-type-title"
                >Επιλέξτε ποσό πληρωμής προς τερματικό</h6>
                <select
                  v-if="tableOpening.table.type!='HOTEL_ROOM'"
                  v-model="amountToBeChargedToPosOnTableClose"
                  id="room-to-charge-select"
                  style="width: 96%"
                  @change="clearErrors()"
                >
                  <option
                    v-if="amountRemainingToBePaid<(amountPendingReceipt + totalPriceOfOpenTempReceipts)"
                    value="RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID"
                  >{{closeTableDiscount==null || closeTableDiscount==0 ? amountRemainingToBePaidToFixed +'€ | Ότι απομένει προς πληρωμή' : 'Ότι απομένει προς πληρωμή'}}</option>

                  <option
                    value="RECEIPT_FOR_ALL_REMAINING"
                    v-if="closeTableDiscount==null || closeTableDiscount==0"
                  >{{(amountRemainingToBePaid<(amountPendingReceipt + totalPriceOfOpenTempReceipts)) ? (amountPendingReceipt + totalPriceOfOpenTempReceipts).toFixed(2) : amountRemainingToBePaidToFixed}}€ | {{amountRemainingToBePaid<(amountPendingReceipt + totalPriceOfOpenTempReceipts) ? 'Όλα, μαζί αυτά που κλείσατε και δεν εκδώσατε απόδειξη' : 'Ότι απομένει προς πληρωμή'}}</option>
                  <option
                    value="RECEIPT_FOR_ALL_REMAINING"
                    v-else
                  >{{amountRemainingToBePaid<(amountPendingReceipt + totalPriceOfOpenTempReceipts) ? 'Όλα, μαζί αυτά που κλείσατε και δεν εκδώσατε απόδειξη' : 'Ότι απομένει προς πληρωμή'}}</option>

                  <option
                    v-if="remainingOpenTempReceipts.length>0 && !restaurantsThatDontSupportReceiptOnlyForOpen.includes(tableOpening.restaurant.id)"
                    value="RECEIPT_ONLY_FOR_OPEN"
                  >{{closeTableDiscount==null || closeTableDiscount==0 ? totalPriceOfOpenTempReceipts.toFixed(2) +'€ | Μόνο για τις ανοικτές προσωρινές' : 'Μόνο για τις ανοικτές προσωρινές'}}</option>
                </select>-->

                <!-- <h6
                  v-if="tableOpening.table.type=='HOTEL_ROOM' || tableOpening.table.supportsOnCreditPayment"
                  class="payment-type-title"
                >Ποσό πληρωμής προς τερματικό</h6>
                <select
                  v-if="tableOpening.table.type=='HOTEL_ROOM' || tableOpening.table.supportsOnCreditPayment"
                  v-model="amountToBeChargedToPosOnTableClose"
                  id="room-to-charge-select"
                  style="width: 96%"
                  @change="clearErrors()"
                >
                  <option
                    value="REMAINING_AMOUNT_TO_TERMINAL_AND_RECEIPT_FOR_NON_PUBLISHED"
                  >{{amountRemainingToBePaidToFixed}}€</option>
                </select>-->

                <div id="tip-input-on-close-container">
                  <h6 class="payment-type-title" style="margin-bottom: 0px">Tip</h6>
                  <input
                    id="card-tip-input"
                    style="margin-bottom: 0px"
                    @input="adjustFinalPriceAfterDiscount()"
                    v-model="cardTip"
                    type="number"
                    :disabled="ongoingModalAction"
                    placeholder="πχ 2€"
                  />
                </div>

                <div
                  class="payment-option"
                  style="margin-right: 16px; margin-top:12px; margin-bottom:10px; align-items:center"
                >
                  <label class="switch" style="margin-left: 0px; margin-top: 0px;">
                    <input type="checkbox" :disabled="ongoingModalAction" v-model="irisPayment" />
                    <span class="slider round"></span>
                  </label>
                  <img
                    v-if="irisPayment"
                    class="iris-logo"
                    @click="toggleIrisPayment()"
                    src="../assets/images/logo-iris.png"
                    alt
                  />
                  <img
                    v-else
                    class="iris-logo"
                    @click="toggleIrisPayment()"
                    src="../assets/images/logo-iris-bw.png"
                    alt
                  />
                </div>
              </div>

              <div
                v-if="tableOpening.restaurant.publishesReceipts && ((finalPriceAfterDiscount!=0) || (finalPriceAfterDiscount=='' && closeTableDiscount==null)) && (((amountPendingReceipt + totalPriceOfOpenTempReceipts > 0) && (paymentType=='CASH' || paymentType=='BANK_ACCOUNT' || (paymentType=='CARD_TERMINAL' && cardTerminals.length==0)) && typeOfReceiptAfterClose!=null && typeOfReceiptAfterClose!='NO_RECEIPT_AFTER_CLOSE') || (paymentType=='CARD_TERMINAL' && (amountPendingReceipt + totalPriceOfOpenTempReceipts > 0) && cardTerminals.length>0 && selectedCardTerminal!='JUST_MARK_PAID' && selectedCardTerminal!=null))"
              >
                <hr style="margin-top:6px; margin-bottom:10px" />
                <h6
                  class="payment-type-title"
                  style="margin-bottom:0px !important"
                >Είδος παραστατικού</h6>
                <h6
                  class="payment-type-title"
                  v-if="tableOpening.table.type=='HOTEL_ROOM' || tableOpening.table.supportsOnCreditPayment"
                >*ΠΡΟΣΟΧΗ* αφορά τα προϊόντα που δεν έχει εκδοθεί παραστατικό νωρίτερα</h6>
                <div class="payment-option">
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="RECEIPT"
                    :disabled="ongoingModalAction"
                    v-model="receiptOrIvoiceType"
                  />
                  <h6 @click="selectReceiptOrInvoice('RECEIPT')">Aπόδειξη</h6>
                </div>
                <div class="payment-option">
                  <input
                    class="input"
                    type="radio"
                    @change="clearErrors()"
                    value="INVOICE"
                    :disabled="ongoingModalAction"
                    v-model="receiptOrIvoiceType"
                  />
                  <h6 @click="selectReceiptOrInvoice('INVOICE')">Τιμολόγιο</h6>
                </div>
              </div>

              <div
                v-if="tableOpening.restaurant.publishesReceipts && receiptOrIvoiceType=='INVOICE' && (((amountPendingReceipt + totalPriceOfOpenTempReceipts > 0) && (paymentType=='CASH' || paymentType=='BANK_ACCOUNT' || (paymentType=='CARD_TERMINAL' && cardTerminals.length==0)) && typeOfReceiptAfterClose!=null && typeOfReceiptAfterClose!='NO_RECEIPT_AFTER_CLOSE') || (paymentType=='CARD_TERMINAL' && (amountPendingReceipt + totalPriceOfOpenTempReceipts > 0) && cardTerminals.length>0 && selectedCardTerminal!='JUST_MARK_PAID' && selectedCardTerminal!=null))"
                id="invoice-info-container"
              >
                <h6 class="invoice-info-title">Χώρα</h6>
                <select
                  id="invoice-country-selectw"
                  class="invoice-info-input"
                  style="height: 30px"
                  v-model="invoiceCountry"
                  @change="clearErrors()"
                >
                  <option value="GR">Ελλάδα</option>
                  <option value="AL">Αλβανία</option>
                  <option value="AD">Ανδόρα</option>
                  <option value="AT">Αυστρία</option>
                  <option value="VA">Βατικανό</option>
                  <option value="BE">Βέλγιο</option>
                  <option value="MK">Βόρεια Μακεδονία</option>
                  <option value="BA">Βοσνία και Ερζεγοβίνη</option>
                  <option value="BG">Βουλγαρία</option>
                  <option value="FR">Γαλλία</option>
                  <option value="DE">Γερμανία</option>
                  <option value="DK">Δανία</option>
                  <option value="CH">Ελβετία</option>
                  <option value="EE">Εσθονία</option>
                  <option value="GB">Ηνωμένο Βασίλειο</option>
                  <option value="US">ΗΠΑ (Αμερική)</option>
                  <option value="IE">Ιρλανδία</option>
                  <option value="IS">Ισλανδία</option>
                  <option value="ES">Ισπανία</option>
                  <option value="IT">Ιταλία</option>
                  <option value="HR">Κροατία</option>
                  <option value="CY">Κύπρος</option>
                  <option value="LV">Λετονία</option>
                  <option value="BY">Λευκορωσία</option>
                  <option value="LT">Λιθουανία</option>
                  <option value="LI">Λιχτενστάιν</option>
                  <option value="LU">Λουξεμβούργο</option>
                  <option value="MT">Μάλτα</option>
                  <option value="MD">Μολδαβία</option>
                  <option value="MC">Μονακό</option>
                  <option value="ME">Μαυροβούνιο</option>
                  <option value="NO">Νορβηγία</option>
                  <option value="NL">Ολλανδία</option>
                  <option value="HU">Ουγγαρία</option>
                  <option value="UA">Ουκρανία</option>
                  <option value="PL">Πολωνία</option>
                  <option value="PT">Πορτογαλία</option>
                  <option value="RO">Ρουμανία</option>
                  <option value="RU">Ρωσία</option>
                  <option value="SM">Άγιος Μαρίνος</option>
                  <option value="RS">Σερβία</option>
                  <option value="SK">Σλοβακία</option>
                  <option value="SI">Σλοβενία</option>
                  <option value="SE">Σουηδία</option>
                  <option value="CZ">Τσεχία</option>
                  <option value="TR">Τουρκία</option>
                  <option value="FI">Φινλανδία</option>
                </select>
                <h6 class="invoice-info-title">ΑΦΜ</h6>
                <div class="invoice-search-container">
                  <input class="invoice-info-input" @input="clearErrors()" v-model="vat" />
                  <button
                    v-if="invoiceCountry=='GR' || invoiceCountry==null"
                    class="action-button"
                    id="search-company-button"
                    @click="searchCompanyByVat()"
                  >
                    <clip-loader
                      v-if="ongoingModalAction"
                      :loading="ongoingModalAction"
                      size="17px"
                      color="#ffffff"
                    />
                    <font-awesome-icon v-else id="icon" icon="search" />
                  </button>
                </div>

                <h6 class="invoice-info-title">Επωνυμία εταιρείας</h6>
                <input
                  class="invoice-info-input"
                  :disabled="ongoingModalAction"
                  @input="clearErrors()"
                  v-model="companyName"
                />

                <h6 class="invoice-info-title">Οδός με αριθμό μαζί</h6>
                <input
                  :disabled="ongoingModalAction"
                  class="invoice-info-input"
                  @input="clearErrors()"
                  v-model="address"
                />

                <h6 class="invoice-info-title">Πόλη</h6>
                <input
                  :disabled="ongoingModalAction"
                  class="invoice-info-input"
                  @input="clearErrors()"
                  v-model="city"
                />

                <h6 class="invoice-info-title">Τ.Κ.</h6>
                <input
                  :disabled="ongoingModalAction"
                  class="invoice-info-input"
                  @input="clearErrors()"
                  v-model="postalCode"
                />

                <h6 :disabled="ongoingModalAction" class="invoice-info-title">Προαιρετικά σχόλια</h6>
                <input class="invoice-info-input" @input="clearErrors()" v-model="invoiceComments" />
              </div>
            </div>
            <button
              class="action-button"
              id="close-table-opening-button"
              style="margin-right: 0px !important; margin-top: 20px;"
              @click="closeTable()"
            >
              <clip-loader :loading="ongoingModalAction" size="18px" color="#ffffff" />
              {{ongoingModalAction ? '' : labels.tableOpenings.closeTableWholeGreekWord[language]}}
            </button>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>
        </div>

        <!-------- TRANSFER TABLE STATE -------->
        <div v-else-if="stateOfModal=='TRANSFER_ORDERS_OF_TABLE'" id="modal-content-container">
          <div id="transfer-table-opening-container">
            <h5 v-if="selectedOrderProducts.length > 0" class="total-selected-price-title">
              {{labels.tableOpenings.totalOfSelectedItems[language]}}
              <span
                style="color: #007bff;"
              >{{priceOfSelectedItems.toFixed(2)}}€</span>
            </h5>
            <h6 class="payment-type-title">{{labels.tableOpenings.chooseDepartment[language]}}</h6>
            <select
              v-model="selectedRestaurantIdToTranferTable"
              @change="selectRestaurantToTransfer()"
            >
              <option
                v-for="restaurant in restaurantsWithTableOpenings"
                :key="restaurant.id"
                :value="restaurant.id"
              >{{restaurant.names.translation[language].name }}</option>
            </select>

            <h6
              class="payment-type-title"
              v-if="sections && sections.length>0"
            >{{labels.tableOpenings.areaSection[language]}}</h6>
            <select
              class="no-bottom-margin"
              v-if="sections && sections.length>0"
              v-model="selectedSection"
              @change="onSectionChange()"
            >
              <option value="ALL">Όλα</option>
              <option v-for="(section, index) in sections" :key="index" :value="section">{{section}}</option>
              <option :value="null">Υπόλοιπα</option>
            </select>

            <h6
              class="payment-type-title"
            >{{this.tableOpening.table.type=='HOTEL_ROOM' ? labels.tableOpenings.chooseTransferRoom[language] : labels.tableOpenings.chooseTransferTable[language] }}</h6>
            <select v-model="selectedTableIdToTrasfer" @click="selectTableToTransfer()">
              <option
                v-for="table in allTablesOfRestaurant"
                :key="table.id"
                :value="table.id"
              >{{table.tableNumber}}</option>
            </select>

            <button
              class="action-button"
              id="transfer-table-opening-button"
              style="margin-right: 0px !important; margin-top: 10px;"
              :disabled="ongoingModalAction"
              @click="transferTable()"
            >
              <clip-loader :loading="ongoingModalAction" size="18px" color="#ffffff" />
              {{ongoingModalAction ? '' : selectedOrderProducts.length > 0 ? labels.tableOpenings.transferSelectedItems[language] : labels.tableOpenings.transferTableWholeWord[language]}}
            </button>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>
        </div>

        <!-------- CARD TERMINAL STATE -------->
        <div v-else-if="stateOfModal=='CARD_TERMINAL_SELECTION'" id="modal-content-container">
          <div id="transfer-table-opening-container">
            <h5 v-if="selectedOrderProducts.length > 0" class="total-selected-price-title">
              {{labels.tableOpenings.totalOfSelectedItems[language]}}
              <span
                style="color: #007bff;"
              >{{priceOfSelectedItems.toFixed(2)}}€</span>
            </h5>
            <h5
              v-else-if="selectedOrderProductsForReceipt.length > 0"
              class="total-selected-price-title"
            >
              {{labels.tableOpenings.totalOfSelectedItems[language]}}
              <span
                style="color: #007bff;"
              >{{priceOfSelectedItemsForReceipt.toFixed(2)}}€</span>
            </h5>
            <h5 v-else-if="selectedTempReceipts.length > 0" class="total-selected-price-title">
              {{labels.tableOpenings.totalOfSelectedItems[language]}}
              <span
                style="color: #007bff;"
              >{{totalAmountOfSelectedTempReceipts.toFixed(2)}}€</span>
            </h5>
            <h5 v-else-if="selectedOnCreditReceipt != null" class="total-selected-price-title">
              {{labels.tableOpenings.totalOfSelectedItems[language]}}
              <span
                style="color: #007bff;"
              >{{calculateTotalOfReceipt(selectedOnCreditReceipt.items)}}€</span>
            </h5>

            <div v-if="selectedOrderProducts.length > 0 && userCanDiscount">
              <div v-if="typeOfDiscount=='PERCENTAGE'" id="pda-discount-input-container">
                <h6 class="payment-type-title" style="margin-bottom: 0px">Έκπτωση %</h6>
                <input
                  id="pda-discount-input"
                  style="margin-bottom: 0px"
                  @input="adjustPriceOfSelectedProductsAfterDiscount()"
                  v-model="selectedProductsDiscount"
                  type="number"
                  placeholder="πχ 10%"
                />
              </div>

              <h6
                v-if="typeOfDiscount=='PERCENTAGE' && selectedProductsDiscount>0 && priceOfSelectedProductsAfterDiscount!=null && priceOfSelectedProductsAfterDiscount!=undefined"
                id="pda-discount-header"
              >Τελική τιμή: {{priceOfSelectedProductsAfterDiscount}}€</h6>

              <h6
                v-if="typeOfDiscount=='FINAL_PRICE'"
                class="payment-type-title"
                style="margin-bottom:0px"
              >Έκπτωση</h6>
              <div v-if="typeOfDiscount=='FINAL_PRICE'" id="pda-discount-input-container">
                <h6 id="pda-discount-header" style="margin-bottom: 0px">Τελική τιμή:</h6>
                <input
                  id="pda-discount-input"
                  style="margin-bottom: 0px"
                  @input="adjustDiscountForSelectedProducts()"
                  v-model="priceOfSelectedProductsAfterDiscount"
                  type="number"
                  placeholder="πχ 3€"
                />
              </div>

              <div id="pda-discount-options">
                <div
                  class="pda-discount-option"
                  @click="selectDiscountType('PERCENTAGE')"
                  style="margin-right: 12px;"
                >
                  <input
                    class="pda-discount-type-input"
                    type="radio"
                    value="PERCENTAGE"
                    v-model="typeOfDiscount"
                  />
                  <h6 class="pda-discount-option-title">Ποσοστό</h6>
                </div>
                <div class="pda-discount-option" @click="selectDiscountType('FINAL_PRICE')">
                  <input
                    class="pda-discount-type-input"
                    type="radio"
                    value="FINAL_PRICE"
                    v-model="typeOfDiscount"
                  />
                  <h6 class="pda-discount-option-title">Τελική τιμή</h6>
                </div>
              </div>

              <h6
                v-if="typeOfDiscount=='FINAL_PRICE'"
                style="display: inline-block; font-size: 13px"
                class="mb-2 alert alert-secondary pl-1 pt-1 pb-1"
              >*ΠΡΟΣΟΧΗ* Γράψτε την τελική τιμή για τα επιλεγμένα προϊόντα μετά την έκπτωση</h6>

              <hr style="margin-top:6px; margin-bottom:10px" />
            </div>

            <div
              v-if="((priceOfSelectedProductsAfterDiscount!=0) || (priceOfSelectedProductsAfterDiscount=='' && selectedProductsDiscount==null))"
            >
              <h6 class="payment-type-title">Επιλέξτε τερματικό κάρτας</h6>
              <div
                v-for="cardTerminal in cardTerminals"
                :key="cardTerminal.id"
                class="payment-option"
                style="margin-right: 16px;"
              >
                <input
                  class="input"
                  type="radio"
                  :value="cardTerminal.id"
                  @change="clearErrors()"
                  v-model="selectedCardTerminal"
                />
                <h6 @click="selectCardTerminal(cardTerminal.id)">{{ cardTerminal.friendlyName }}</h6>
              </div>
              <div
                v-if="selectedOrderProducts.length > 0 && tableOpening.restaurant.canPayCardWithoutReceipt"
                class="payment-option"
                style="margin-right: 16px;"
              >
                <input
                  class="input"
                  type="radio"
                  value="JUST_MARK_PAID"
                  @change="clearErrors()"
                  v-model="selectedCardTerminal"
                />
                <h6
                  @click="selectCardTerminal('JUST_MARK_PAID')"
                >Απλά μαρκάρισμα ότι πληρώθηκαν με κάρτα (Χωρίς απόδειξη)</h6>
              </div>
            </div>

            <div
              v-if="selectedCardTerminal!=null && selectedCardTerminal!='JUST_MARK_PAID'"
              id="tip-input-container"
            >
              <h6 class="payment-type-title" style="margin-bottom: 0px">Tip</h6>
              <input
                id="card-tip-input"
                style="margin-bottom: 0px"
                @input="adjustFinalPriceAfterDiscount()"
                v-model="cardTip"
                type="number"
                placeholder="πχ 2€"
              />
            </div>

            <div
              class="payment-option"
              v-if="selectedCardTerminal!=null && selectedCardTerminal!='JUST_MARK_PAID'"
              style="margin-right: 16px; margin-top:8px; margin-bottom:10px; align-items:center"
            >
              <label class="switch" style="margin-left: 0px; margin-top: 0px;">
                <input type="checkbox" v-model="irisPayment" />
                <span class="slider round"></span>
              </label>
              <img
                v-if="irisPayment"
                class="iris-logo"
                @click="toggleIrisPayment()"
                src="../assets/images/logo-iris.png"
                alt
              />
              <img
                v-else
                class="iris-logo"
                @click="toggleIrisPayment()"
                src="../assets/images/logo-iris-bw.png"
                alt
              />
            </div>

            <button
              class="action-button"
              id="card-terminal-send-transaction"
              style="margin-right: 0px !important; margin-top: 10px;"
              @click="publishCardReceiptAfterTerminalSelection()"
            >
              <clip-loader :loading="ongoingModalAction" size="18px" color="#ffffff" />
              {{ongoingModalAction ? '' : ((priceOfSelectedProductsAfterDiscount!=0) || (priceOfSelectedProductsAfterDiscount=='' && selectedProductsDiscount==null)) ? 'Εντολή πληρωμής' : 'Πληρωμή κάρτα'}}
            </button>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>
        </div>

        <!-------- PARTIAL PAY WITH DISCOUNT STATE -------->
        <div v-else-if="stateOfModal=='PARTIAL_PAY_SCREEN'" id="modal-content-container">
          <div id="transfer-table-opening-container">
            <h5 class="total-selected-price-title">
              {{labels.tableOpenings.totalOfSelectedItems[language]}}
              <span
                style="color: #007bff;"
              >{{priceOfSelectedItems.toFixed(2)}}€</span>
            </h5>

            <div v-if="partialPaymentType=='CASH'">
              <div id="received-amount-input-container">
                <h6 id="received-amount-header" style="margin-bottom: 0px">Ποσό είσπραξης</h6>
                <input
                  id="change-input"
                  style="margin-bottom: 0px"
                  @input="adjustChangeToBeGivenOnPartialPayment()"
                  v-model="amountReceived"
                  :disabled="ongoingModalAction"
                  type="number"
                  placeholder="πχ 10€"
                />
              </div>

              <div id="change-amount-input-container" style="align-items: center">
                <h6 id="change-header" style="margin-bottom: 0px">Ρέστα: {{changeToBeGiven}}</h6>
              </div>

              <hr style="margin-top:6px; margin-bottom:6px" />
            </div>

            <div v-if="userCanDiscount">
              <div v-if="typeOfDiscount=='PERCENTAGE'" id="pda-discount-input-container">
                <h6 class="payment-type-title" style="margin-bottom: 0px">Έκπτωση %</h6>
                <input
                  id="pda-discount-input"
                  style="margin-bottom: 0px"
                  @input="adjustPriceOfSelectedProductsAfterDiscount()"
                  v-model="selectedProductsDiscount"
                  type="number"
                  placeholder="πχ 10%"
                />
              </div>

              <h6
                v-if="typeOfDiscount=='PERCENTAGE' && selectedProductsDiscount>0 && priceOfSelectedProductsAfterDiscount!=null && priceOfSelectedProductsAfterDiscount!=undefined"
                id="pda-discount-header"
              >Τελική τιμή: {{priceOfSelectedProductsAfterDiscount}}€</h6>

              <h6
                v-if="typeOfDiscount=='FINAL_PRICE'"
                class="payment-type-title"
                style="margin-bottom:0px"
              >Έκπτωση</h6>
              <div v-if="typeOfDiscount=='FINAL_PRICE'" id="pda-discount-input-container">
                <h6 id="pda-discount-header" style="margin-bottom: 0px">Τελική τιμή:</h6>
                <input
                  id="pda-discount-input"
                  style="margin-bottom: 0px"
                  @input="adjustDiscountForSelectedProducts()"
                  v-model="priceOfSelectedProductsAfterDiscount"
                  type="number"
                  placeholder="πχ 3€"
                />
              </div>

              <div id="pda-discount-options">
                <div
                  class="pda-discount-option"
                  @click="selectDiscountType('PERCENTAGE')"
                  style="margin-right: 12px;"
                >
                  <input
                    class="pda-discount-type-input"
                    type="radio"
                    value="PERCENTAGE"
                    v-model="typeOfDiscount"
                  />
                  <h6 class="pda-discount-option-title">Ποσοστό</h6>
                </div>
                <div class="pda-discount-option" @click="selectDiscountType('FINAL_PRICE')">
                  <input
                    class="pda-discount-type-input"
                    type="radio"
                    value="FINAL_PRICE"
                    v-model="typeOfDiscount"
                  />
                  <h6 class="pda-discount-option-title">Τελική τιμή</h6>
                </div>
              </div>

              <h6
                v-if="typeOfDiscount=='FINAL_PRICE'"
                style="display: inline-block; font-size: 13px"
                class="mb-2 alert alert-secondary pl-1 pt-1 pb-1"
              >*ΠΡΟΣΟΧΗ* Γράψτε την τελική τιμή για τα επιλεγμένα προϊόντα μετά την έκπτωση</h6>

              <hr style="margin-top:6px; margin-bottom:10px" />
            </div>

            <div
              class="invoice-selection"
              v-if="(partialPaymentType=='CASH' || ((partialPaymentType=='BANK_ACCOUNT' || partialPaymentType=='CARD_TERMINAL') && tableOpening.restaurant.canPayCardWithoutReceipt)) && tableOpening.restaurant.publishesReceipts && userCanPublishReceipts && ((priceOfSelectedProductsAfterDiscount!=0) || (priceOfSelectedProductsAfterDiscount=='' && selectedProductsDiscount==null))"
            >
              <input
                v-if="!ongoingModalAction && !userPublishesReceiptAlways"
                type="checkbox"
                id="invoice-checkbox"
                v-model="receiptOnPartialPayment"
              />
              <label
                v-if="!ongoingModalAction && !userPublishesReceiptAlways"
                style="margin-left:4px; font-weight: 500; font-size: 15px"
                for="invoice-checkbox"
              >Να βγει και απόδειξη</label>
            </div>

            <div
              class="invoice-selection"
              v-if="((partialPaymentType=='BANK_ACCOUNT' || partialPaymentType=='CARD_TERMINAL') && !tableOpening.restaurant.canPayCardWithoutReceipt) && tableOpening.restaurant.publishesReceipts && userCanPublishReceipts && ((priceOfSelectedProductsAfterDiscount!=0) || (priceOfSelectedProductsAfterDiscount=='' && selectedProductsDiscount==null))"
            >
              <font-awesome-icon style="margin-left:2px; color: #10703a" icon="cash-register" />
              <label
                style="margin-left:4px; font-weight: 500; font-size: 15px"
              >Θα βγει απόδειξη αναγκαστικά λόγω τραπεζικής πληρωμής</label>
            </div>

            <button
              class="action-button"
              id="card-terminal-send-transaction"
              style="margin-right: 0px !important; margin-top: 10px;"
              @click="payPartial(partialPaymentType)"
            >
              <clip-loader :loading="ongoingModalAction" size="18px" color="#ffffff" />
              {{ongoingModalAction ? '' : partialPaymentType=='CASH' ? 'Πληρωμή μετρητά' : partialPaymentType=='CARD_TERMINAL' ? 'Πληρωμή κάρτα' : 'Πληρωμή Λογ.Τράπεζας'}}
            </button>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>
        </div>

        <!-------- ROOM_CHARGE STATE -------->
        <div v-else-if="stateOfModal=='ROOM_CHARGE'" id="modal-content-container">
          <div id="room-charge-container">
            <h5 class="total-selected-price-title">
              {{labels.tableOpenings.totalOfSelectedItems[language]}}
              <span
                style="color: #007bff;"
              >{{priceOfSelectedItems.toFixed(2)}}€</span>
            </h5>
            <h6 class="payment-type-title">{{labels.tableOpenings.chooseChargingRoom[language]}}</h6>
            <select v-model="selectedRoomIdToCharge" @click="clearErrors()">
              <option
                v-for="hotelRoom in hotelRooms"
                :key="hotelRoom.id"
                :value="hotelRoom.id"
              >{{hotelRoom.tableNumber}}</option>
            </select>

            <div
              class="invoice-selection"
              v-if="tableOpening.restaurant.publishesReceipts && userCanPublishReceipts && (!tableOpening.restaurant.hotelizerIntegrationEnabled || (tableOpening.restaurant.hotelizerIntegrationEnabled && tableOpening.restaurant.hotelizerReceipt!='NO_RECEIPT'))"
            >
              <input
                v-if="!ongoingModalAction && !userPublishesReceiptAlways"
                type="checkbox"
                id="invoice-checkbox"
                v-model="receiptOnPartialPayment"
                :disabled="tableOpening.restaurant.hotelizerIntegrationEnabled && tableOpening.restaurant.hotelizerReceipt=='ON_CREDIT'"
              />
              <label
                v-if="!ongoingModalAction"
                style="margin-left:4px; font-weight: 500; font-size: 15px"
                for="invoice-checkbox"
              >{{tableOpening.restaurant.hotelizerIntegrationEnabled && tableOpening.restaurant.hotelizerReceipt=='ON_CREDIT' ? 'Θα ' : 'Να '}}βγει και απόδειξη επί πιστώσει η οποία θα επισυναπτεί στο δωμάτιο χρέωσης</label>
            </div>

            <button
              class="action-button"
              id="charge-room-button"
              style="margin-right: 0px !important; margin-top: 10px;"
              @click="chargeToRoom()"
            >
              <clip-loader :loading="ongoingModalAction" size="18px" color="#ffffff" />
              {{ongoingModalAction ? '' : labels.payment.chargeAtRoom[language]}}
            </button>
            <h6 v-if="errorAtModalAction" id="error-message-container">{{errorMessage}}</h6>
          </div>
        </div>
      </div>

      <div
        id="open-table-modal-footer"
        v-if="selectedOrderProducts.length>0 && stateOfModal=='SHOW_ORDERS' && (!assignedTablesOnly || !(assignedTablesOnly && tableOpening.id!=null &&(tableOpening.openingUserId==null || !waiterIds.includes(tableOpening.openingUserId))))"
      >
        <div class="bottom-amount-and-option-container" style="margin-bottom: 2px">
          <div v-if="!ongoingModalAction" class="selected-items-price-container">
            <h6
              id="amount-for-partial-payment"
              style="margin-top: 0px !important; margin-right: 4px"
            >{{labels.tableOpenings.selectedItems[language]}} {{priceOfSelectedItems.toFixed(2)}}€ |</h6>

            <div class="payment-option" style="align-items:center">
              <label class="switch" style="margin-left: 0px; margin-top: 0px;">
                <input
                  type="checkbox"
                  @change="onAllItemsSelectedChange()"
                  v-model="allItemsSelected"
                />
                <span class="slider round"></span>
              </label>
              <span @click="toggleAllItemsSelected()">Όλα</span>
            </div>
          </div>

          <div
            class="receipt-selection"
            v-if="tableOpening.restaurant.publishesReceipts && userCanPublishReceipts"
          >
            <input
              v-if="!ongoingModalAction && !userPublishesReceiptAlways"
              type="checkbox"
              id="invoice-checkbox"
              style="margin-bottom: 2px"
              v-model="receiptOnPartialPayment"
            />
            <label
              v-if="!ongoingModalAction && !userPublishesReceiptAlways"
              style="margin-left:4px; font-weight: 500; font-size: 15px"
              for="invoice-checkbox"
            >Απόδειξη</label>
          </div>
        </div>

        <clip-loader
          v-if="ongoingModalAction"
          style="margin-top:8px; margin-bottom:2px;"
          :loading="ongoingModalAction"
          size="18px"
          color="#393939"
        />
        <div id="bottom-buttons-container" v-if="!ongoingModalAction">
          <button
            v-if="userCanPartialCashPaid"
            class="action-button break-2nd"
            id="pay-cash-button"
            @click="payProducts('CASH')"
          >{{labels.tableOpenings.payCash[language]}}</button>
          <button
            v-if="userCanPartialCardPaid"
            class="action-button break-2nd"
            id="pay-card-button"
            @click="payProducts('CARD_TERMINAL')"
          >{{labels.tableOpenings.payCard[language]}}</button>
          <button
            v-if="userCanBePaidByBank && tableOpening.restaurant.publishesReceipts && !restaurantsThatDontSupportBankPayment.includes(tableOpening.restaurant.id)"
            class="action-button break-2nd"
            id="partial-bank-account-button"
            @click="payProducts('BANK_ACCOUNT')"
          >{{labels.tableOpenings.bankAccount[language]}}</button>
          <button
            v-if="hotelRooms && hotelRooms.length>0 && tableOpening.table.type!='HOTEL_ROOM'"
            class="action-button break-2nd"
            id="charge-room-btn"
            @click="changeModalState('ROOM_CHARGE')"
          >Charge room</button>
          <button
            v-if="userCanTreat"
            class="action-button break-2nd"
            id="treat-products-button"
            @click="treatProducts()"
          >{{labels.tableOpenings.treat[language]}}</button>
          <button
            v-if="userCanCancel"
            class="action-button break-2nd"
            id="cancel-products-button"
            @click="cancelProducts()"
          >{{labels.tableOpenings.cancel[language]}}</button>
        </div>
        <h6
          v-if="errorAtModalAction"
          id="error-message-container"
          style="margin-top: 0px !important;"
        >{{errorMessage}}</h6>
      </div>

      <div
        id="open-table-modal-footer"
        v-if="selectedOrderProductsForReceipt.length>0 && stateOfModal=='RECEIPT_VIEW' && tableOpening.table.typeOfReceipt=='TEMP_RECEIPT'"
      >
        <h6
          id="amount-for-partial-payment"
          v-if="!ongoingModalAction"
        >{{labels.tableOpenings.totalOfSelectedItems[language]}} {{priceOfSelectedItemsForReceipt.toFixed(2)}}€</h6>
        <clip-loader
          v-if="ongoingModalAction"
          style="margin-top:8px; margin-bottom:2px;"
          :loading="ongoingModalAction"
          size="18px"
          color="#393939"
        />
        <div id="bottom-buttons-container" v-if="!ongoingModalAction">
          <button
            class="action-button break-2nd"
            id="publish-temp-receipt-button"
            @click="publishTempReceipt('CASH')"
          >{{labels.tableOpenings.publishTempReceipt[language]}}</button>
        </div>
        <h6
          v-if="errorAtModalAction"
          id="error-message-container"
          style="margin-top: 0px !important;"
        >{{errorMessage}}</h6>
      </div>

      <div
        id="open-table-modal-footer"
        v-if="selectedOrderProductsForReceipt.length>0 && stateOfModal=='RECEIPT_VIEW' && tableOpening.table.typeOfReceipt=='FINAL_RECEIPT'"
      >
        <div class="bottom-amount-and-option-container">
          <h6
            id="amount-of-selected-temp-receipts"
            v-if="!ongoingModalAction"
          >{{labels.tableOpenings.totalOfSelectedItems[language]}} {{priceOfSelectedItemsForReceipt.toFixed(2)}}€</h6>

          <div class="invoice-selection">
            <input
              v-if="!ongoingModalAction"
              type="checkbox"
              id="invoice-checkbox"
              v-model="isInvoice"
            />
            <label
              v-if="!ongoingModalAction"
              style="margin-left:4px; font-weight: 500"
              for="invoice-checkbox"
            >Τιμολόγιο</label>
          </div>
        </div>

        <clip-loader
          v-if="ongoingModalAction"
          style="margin-top:8px; margin-bottom:2px;"
          :loading="ongoingModalAction"
          size="18px"
          color="#393939"
        />
        <div id="bottom-buttons-container" v-if="!ongoingModalAction">
          <button
            v-if="userCanPartialCashPaid"
            class="action-button break-2nd"
            id="pay-cash-button"
            @click="publishFinalReceiptOrAddInvoiceInfo('CASH')"
          >{{isInvoice ? labels.tableOpenings.invoiceCash[language] :labels.tableOpenings.receiptCash[language]}}</button>
          <button
            v-if="userCanPartialCardPaid"
            class="action-button break-2nd"
            id="pay-card-button"
            @click="publishFinalReceiptOrAddInvoiceInfo('CARD_TERMINAL')"
          >{{isInvoice ? labels.tableOpenings.invoiceCard[language] : labels.tableOpenings.receiptCard[language]}}</button>
          <button
            class="action-button break-2nd"
            id="on-credit-receipt-btn"
            @click="publishFinalReceiptOrAddInvoiceInfo('ON_CREDIT')"
          >{{labels.tableOpenings.receiptOnCredit[language]}}</button>
          <button
            v-if="userCanBePaidByBank"
            class="action-button break-2nd"
            id="bank-account-receipt-btn"
            @click="publishFinalReceiptOrAddInvoiceInfo('BANK_ACCOUNT')"
          >{{labels.tableOpenings.receiptBankAccount[language]}}</button>
          <button
            v-if="!isInvoice && userCanTreat"
            class="action-button break-2nd"
            id="self-delivery-receipt-btn"
            @click="publishFinalReceiptOrAddInvoiceInfo('SELF_DELIVERY')"
          >{{labels.tableOpenings.receiptSelfDelivery[language]}}</button>
        </div>
        <h6
          v-if="errorAtModalAction"
          id="error-message-container"
          style="margin-top: 0px !important;"
        >{{errorMessage}}</h6>
      </div>

      <div
        id="open-table-modal-footer"
        v-if="selectedTempReceipts.length>0 && stateOfModal=='TEMP_RECEIPTS'"
      >
        <div class="bottom-amount-and-option-container">
          <h6
            id="amount-of-selected-temp-receipts"
            v-if="!ongoingModalAction"
          >{{labels.tableOpenings.totalOfSelectedItems[language]}} {{totalAmountOfSelectedTempReceipts.toFixed(2)}}€</h6>

          <div class="invoice-selection">
            <input
              v-if="!ongoingModalAction"
              type="checkbox"
              id="invoice-checkbox"
              v-model="isInvoice"
            />
            <label
              v-if="!ongoingModalAction"
              style="margin-left:4px; font-weight:500"
              for="invoice-checkbox"
            >Τιμολόγιο</label>
          </div>
        </div>

        <clip-loader
          v-if="ongoingModalAction"
          style="margin-top:8px; margin-bottom:2px;"
          :loading="ongoingModalAction"
          size="18px"
          color="#393939"
        />
        <div id="bottom-buttons-container" v-if="!ongoingModalAction">
          <button
            v-if="userCanPartialCashPaid"
            class="action-button break-2nd"
            id="pay-cash-button"
            @click="publishFinalReceiptFromTempsOrAddInvoiceInfo('CASH')"
          >{{isInvoice ? labels.tableOpenings.invoiceCash[language] :labels.tableOpenings.receiptCash[language]}}</button>
          <button
            v-if="userCanPartialCardPaid"
            class="action-button break-2nd"
            id="pay-card-button"
            @click="publishFinalReceiptFromTempsOrAddInvoiceInfo('CARD_TERMINAL')"
          >{{isInvoice ? labels.tableOpenings.invoiceCard[language] : labels.tableOpenings.receiptCard[language]}}</button>
          <button
            class="action-button break-2nd"
            id="on-credit-receipt-btn"
            @click="publishFinalReceiptFromTempsOrAddInvoiceInfo('ON_CREDIT')"
          >{{labels.tableOpenings.receiptOnCredit[language]}}</button>
          <button
            v-if="userCanBePaidByBank"
            class="action-button break-2nd"
            id="bank-account-receipt-btn"
            @click="publishFinalReceiptFromTempsOrAddInvoiceInfo('BANK_ACCOUNT')"
          >{{labels.tableOpenings.receiptBankAccount[language]}}</button>
          <button
            v-if="!isInvoice && userCanTreat"
            class="action-button break-2nd"
            id="self-delivery-receipt-btn"
            @click="publishFinalReceiptFromTempsOrAddInvoiceInfo('SELF_DELIVERY')"
          >{{labels.tableOpenings.receiptSelfDelivery[language]}}</button>
          <button
            class="action-button break-2nd"
            id="cancel-receipts-btn"
            @click="cancelTempReceipts()"
          >{{labels.tableOpenings.deleteTempReceipts[language]}}</button>
        </div>
        <h6
          v-if="errorAtModalAction"
          id="error-message-container"
          style="margin-top: 0px !important;"
        >{{errorMessage}}</h6>
      </div>

      <div id="open-table-modal-footer" v-if="stateOfModal=='INVOICE_DETAILS'">
        <h6
          id="amount-of-invoice"
          v-if="!ongoingModalAction"
        >Σύνολο: {{tableOpening.table.typeOfReceipt == 'FINAL_RECEIPT' ? priceOfSelectedItemsForReceipt.toFixed(2) : totalAmountOfSelectedTempReceipts.toFixed(2)}}€</h6>
        <clip-loader
          v-if="ongoingModalAction"
          style="margin-top:8px; margin-bottom:2px;"
          :loading="ongoingModalAction"
          size="18px"
          color="#393939"
        />
        <div id="bottom-buttons-container" v-if="!ongoingModalAction">
          <button
            class="action-button break-2nd"
            id="pay-cash-button"
            @click="publishInvoice()"
          >Έκδοση τιμολογίου</button>
        </div>
        <h6
          v-if="errorAtModalAction"
          id="error-message-container"
          style="margin-top: 0px !important;"
        >{{errorMessage}}</h6>
      </div>

      <div id="open-table-modal-footer" v-if="stateOfModal=='FINAL_RECEIPTS' && errorAtModalAction">
        <h6 id="error-message-container" style="margin-top: 0px !important;">{{errorMessage}}</h6>
      </div>
    </div>
  </div>
</template>

<script>
import StoreApi from "../api/stores";
import OrderApi from "../api/order";
import LogApi from "../api/log";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import Button from './Button.vue';
import SubselectionsOfProductAtOrder from "./SubselectionsOfProductAtOrder";
import ProductInOrder from "./ProductInOrder";
import ReceiptProduct from "./ReceiptProduct";
import TempReceipt from "./TempReceipt";
import FinalReceipt from "./FinalReceipt";
import order from '../api/order';
export default {
  name: "OrdersOfOpenTableModal",
  components: {
    ClipLoader,
    ProductInOrder,
    ReceiptProduct,
    TempReceipt,
    FinalReceipt,
    SubselectionsOfProductAtOrder,
    Button
  },
  props: ["tableOpening", "isFromHistoryScreen", "typeOfTableOpenings", "currentUserId", "waiterOfcurrentUser", "adminAccounts", "isHotel", "tempReceiptsOfSelectedTableOpening", "assignedTablesOnly", "waiterIds", "waiters", "sections", "loadingOrders", "ordersOfSelectedTableOpening", "errorWhileLoadingOrders", "ordersConcatedNote", "authToken", "jwt", "hotelRooms", "tablesUserIsAbleToTransfer"],
  data() {
    return {
      hideDetails: true,
      stateOfModal: 'SHOW_ORDERS',
      stateOfHeader: 'SHOW_TABLE_OPENING_INFO',
      paymentType: 'CASH',
      partialPaymentType: 'CASH',
      amountPayedByCash: 0,
      amountPayedByCard: 0,
      ongoingModalAction: false,
      errorAtModalAction: false,
      errorMessage: "",
      selectedRestaurantIdToTranferTable: null,
      selectedTableIdToTrasfer: 0,
      selectedRoomIdToCharge: 0,
      selectedRoomIdToChargeOnClose: 0,
      printingTableOpening: false,
      printingOrderId: null,
      selectedOrderProducts: [],
      allItemsSelected: false,
      priceOfSelectedItems: 0,
      selectedOrderProductsForReceipt: [],
      priceOfSelectedItemsForReceipt: 0,
      selectedSection: 'ALL',
      isAtleastOneProductPendingReceipt: false,
      amountPendingReceipt: 0,
      selectedTempReceipts: [],
      selectedOnCreditReceipt: null,
      totalAmountOfSelectedTempReceipts: 0,
      showClosedTempReceipts: false,
      amountForSelfDeliveryReceipt: 0,
      isInvoice: false,
      receiptOnPartialPayment: false,
      vat: null,
      companyName: null,
      invoiceCountry: "GR",
      address: null,
      city: null,
      postalCode: null,
      invoiceComments: null,
      paymentMethodforInvoice: 'CASH',
      typeOfReceiptAfterClose: null,
      selectedCardTerminal: null,
      amountToBeChargedToPosOnTableClose: null,
      tableOpeningNote: null,
      minimumConsumptionOfSelectedTable: 0,
      restartingCashRegister: false,
      successfullAction: false,
      successfullMessage: "",
      resetOfStateOnChangeOfOrders: true,
      receiptOrIvoiceType: "RECEIPT",
      typeOfDiscount: "FINAL_PRICE",
      closeTableDiscount: null,
      finalPriceAfterDiscount: null,
      amountReceived: null,
      selectedProductsDiscount: null,
      assignedUserId: null,
      userIdToCloseTable: null,
      changeToBeGiven: "-",
      priceOfSelectedProductsAfterDiscount: null,
      irisPayment: false,
      finalReceiptsOfSelectedTableOpening: [],
      cardTip: null,
      restaurantsThatDontSupportBankPayment: [858], //TODO fix this properly from server
      restaurantsThatDontSupportReceiptOnlyForOpen: [664, 668, 669, 670] //TODO fix this properly from server
    };
  },
  watch: {

    showClosedTempReceipts(newVal, oldVal) {
      this.selectedTempReceipts = [];
      this.totalAmountOfSelectedTempReceipts = 0;
    },

    ordersOfSelectedTableOpening(newVal, oldVal) {
      this.isAtleastOneProductPendingReceipt = false;
      this.amountPendingReceipt = 0;
      if (newVal.length > 0) {
        for (let order of newVal) {
          order.products.forEach(orderContent => {
            let remainingReceiptQuantity = orderContent.quantity - orderContent.quantityCanceled - orderContent.quantityChargedToRoom - orderContent.quantityTreated - orderContent.quantityReceipt;
            if (remainingReceiptQuantity > 0) {
              this.isAtleastOneProductPendingReceipt = true;
              let totalSubselectionPrice = 0;
              orderContent.productSubselections.forEach(productSubselection => {
                totalSubselectionPrice = totalSubselectionPrice + productSubselection.price;
              });
              this.amountPendingReceipt = this.amountPendingReceipt + (orderContent.price + totalSubselectionPrice) * remainingReceiptQuantity;
            }
          });
        }
      }

      this.assignedUserId = this.tableOpening == null || this.tableOpening.id == null ? null : this.tableOpening.openingUserId;
      this.userIdToCloseTable = this.tableOpening == null || this.tableOpening.id == null ? null : this.waiterOfcurrentUser != null ? this.waiterOfcurrentUser.userId : this.tableOpening.openingUserId;

      if (this.resetOfStateOnChangeOfOrders) {
        this.resetModalState();
      }
    }

  },
  computed: {

    tempReceiptsToShow() {
      if (this.showClosedTempReceipts) {
        let receiptsToShow = this.tempReceiptsOfSelectedTableOpening.filter(tempReceipt => tempReceipt.status == 'CLOSED');
        return receiptsToShow;
      } else {
        let receiptsToShow = this.tempReceiptsOfSelectedTableOpening.filter(tempReceipt => tempReceipt.status != 'CLOSED');
        return receiptsToShow;
      }
    },

    isModalOpen() {
      return this.$store.state.itemModal.isOpen;
    },

    storeId() {
      return this.$store.getters.getStoreId;
    },

    restaurantsWithTableOpenings() {
      return this.$store.getters.getRestaurantsWithTableOpenings;
    },

    cardTerminals() {
      let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
      if (adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined && adminAcountOfUserForCurrentRestaurant.cardTerminalsOfUser != null && adminAcountOfUserForCurrentRestaurant.cardTerminalsOfUser.trim().length > 0) {
        let cardTerminalsOfUser = adminAcountOfUserForCurrentRestaurant.cardTerminalsOfUser.split(",");
        let cardTerminalsToShow = this.$store.getters.getCardTerminals.filter(cardTerminal => cardTerminal.restaurantId == this.tableOpening.restaurant.id && cardTerminalsOfUser.includes(`${cardTerminal.id}`));
        if (cardTerminalsToShow.length == 0) {
          return this.$store.getters.getCardTerminals.filter(cardTerminal => cardTerminal.restaurantId == this.tableOpening.restaurant.id);
        }
        return cardTerminalsToShow;
      } else {
        return this.$store.getters.getCardTerminals.filter(cardTerminal => cardTerminal.restaurantId == this.tableOpening.restaurant.id);
      }
    },

    serviceName() {
      return this.$store.getters.getServiceName;
    },

    language() {
      return this.$store.getters.getLanguage;
    },

    restaurantsWithTheirTables() {
      return this.$store.getters.getRestaurantsWithTheirTables;
    },

    currentGreekDate() {
      return this.$store.getters.getCurrentGreekDate
    },

    userCanCancel() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToCancel);
    },

    userCanPrintBill() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToPrintBill);
    },

    userCanTreat() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToTreat);
    },

    userCanReopenTable() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToReopenTable);
    },

    userCanEditMinimumConsumption() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToAddMinimumConsumption);
    },

    userCanDiscount() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToDiscount);
    },

    userCanCloseTable() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToCloseTable);
    },

    userCanTransferTable() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToTransfer);
    },

    userCanPartialCashPaid() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableForPartialCashPayment);
    },

    userCanPartialCardPaid() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableForPartialCardPayment);
    },

    userCanBePaidByBank() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToBePaidByBank);
    },

    userCanReprintOrder() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToReprintOrder);
    },

    userCanReprintReceipt() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToReprintReceipt);
    },

    userCanPublishReceipts() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToPublishReceipts);
    },

    userPublishesReceiptAlways() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.publishesAlwaysReceipt);
    },

    userCanAccessCashRegister() {
      return this.adminAccounts.some(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id && adminAccount.ableToAccessCashRegister);
    },

    amountRemainingToBePaidToFixed() {
      return this.amountRemainingToBePaid.toFixed(2);
    },

    amountRemainingToBePaid() {
      if (this.tableOpening.minimumConsumption == 0) {
        let amountThatRemains = this.tableOpening.totalPrice - this.tableOpening.amountPayedByCard - this.tableOpening.amountPayedByCash - this.tableOpening.amountChargedToRoom;
        amountThatRemains = amountThatRemains < 0 ? 0 : amountThatRemains;
        return amountThatRemains;
      }

      if (this.tableOpening.minimumConsumption > 0 && this.tableOpening.totalPrice == 0) {
        return 0;
      }

      let totalPrice = this.tableOpening.totalPrice <= this.tableOpening.minimumConsumption ? this.tableOpening.minimumConsumption : this.tableOpening.totalPrice;
      let amountThatRemains = totalPrice - this.tableOpening.amountPayedByCard - this.tableOpening.amountPayedByCash - this.tableOpening.amountChargedToRoom;
      amountThatRemains = amountThatRemains < 0 ? 0 : amountThatRemains;
      return amountThatRemains;
    },

    remainingOpenTempReceipts() {
      if (this.tableOpening.restaurant.publishesReceipts) {
        return this.tempReceiptsOfSelectedTableOpening.filter(tempReceipt => tempReceipt.status == 'OPEN');
      }
      let remainingOpenTempReceipts = [];
      return remainingOpenTempReceipts;
    },

    totalPriceOfOpenTempReceipts() {
      let totalPriceOfOpenTempReceipts = 0;
      this.remainingOpenTempReceipts.forEach(openTempReceipt => {
        totalPriceOfOpenTempReceipts = totalPriceOfOpenTempReceipts + openTempReceipt.totalAmount;
      });
      return totalPriceOfOpenTempReceipts;
    },

    isAtLeastOneOrderNotifiesUser() {
      let atLeastOneOrderNotPda = this.ordersOfSelectedTableOpening.some(order => (order.sendSmsAtExecution && order.phoneNumber != null) || (order.sendEmailAtExecution && order.emailToNotifyWhenExecuted != null));
      return atLeastOneOrderNotPda;
    },

    isAtLeastOneOrderNotExecuted() {
      let atLeastOneOrderNotExecuted = this.ordersOfSelectedTableOpening.some(order => !order.hasBeenExecuted);
      return atLeastOneOrderNotExecuted;
    },

    allTablesOfRestaurant() {
      if (this.tableOpening.table.type == 'HOTEL_ROOM' && this.hotelRooms.length > 0) {
        if (this.selectedSection == 'ALL') {
          return this.hotelRooms;
        } else {
          return this.hotelRooms.filter(hotelRoom => hotelRoom.familySection == this.selectedSection);
        }
      } else if (this.restaurantsWithTheirTables.length > 0) {
        let restaurantWithTables = this.restaurantsWithTheirTables.find(restaurant => restaurant.restaurantId == this.selectedRestaurantIdToTranferTable);
        if (this.selectedSection == 'ALL') {
          if (this.tablesUserIsAbleToTransfer.length > 0) {
            return this.tablesUserIsAbleToTransfer;
          }
          return restaurantWithTables.tables;
        } else {
          if (this.tablesUserIsAbleToTransfer.length > 0) {
            return this.tablesUserIsAbleToTransfer.filter(hotelRoom => hotelRoom.familySection == this.selectedSection);
          }
          return restaurantWithTables.tables.filter(hotelRoom => hotelRoom.familySection == this.selectedSection);
        }
      } else {
        let restsWithTables = [];
        return restsWithTables;
      }
    }
  },
  methods: {
    onCloseClick: function (event) {
      if ((this.stateOfModal == 'CLOSE_TABLE_OPENING' || this.stateOfModal == 'CARD_TERMINAL_SELECTION') && this.ongoingModalAction) {
        return;
      }

      this.resetModalState();
      this.$store.dispatch("closeTableOrdersModal");
    },

    toggleIrisPayment() {
      this.irisPayment = !this.irisPayment;
    },

    selectDiscountType(typeOfDiscount) {
      if (!this.ongoingModalAction) {
        this.typeOfDiscount = typeOfDiscount;
      }

    },

    findServiceName(userId) {
      let waiter = this.waiters.find(waiter => waiter.userId == userId);
      if (waiter != null) {
        return waiter.name;
      }
      return "-";
    },

    adjustChangeToBeGiven() {
      if (this.amountReceived == null || this.amountReceived <= 0) {
        this.changeToBeGiven = "-";
      } else if (this.amountReceived != null && this.amountReceived > 0) {

        let amountToBePaid = this.finalPriceAfterDiscount != null && this.finalPriceAfterDiscount <= this.amountRemainingToBePaid ? this.finalPriceAfterDiscount : this.amountRemainingToBePaid;

        if (this.finalPriceAfterDiscount == '') {
          amountToBePaid = this.amountRemainingToBePaid;
        }

        if (this.amountReceived > amountToBePaid) {
          let change = this.amountReceived - amountToBePaid;
          this.changeToBeGiven = change.toFixed(2) + "€";
        } else {
          this.changeToBeGiven = '0.00€';
        }
      }
    },

    adjustChangeToBeGivenOnPartialPayment() {
      if (this.amountReceived == null || this.amountReceived <= 0) {
        this.changeToBeGiven = "-";
      } else if (this.amountReceived != null && this.amountReceived > 0) {

        let amountToBePaid = this.priceOfSelectedProductsAfterDiscount != null && this.priceOfSelectedProductsAfterDiscount <= this.priceOfSelectedItems ? this.priceOfSelectedProductsAfterDiscount : this.priceOfSelectedItems;

        if (this.priceOfSelectedProductsAfterDiscount == '') {
          amountToBePaid = this.priceOfSelectedItems;
        }

        if (this.amountReceived > amountToBePaid) {
          let change = this.amountReceived - amountToBePaid;
          this.changeToBeGiven = change.toFixed(2) + "€";
        } else {
          this.changeToBeGiven = '0.00€';
        }
      }
    },

    adjustCloseTableDiscount() {
      this.clearErrors();
      this.amountReceived = null;
      this.changeToBeGiven = "-";
      if (this.finalPriceAfterDiscount == null || this.finalPriceAfterDiscount == undefined || this.finalPriceAfterDiscount == "") {
        this.closeTableDiscount = null
      } else if (this.finalPriceAfterDiscount >= this.amountRemainingToBePaid) {
        this.closeTableDiscount = null;
      } else {
        let discountMultiplier = this.finalPriceAfterDiscount / this.amountRemainingToBePaid;
        let discountMultiplierTo100 = discountMultiplier * 100;
        let discount = 100 - discountMultiplierTo100;
        let discountString = discount.toFixed(2);
        this.closeTableDiscount = Number(discountString);
      }
    },

    adjustDiscountForSelectedProducts() {
      this.clearErrors();
      this.amountReceived = null;
      this.changeToBeGiven = "-";
      if (this.priceOfSelectedProductsAfterDiscount == null || this.priceOfSelectedProductsAfterDiscount == undefined || this.priceOfSelectedProductsAfterDiscount == "") {
        this.selectedProductsDiscount = null
      } else if (this.priceOfSelectedProductsAfterDiscount >= this.priceOfSelectedItems) {
        this.selectedProductsDiscount = null;
      } else {
        let discountMultiplier = this.priceOfSelectedProductsAfterDiscount / this.priceOfSelectedItems;
        let discountMultiplierTo100 = discountMultiplier * 100;
        let discount = 100 - discountMultiplierTo100;
        let discountString = discount.toFixed(2);
        this.selectedProductsDiscount = Number(discountString);
      }
    },

    adjustFinalPriceAfterDiscount() {
      this.clearErrors();
      this.amountReceived = null;
      this.changeToBeGiven = "-";
      if (this.closeTableDiscount == null || this.closeTableDiscount == 0) {
        this.finalPriceAfterDiscount = null;
      } else if (this.closeTableDiscount >= 100) {
        this.finalPriceAfterDiscount = 0;
      } else {
        let finalPrice = this.amountRemainingToBePaid * (1 - (this.closeTableDiscount / 100));
        let finalPriceString = finalPrice.toFixed(2);
        this.finalPriceAfterDiscount = Number(finalPriceString);
      }
    },

    adjustPriceOfSelectedProductsAfterDiscount() {
      this.clearErrors();
      this.amountReceived = null;
      this.changeToBeGiven = "-";
      if (this.selectedProductsDiscount == null || this.selectedProductsDiscount == 0) {
        this.priceOfSelectedProductsAfterDiscount = null;
      } else if (this.selectedProductsDiscount >= 100) {
        this.priceOfSelectedProductsAfterDiscount = 0;
      } else {
        let finalPrice = this.priceOfSelectedItems * (1 - (this.selectedProductsDiscount / 100));
        let finalPriceString = finalPrice.toFixed(2);
        this.priceOfSelectedProductsAfterDiscount = Number(finalPriceString);
      }
    },

    setResetOfStateOnOrdersChange(resetOfStateOnChangeOfOrders) {
      this.resetOfStateOnChangeOfOrders = resetOfStateOnChangeOfOrders;
    },

    showError(errorMessage) {
      this.errorAtModalAction = true;
      this.errorMessage = errorMessage != null && errorMessage.trim().length > 0 ? errorMessage : 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
    },

    resetModalState() {
      this.resetOfStateOnChangeOfOrders = true;
      this.hideDetails = true;
      this.showClosedTempReceipts = false;
      this.stateOfModal = 'SHOW_ORDERS';
      this.paymentType = 'CASH';
      this.irisPayment = false;
      this.stateOfHeader = 'SHOW_TABLE_OPENING_INFO';
      this.amountPayedByCard = 0;
      this.amountPayedByCard = 0;
      this.ongoingModalAction = false;
      this.errorAtModalAction = false;
      this.errorMessage = "";
      this.selectedTableIdToTrasfer = 0;
      this.selectedRoomIdToCharge = 0;
      this.selectedRoomIdToChargeOnClose = 0;
      this.printingTableOpening = false;
      this.printingOrderId = null;
      this.selectedOrderProducts = [];
      this.allItemsSelected = false;
      this.priceOfSelectedItems = 0;
      this.selectedOrderProductsForReceipt = [];
      this.priceOfSelectedItemsForReceipt = 0;
      this.selectedSection = 'ALL';
      this.selectedTempReceipts = [];
      this.selectedOnCreditReceipt = null;
      this.totalAmountOfSelectedTempReceipts = 0;
      this.amountForSelfDeliveryReceipt = 0;
      this.isInvoice = false;
      this.receiptOnPartialPayment = this.tableOpening != null && this.tableOpening.table != null && this.userCanPublishReceipts ? this.tableOpening.table.defaultReceiptOnOpenTable || this.userPublishesReceiptAlways : false;
      this.vat = null;
      this.companyName = null;
      this.invoiceCountry = "GR";
      this.address = null;
      this.city = null;
      this.postalCode = null;
      this.invoiceComments = null;
      this.selectedCardTerminal = null;
      this.receiptOrIvoiceType = 'RECEIPT';
      this.typeOfDiscount = 'FINAL_PRICE';
      this.closeTableDiscount = null;
      this.finalPriceAfterDiscount = null;
      this.selectedProductsDiscount = null;
      this.amountReceived = null;
      this.changeToBeGiven = '-';
      this.priceOfSelectedProductsAfterDiscount = null;
      this.typeOfReceiptAfterClose = null;
      this.amountToBeChargedToPosOnTableClose = null;
      this.tableOpeningNote = null;
      this.minimumConsumptionOfSelectedTable = 0;
      this.restartingCashRegister = false;
      this.successfullAction = false;
      this.successfullMessage = "";
      this.cardTip = null;
    },

    changeStateOfHeader(state) {
      this.stateOfHeader = state;
      if (state == 'EDIT_NOTE') {
        this.tableOpeningNote = this.tableOpening.note;
      } else {
        this.tableOpeningNote = null;
      }

      if (state == 'EDIT_MINIMUM_CONSUMPTION') {
        this.minimumConsumptionOfSelectedTable = this.tableOpening.minimumConsumption;
      } else {
        this.minimumConsumptionOfSelectedTable = 0;
      }

      this.closeTableDiscount = null;
      this.finalPriceAfterDiscount = null;
      this.typeOfDiscount = 'FINAL_PRICE';
    },

    onSelectCardTerminal() {
      if (this.amountToBeChargedToPosOnTableClose == null && this.selectedCardTerminal != 'JUST_MARK_PAID' && this.selectedCardTerminal != null) {
        if (this.tableOpening.table.type == 'HOTEL_ROOM' || this.tableOpening.table.supportsOnCreditPayment) {
          this.amountToBeChargedToPosOnTableClose = 'REMAINING_AMOUNT_TO_TERMINAL_AND_RECEIPT_FOR_NON_PUBLISHED';
        } else if (this.amountRemainingToBePaid < (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts)) {
          this.amountToBeChargedToPosOnTableClose = 'RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID';
        } else {
          this.amountToBeChargedToPosOnTableClose = 'RECEIPT_FOR_ALL_REMAINING';
        }
      }
    },

    selectCardTerminalOnTableClose(cardTerminal) {
      if (!this.ongoingModalAction) {
        this.clearErrors()
        this.selectedCardTerminal = cardTerminal;
        this.onSelectCardTerminal();
      }

    },

    selectCardTerminal(cardTerminal) {
      this.clearErrors()
      this.selectedCardTerminal = cardTerminal;
    },

    addNewOrderToTable() {

      if (this.tableOpening.id != null && this.tableOpening.currentlyOpen && this.ordersOfSelectedTableOpening.length >= 150) {
        this.$confirm({
          message: `Αυτό το τραπέζι έχει ήδη 150 παραγγελίες, που είναι το μέγιστο επιτρεπτό όριο. Παρακαλώ κλείστε το τραπέζι και ανοίξτε το ξανά για να συνεχίσετε.`,
          button: {
            yes: 'ΟΚ'
          },
          callback: async confirm => {
            if (confirm) {
            } else {
            }
          }
        });
      } else {
        this.onCloseClick();
        setTimeout(() => {
          let fromOpenTable = this.typeOfTableOpenings == 'TABLES';
          let queryObject = { isPda: true, pdaId: this.$router.currentRoute.params.tableId, tableId: this.tableOpening.table.id, fromOpenTable: fromOpenTable };

          let reFetchMenuFromServer = this.tableOpening.table.serviceMode != 'DINE_IN';
          if (reFetchMenuFromServer) {
            queryObject.reFetchMenuFromServer = true;
          }

          if (this.tableOpening.id != null) {
            queryObject.tableOpeningId = this.tableOpening.id;
          }
          this.$router.push({
            name: "pda-menu",
            params: {
              tableId: this.tableOpening.table.id,
              service: this.tableOpening.restaurant.routeName,
              table: this.tableOpening.table
            },
            query: queryObject
          });
        }, 80);
      }

    },

    reopenTable() {
      if (!this.ongoingModalAction) {
        this.$confirm({
          message: "Είστε σίγουρος πως θέλετε να ανοίξετε ξανά τον συγκεκριμένο λογαριασμό και να κάνετε τροποποιήσεις; *ΠΡΟΣΟΧΗ* Θα γίνει επαναφορά στις πληρωμές του συγκεκριμένου λογαριασμού, και ο λογαριασμός θα μεταφερθεί στα ανοιχτά τραπέζια ώστε να κάνετε αλλαγές σε αυτόν.",
          button: {
            yes: 'Ναι',
            no: 'Ακύρωση'
          },
          callback: async confirm => {
            if (confirm) {
              this.ongoingModalAction = true;
              this.errorAtModalAction = false;
              this.errorMessage = "";

              let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
              let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;


              let response = await StoreApi.reOpenTable(this.tableOpening.id, this.tableOpening.restaurant.id, userId, this.authToken, this.jwt);
              if (response.error) {
                this.errorAtModalAction = true;
                this.ongoingModalAction = false;
                this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
              } else {
                this.$emit("remove-selected-tableOpening-from-list", response);
                this.ongoingModalAction = false;
                setTimeout(() => {

                  this.$confirm({
                    message: `Το τραπέζι επανήλθε στα ανοιχτά`,
                    button: {
                      yes: 'ΟΚ'
                    },
                    callback: async confirm => {
                      if (confirm) {
                        this.onCloseClick();
                      } else {
                        this.onCloseClick();
                      }
                    }
                  });
                }, 310);
              }
            }
          }
        });
      }
    },

    onClickOutside: function (event) {
      // if (event.target.id == "modal-container") {
      //   this.onCloseClick();
      // }
    },
    toggleDetails() {
      this.hideDetails = !this.hideDetails;
    },

    toggleTempReceipts() {
      this.showClosedTempReceipts = !this.showClosedTempReceipts;
    },

    selectAllItemsForReceipt() {
      var receiptProducts = this.$refs.receiptProduct;
      if (receiptProducts != null && receiptProducts.length > 0) {
        receiptProducts.forEach(receiptProduct => receiptProduct.selectAllProductsForReceipt())
      }
    },

    async changeModalState(state) {
      if ((this.stateOfModal == 'CLOSE_TABLE_OPENING' || this.stateOfModal == 'CARD_TERMINAL_SELECTION') && state == 'SHOW_ORDERS' && this.ongoingModalAction) {
        return;
      }

      if (state != 'ROOM_CHARGE' && state != 'TRANSFER_ORDERS_OF_TABLE') {
        this.selectedOrderProducts = [];
        this.priceOfSelectedItems = 0;
        this.allItemsSelected = false;
      }

      if (state == 'TRANSFER_ORDERS_OF_TABLE') {
        this.selectedRestaurantIdToTranferTable = this.tableOpening.restaurant.id;
      }

      this.errorAtModalAction = false;
      this.errorMessage = "";
      this.resetOfStateOnChangeOfOrders = true;

      this.restartingCashRegister = false;
      this.successfullAction = false;
      this.successfullMessage = "";

      this.showClosedTempReceipts = false;
      this.amountForSelfDeliveryReceipt = 0;
      this.hideDetails = true;
      this.selectedCardTerminal = null;
      this.typeOfReceiptAfterClose = null;
      this.receiptOrIvoiceType = 'RECEIPT';
      this.typeOfDiscount = 'FINAL_PRICE';
      this.closeTableDiscount = null;
      this.cardTip = null;
      this.irisPayment = false;
      this.finalPriceAfterDiscount = null;
      this.selectedProductsDiscount = null;
      this.amountReceived = null;
      this.changeToBeGiven = '-';
      this.priceOfSelectedProductsAfterDiscount = null;
      this.vat = null;
      this.companyName = null;
      this.invoiceCountry = "GR";
      this.address = null;
      this.city = null;
      this.postalCode = null;
      this.invoiceComments = null;

      this.amountToBeChargedToPosOnTableClose = null;

      this.selectedOrderProductsForReceipt = [];
      this.priceOfSelectedItemsForReceipt = 0
      this.selectedTempReceipts = [];
      this.selectedOnCreditReceipt = null;
      this.totalAmountOfSelectedTempReceipts = 0;
      this.isInvoice = false;
      if (state != 'ROOM_CHARGE') {
        this.receiptOnPartialPayment = this.tableOpening != null && this.tableOpening.table != null && this.userCanPublishReceipts ? this.userPublishesReceiptAlways || this.tableOpening.table.defaultReceiptOnOpenTable : false;
      }

      if (state == 'ROOM_CHARGE' && this.tableOpening.restaurant.hotelizerIntegrationEnabled) {
        this.receiptOnPartialPayment = this.tableOpening.restaurant.hotelizerReceipt == 'ON_CREDIT' ? true : this.tableOpening.restaurant.hotelizerReceipt == 'NO_RECEIPT' ? false : this.receiptOnPartialPayment;
      }

      if (state == 'CLOSE_TABLE_OPENING') {
        this.paymentType = this.userCanPartialCashPaid ? 'CASH' : 'CARD_TERMINAL';
        LogApi.closeTableScreenInitialized(this.tableOpening.id, this.authToken)
        this.userIdToCloseTable = this.userIdToCloseTable == null ? (this.waiterOfcurrentUser != null ? this.waiterOfcurrentUser.userId : this.tableOpening.openingUserId) : this.userIdToCloseTable;
        this.setTypeOfReceiptAccordingToUser();
      }

      this.stateOfModal = state;

      if (state == 'FINAL_RECEIPTS') {
        this.ongoingModalAction = true;
        this.finalReceiptsOfSelectedTableOpening = await StoreApi.fetchFinalReceiptsForTableOpening(this.tableOpening.id, this.tableOpening.restaurant.id, this.authToken, this.jwt);
        this.ongoingModalAction = false;
      }
    },

    async fetchFinalReceiptsAndOrders(response) {
      this.ongoingModalAction = true;
      this.finalReceiptsOfSelectedTableOpening = await StoreApi.fetchFinalReceiptsForTableOpening(this.tableOpening.id, this.tableOpening.restaurant.id, this.authToken, this.jwt);
      this.resetOfStateOnChangeOfOrders = false;
      this.$emit("update-selected-tableOpening", response);
      setTimeout(() => {
        this.ongoingModalAction = false;
      }, 530);
    },

    selectPaymentType(paymentType) {
      if (!this.ongoingModalAction) {
        this.paymentType = paymentType;
        this.onPaymentTypeChange();
      }

    },

    onPaymentTypeChange() {
      this.errorAtModalAction = false;
      this.setTypeOfReceiptAccordingToUser();
      this.amountToBeChargedToPosOnTableClose = null;
      this.selectedCardTerminal = null;
      this.irisPayment = false;
    },

    setTypeOfReceiptAccordingToUser() {
      try {
        let questionForReceiptExist = this.tableOpening.restaurant.publishesReceipts && this.userCanPublishReceipts && ((this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) || (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts <= 0 && this.tableOpening.minimumConsumption > 0 && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00')) && (this.paymentType == 'CASH' || this.paymentType == 'BANK_ACCOUNT' || (this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length == 0)) && ((this.finalPriceAfterDiscount != 0) || (this.finalPriceAfterDiscount == '' && this.closeTableDiscount == null));

        if (questionForReceiptExist && this.userPublishesReceiptAlways && this.tableOpening.table.type != 'HOTEL_ROOM' && !tableOpening.table.supportsOnCreditPayment && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00') {
          if (this.amountRemainingToBePaid < (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts)) {
            this.typeOfReceiptAfterClose = 'RECEIPT_FOR_ITEMS_NOT_MARKED_AS_PAID';
          } else {
            this.typeOfReceiptAfterClose = 'RECEIPT_FOR_ALL_REMAINING';
          }
        } else {
          this.typeOfReceiptAfterClose = null;
        }

      } catch (error) {
        console.log("Error during setting type of receipt according to user")
        this.typeOfReceiptAfterClose = null;
      }
    },

    selectTypeOfReceiptAfterClose(typeOfReceiptAfterClose) {
      if (!this.ongoingModalAction) {
        this.clearErrors();
        this.typeOfReceiptAfterClose = typeOfReceiptAfterClose;
      }

    },

    selectReceiptOrInvoice(receiptOrIvoiceType) {
      if (!this.ongoingModalAction) {
        this.clearErrors();
        this.receiptOrIvoiceType = receiptOrIvoiceType;
        if (receiptOrIvoiceType == 'INVOICE') {
          setTimeout(() => {
            let element = document.getElementById("invoice-info-container");
            element.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
          }, 71);

        }
      }

    },

    typeCashAmount() {
      this.errorAtModalAction = false;
      if (this.amountPayedByCash >= this.amountRemainingToBePaid) {
        this.amountPayedByCash = (this.amountRemainingToBePaid).toFixed(2);
        this.amountPayedByCard = 0;
      } else {
        this.amountPayedByCard = (this.amountRemainingToBePaid - this.amountPayedByCash).toFixed(2);
      }
    },

    typeCardAmount() {
      this.errorAtModalAction = false;
      if (this.amountPayedByCard >= this.amountRemainingToBePaid) {
        this.amountPayedByCard = (this.amountRemainingToBePaid).toFixed(2);
        this.amountPayedByCash = 0;
      } else {
        this.amountPayedByCash = (this.amountRemainingToBePaid - this.amountPayedByCard).toFixed(2);
      }
    },

    async selectRestaurantToTransfer() {
      this.errorAtModalAction = false;
      this.errorMessage = "";
      this.selectedTableIdToTrasfer = 0;
      this.selectedSection = 'ALL';
    },

    onSectionChange() {
      this.errorAtModalAction = false;
      this.errorMessage = "";
      if (this.selectedSection != 'ALL') {
        this.selectedTableIdToTrasfer = 0;
      }
    },

    selectTableToTransfer() {
      this.errorAtModalAction = false;
      this.errorMessage = "";
    },

    async printWholeTableOpening() {
      if (this.ordersOfSelectedTableOpening != null && this.ordersOfSelectedTableOpening.length > 0 && !this.printingTableOpening) {
        this.$confirm({
          message: 'Είστε σίγουρος για την εκτύπωση του λογαριασμού;',
          button: {
            yes: 'Ναι',
            no: 'Όχι'
          },
          callback: async confirm => {
            if (confirm) {
              this.printingTableOpening = true;
              let orderId = this.ordersOfSelectedTableOpening[0].id;
              let restaurantId = this.ordersOfSelectedTableOpening[0].restaurant.id;
              await OrderApi.sendForPrint(orderId, restaurantId, true, this.authToken, this.jwt);
              setTimeout(() => {
                this.printingTableOpening = false;
              }, 1600);
            }
          }
        });


      }
    },

    selectOrderProductForReceipt(orderProduct) {
      let isOrderProductAlreadyInSelected = this.selectedOrderProductsForReceipt.some(selectedOrderProduct => selectedOrderProduct.id == orderProduct.id);

      if (isOrderProductAlreadyInSelected) {
        if (orderProduct.quantityToBePaid == 0) {
          let orderProductInSelected = this.selectedOrderProductsForReceipt.find(selectedOrderProduct => selectedOrderProduct.id == orderProduct.id);
          let priceOfProductInSelected = Number(orderProductInSelected.priceOfProduct);
          this.priceOfSelectedItemsForReceipt = this.priceOfSelectedItemsForReceipt - (priceOfProductInSelected * orderProductInSelected.quantityToBePaid);
          this.selectedOrderProductsForReceipt = this.selectedOrderProductsForReceipt.filter(selectedOrderProduct => selectedOrderProduct.id != orderProduct.id);
        } else {
          let index = this.selectedOrderProductsForReceipt.findIndex(selectedOrderProduct => selectedOrderProduct.id === orderProduct.id);
          if (index != -1) {
            let orderProductInSelected = this.selectedOrderProductsForReceipt[index];
            let priceOfProductInSelected = Number(orderProductInSelected.priceOfProduct);
            let orderProductPrice = Number(orderProduct.priceOfProduct);
            this.priceOfSelectedItemsForReceipt = this.priceOfSelectedItemsForReceipt - (priceOfProductInSelected * orderProductInSelected.quantityToBePaid) + (orderProductPrice * orderProduct.quantityToBePaid);
            this.selectedOrderProductsForReceipt.splice(index, 1, orderProduct);
          }
        }
      } else {
        let orderProductPrice = Number(orderProduct.priceOfProduct);
        this.priceOfSelectedItemsForReceipt = this.priceOfSelectedItemsForReceipt + (orderProductPrice * orderProduct.quantityToBePaid);
        this.selectedOrderProductsForReceipt.push(orderProduct);
      }
    },

    selectTempReceipt(tempReceipt) {
      let isTempReceiptAlreadySelected = this.selectedTempReceipts.some(selectedTempReceipt => selectedTempReceipt.id == tempReceipt.id);
      if (isTempReceiptAlreadySelected) {
        this.selectedTempReceipts = this.selectedTempReceipts.filter(selectedTempReceipt => selectedTempReceipt.id != tempReceipt.id);
        this.totalAmountOfSelectedTempReceipts = this.totalAmountOfSelectedTempReceipts - tempReceipt.totalAmount;
      } else {
        this.totalAmountOfSelectedTempReceipts = this.totalAmountOfSelectedTempReceipts + tempReceipt.totalAmount;
        this.selectedTempReceipts.push(tempReceipt);
      }
    },

    selectOrderProduct(orderProduct) {
      let isOrderProductAlreadyInSelected = this.selectedOrderProducts.some(selectedOrderProduct => selectedOrderProduct.id == orderProduct.id);
      this.errorAtModalAction = false;
      this.errorMessage = "";

      if (isOrderProductAlreadyInSelected) {
        if (orderProduct.quantityToBePaid == 0) {
          let orderProductInSelected = this.selectedOrderProducts.find(selectedOrderProduct => selectedOrderProduct.id == orderProduct.id);
          let priceOfProductInSelected = Number(orderProductInSelected.priceOfProduct);
          this.priceOfSelectedItems = this.priceOfSelectedItems - (priceOfProductInSelected * orderProductInSelected.quantityToBePaid);
          this.selectedOrderProducts = this.selectedOrderProducts.filter(selectedOrderProduct => selectedOrderProduct.id != orderProduct.id);
        } else {
          let index = this.selectedOrderProducts.findIndex(selectedOrderProduct => selectedOrderProduct.id === orderProduct.id);
          if (index != -1) {
            let orderProductInSelected = this.selectedOrderProducts[index];
            let priceOfProductInSelected = Number(orderProductInSelected.priceOfProduct);
            let orderProductPrice = Number(orderProduct.priceOfProduct);
            this.priceOfSelectedItems = this.priceOfSelectedItems - (priceOfProductInSelected * orderProductInSelected.quantityToBePaid) + (orderProductPrice * orderProduct.quantityToBePaid);
            this.selectedOrderProducts.splice(index, 1, orderProduct);
          }
        }
      } else {
        let orderProductPrice = Number(orderProduct.priceOfProduct);
        this.priceOfSelectedItems = this.priceOfSelectedItems + (orderProductPrice * orderProduct.quantityToBePaid);
        this.selectedOrderProducts.push(orderProduct);
      }
    },

    clearErrors() {
      this.errorAtModalAction = false;
      this.errorMessage = '';
    },

    onAmountForSelfDeliveryChange() {
      this.errorAtModalAction = false;
      this.errorMessage = "";
    },

    async assignTable(userId) {
      if (!this.ongoingModalAction) {
        let message = this.tableOpening.openingUserId == null ? 'Είστε σίγουρος πως θέλετε να αναθέσετε πάνω σας το συγκεκριμένο τραπέζι;' : 'Είστε σίγουρος πως θέλετε να αναθέσετε το τραπέζι στον συγκεκριμένο χρήστη;'
        this.$confirm({
          message: message,
          button: {
            yes: 'Ναι',
            no: 'Όχι'
          },
          callback: async confirm => {
            if (confirm) {
              this.ongoingModalAction = true;
              this.errorAtModalAction = false;
              this.errorMessage = "";
              let response = await StoreApi.assignTable(this.tableOpening.restaurant.id, this.tableOpening.id, userId, this.authToken, this.jwt);
              if (response.error) {
                this.errorAtModalAction = true;
                this.ongoingModalAction = false;
                this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
              } else {
                this.assignedUserId = userId;
                this.$emit("update-selected-tableOpening", response);

                this.errorAtModalAction = false;
                this.ongoingModalAction = false;
              }
            }
          }
        });
      }

    },

    async generateTempSelfDeliveryReceipt() {
      this.errorAtModalAction = false;
      this.errorMessage = "";
      if (this.amountForSelfDeliveryReceipt == '' || this.amountForSelfDeliveryReceipt == null || this.amountForSelfDeliveryReceipt == undefined || this.amountForSelfDeliveryReceipt <= 0.009) {
        this.errorAtModalAction = true;
        this.errorMessage = "Το ποσό πρέπει να είναι τουλάχιστον 0.01 cents";
        return;
      }

      this.$confirm({
        message: `Είστε σίγουρος για την έκδοση του δελτίου αυτοπαράδοσης;`,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let restaurantId = this.tableOpening.restaurant.id;
            let response = await StoreApi.generateTempSelfDeliveryReceipt(restaurantId, this.tableOpening.id, this.amountForSelfDeliveryReceipt, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την έκδοση, δοκιμάστε ξανά.'
            } else {
              this.$emit("update-selected-tableOpening", response);
              this.amountForSelfDeliveryReceipt = 0;

              this.errorAtModalAction = false;
              this.ongoingModalAction = false;
            }
          }
        }
      });
    },

    async publishTempReceipt(paymentType) {

      this.$confirm({
        message: `Είστε σίγουρος για την έκδοση προσωρινής απόδειξης για τα επιλεγμένα προϊόντα;`,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let payload = {
              tableOpeningId: this.tableOpening.id,
              orderProductsForPayment: this.selectedOrderProductsForReceipt,
              paymentType: paymentType
            }

            let restaurantId = this.tableOpening.restaurant.id;
            let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
            let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

            let response = await StoreApi.generateTempReceipt(restaurantId, payload, userId, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την έκδοση απόδειξης, δοκιμάστε ξανά.'
            } else {
              this.$emit("update-selected-tableOpening", response);
              this.selectedOrderProductsForReceipt = [];
              this.priceOfSelectedItemsForReceipt = 0;
              this.selectedOrderProducts = [];
              this.allItemsSelected = false;
              this.priceOfSelectedItems = 0
              this.selectedTempReceipts = [];
              this.totalAmountOfSelectedTempReceipts = 0;

              this.errorAtModalAction = false;
              this.ongoingModalAction = false;
            }
          }
        }
      });
    },

    async publishFinalReceiptOrAddInvoiceInfo(paymentType) {
      if (this.isInvoice) {
        this.stateOfModal = "INVOICE_DETAILS";
        this.paymentMethodforInvoice = paymentType;
        return;
      }

      if (paymentType == 'CARD_TERMINAL' && this.cardTerminals.length >= 1) {
        this.stateOfModal = "CARD_TERMINAL_SELECTION";
        return;
      }

      await this.publishFinalReceipt(paymentType, null);
    },

    async publishFinalReceipt(paymentType, invoiceDetailsRequest) {
      let message = invoiceDetailsRequest != null ? `Είστε σίγουρος για την έκδοση τιμολογίου;` : `Είστε σίγουρος για την έκδοση τελικής απόδειξης;`;
      message = paymentType == 'CARD_TERMINAL' ? message + ' **ΠΡΟΣΟΧΗ** Αν έχετε συνδέσει το POS στο πρόγραμμα θα ενεργοποιηθεί και θα πρέπει να γίνει πληρωμή, ώστε να βγει η απόδειξη.' : message;

      this.$confirm({
        message: message,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let payload = {
              tableOpeningId: this.tableOpening.id,
              orderProductsForPayment: this.selectedOrderProductsForReceipt,
              paymentType: paymentType == 'SELF_DELIVERY' ? 'CASH' : paymentType,
              invoiceDetailsRequest: invoiceDetailsRequest,
              irisPayment: this.irisPayment,
              cardTip: this.cardTip != null && this.cardTip > 0 ? this.cardTip : 0
            }

            if (paymentType == 'CARD_TERMINAL' && this.cardTerminals.length >= 1 && this.selectedCardTerminal != 'JUST_MARK_PAID' && this.selectedCardTerminal != null) {
              payload.cardTerminalId = this.selectedCardTerminal;
            }

            let isSelfDeliveryReceipt = paymentType == 'SELF_DELIVERY';

            let restaurantId = this.tableOpening.restaurant.id;
            let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
            let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

            let response = await StoreApi.generateFinalReceipt(restaurantId, payload, isSelfDeliveryReceipt, userId, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την έκδοση απόδειξης, δοκιμάστε ξανά.'
            } else {
              this.$emit("update-selected-tableOpening", response);
              this.selectedOrderProductsForReceipt = [];
              this.priceOfSelectedItemsForReceipt = 0;
              this.selectedOrderProducts = [];
              this.allItemsSelected = false;
              this.priceOfSelectedItems = 0
              this.selectedTempReceipts = [];
              this.totalAmountOfSelectedTempReceipts = 0;

              this.errorAtModalAction = false;
              this.ongoingModalAction = false;
            }
          }
        }
      });
    },

    async publishCardReceiptAfterTerminalSelection() {
      if (this.selectedCardTerminal == null && ((this.priceOfSelectedProductsAfterDiscount != 0) || (this.priceOfSelectedProductsAfterDiscount == '' && this.selectedProductsDiscount == null))) {
        this.errorAtModalAction = true;
        this.errorMessage = 'Επιλέξτε το τερματικό κάρτας στο οποίο θέλετε να γίνει η πληρωμή'
        return;
      }
      if (this.selectedTempReceipts.length > 0) {
        await this.publishFromTemps('CARD_TERMINAL', null);
      } else if (this.selectedOrderProductsForReceipt.length > 0) {
        await this.publishFinalReceipt('CARD_TERMINAL', null);
      } else if (this.selectedOrderProducts.length > 0) {
        if (this.selectedCardTerminal == 'JUST_MARK_PAID') {
          this.receiptOnPartialPayment = false;
        }
        await this.payPartial('CARD_TERMINAL')
      } else if (this.selectedOnCreditReceipt != null) {
        await this.sendPaymentToPos(this.selectedOnCreditReceipt);
      }

    },

    async publishFinalReceiptFromTempsOrAddInvoiceInfo(paymentType) {
      if (this.isInvoice) {
        this.stateOfModal = "INVOICE_DETAILS";
        this.paymentMethodforInvoice = paymentType;
        return;
      }

      if (paymentType == 'CARD_TERMINAL' && this.cardTerminals.length >= 1) {
        this.stateOfModal = "CARD_TERMINAL_SELECTION";
        return;
      }

      await this.publishFromTemps(paymentType, null);
    },

    async publishInvoice() {
      let isInvoiceInfoValid = this.validateInvoiceInfo();
      if (isInvoiceInfoValid) {
        let invoiceDetailsRequest = {
          vat: this.vat,
          companyName: this.companyName,
          address: this.address,
          city: this.city,
          country: this.invoiceCountry,
          postalCode: this.postalCode,
          comments: this.invoiceComments
        };
        if (this.tableOpening.table.typeOfReceipt == 'FINAL_RECEIPT') {
          await this.publishFinalReceipt(this.paymentMethodforInvoice, invoiceDetailsRequest);
        } else {
          await this.publishFromTemps(this.paymentMethodforInvoice, invoiceDetailsRequest);
        }
      }
    },

    async publishFromTemps(paymentType, invoiceDetailsRequest) {
      let message = invoiceDetailsRequest != null ? `Είστε σίγουρος για την έκδοση τιμολογίου;` : `Είστε σίγουρος για την έκδοση τελικής απόδειξης;`;
      message = paymentType == 'CARD_TERMINAL' ? message + ' **ΠΡΟΣΟΧΗ** Αν έχετε συνδέσει το POS στο πρόγραμμα θα ενεργοποιηθεί και θα πρέπει να γίνει πληρωμή, ώστε να βγει η απόδειξη.' : message;
      this.$confirm({
        message: message,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let restaurantId = this.tableOpening.restaurant.id;
            let receiptIds = this.selectedTempReceipts.map(selectedTempReceipt => selectedTempReceipt.id);
            let isSelfDeliverReceipt = paymentType == 'SELF_DELIVERY' ? true : false;
            paymentType = paymentType == 'SELF_DELIVERY' ? 'CASH' : paymentType;
            let cardTerminalId = paymentType == 'CARD_TERMINAL' && this.cardTerminals.length >= 1 && this.selectedCardTerminal != 'JUST_MARK_PAID' ? this.selectedCardTerminal : null;

            let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
            let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

            let cardTip = this.cardTip != null && this.cardTip > 0 ? this.cardTip : 0
            let response = await StoreApi.generateFinalReceiptFromTemps(receiptIds, restaurantId, paymentType, isSelfDeliverReceipt, cardTerminalId, cardTip, invoiceDetailsRequest, userId, this.irisPayment, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την έκδοση απόδειξης, δοκιμάστε ξανά.'
            } else {
              this.$emit("update-selected-tableOpening", response);
              this.selectedOrderProductsForReceipt = [];
              this.priceOfSelectedItemsForReceipt = 0;
              this.selectedOrderProducts = [];
              this.allItemsSelected = false;
              this.priceOfSelectedItems = 0
              this.selectedTempReceipts = [];
              this.totalAmountOfSelectedTempReceipts = 0;
              this.selectedCardTerminal = null;

              this.errorAtModalAction = false;
              this.ongoingModalAction = false;
            }
          }
        }
      });
    },

    async searchCompanyByVat() {
      if (!this.ongoingModalAction) {
        this.errorAtModalAction = false;
        this.errorMessage = '';
        this.companyName = null;
        this.address = null
        this.city = null;
        this.postalCode = null;

        if (this.vat == null || this.vat.trim().length < 9) {
          this.errorAtModalAction = true;
          this.errorMessage = 'Συμπληρώστε τον 9ψήφιο ΑΦΜ'
          return;
        }

        this.ongoingModalAction = true;
        let restaurantId = this.tableOpening.restaurant.id;
        let response = await StoreApi.fetchCompanyByVat(restaurantId, this.vat, this.authToken, this.jwt);
        if (response.error) {
          this.ongoingModalAction = false;
          this.errorAtModalAction = true;
          this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.'
        } else {
          this.ongoingModalAction = false;
          if (response.searchResults != null && response.searchResults.length > 0) {
            let companyDetails = response.searchResults.find(searchResult => !searchResult.isBranch);
            if (companyDetails == null) {
              this.errorAtModalAction = true;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.';
              return;
            }
            this.companyName = companyDetails.coNameEl;
            this.address = companyDetails.streetNumber != null ? companyDetails.street + " " + companyDetails.streetNumber : companyDetails.street;
            this.city = companyDetails.city;
            this.postalCode = companyDetails.zipCode;
          } else {
            this.errorAtModalAction = true;
            this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.'
          }
        }
      }

    },

    validateInvoiceInfo() {
      let isValid = true;
      this.errorAtModalAction = false;
      this.errorMessage = '';
      if (this.vat == null || this.vat.trim().length == 0) {
        isValid = false;
        this.errorAtModalAction = true;
        this.errorMessage = 'Συμπληρώστε το ΑΦΜ'
      } else if (this.companyName == null || this.companyName.trim().length == 0) {
        isValid = false;
        this.errorAtModalAction = true;
        this.errorMessage = 'Συμπληρώστε το όνομα της εταιρείας'
      } else if (this.address == null || this.address.trim().length == 0) {
        isValid = false;
        this.errorAtModalAction = true;
        this.errorMessage = 'Συμπληρώστε την οδό μαζί με αριθμό'
      } else if (this.city == null || this.city.trim().length == 0) {
        isValid = false;
        this.errorAtModalAction = true;
        this.errorMessage = 'Συμπληρώστε την πόλη'
      } else if (this.postalCode == null || this.postalCode.trim().length == 0) {
        isValid = false;
        this.errorAtModalAction = true;
        this.errorMessage = 'Συμπληρώστε τον Τ.Κ.'
      } else if (this.paymentMethodforInvoice == 'CARD_TERMINAL' && this.cardTerminals.length >= 1 && (this.selectedCardTerminal == null || this.selectedCardTerminal == 'JUST_MARK_PAID')) {
        isValid = false;
        this.errorAtModalAction = true;
        this.errorMessage = 'Επιλέξτε το τερματικό κάρτας στο οποίο θέλετε να γίνει η πληρωμή'
      }
      return isValid;
    },

    async payProducts(paymentType) {

      this.partialPaymentType = paymentType;

      if (paymentType == 'CARD_TERMINAL' && this.cardTerminals.length > 0 && this.userCanPublishReceipts) {
        this.receiptOnPartialPayment = true;
        this.stateOfModal = "CARD_TERMINAL_SELECTION";
        return;
      }

      if (paymentType == 'CASH') {
        this.stateOfModal = "PARTIAL_PAY_SCREEN";
        return;
      }

      if ((paymentType == 'CARD_TERMINAL' || paymentType == 'CASH' || paymentType == 'BANK_ACCOUNT') && this.userCanDiscount) {
        this.stateOfModal = "PARTIAL_PAY_SCREEN";

        if (((this.partialPaymentType == 'BANK_ACCOUNT' || this.partialPaymentType == 'CARD_TERMINAL') && !this.tableOpening.restaurant.canPayCardWithoutReceipt) && this.tableOpening.restaurant.publishesReceipts && this.userCanPublishReceipts && ((this.priceOfSelectedProductsAfterDiscount != 0) || (this.priceOfSelectedProductsAfterDiscount == '' && this.selectedProductsDiscount == null))) {
          this.receiptOnPartialPayment = true;
        }

        return;
      }

      await this.payPartial(paymentType);
    },

    async editTableOpeningNote() {
      this.ongoingModalAction = true;
      this.errorAtModalAction = false;
      this.errorMessage = "";
      let tableOpeningNoteTrimmed = this.tableOpeningNote == null ? '' : this.tableOpeningNote.trim();
      tableOpeningNoteTrimmed = tableOpeningNoteTrimmed.trim().length == 0 ? ' ' : tableOpeningNoteTrimmed; //server returns error with just empty space

      let response = await StoreApi.editNote(this.tableOpening.restaurant.id, this.tableOpening.id, tableOpeningNoteTrimmed, this.authToken, this.jwt);
      if (response.error) {
        this.errorAtModalAction = true;
        this.ongoingModalAction = false;
        this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
      } else {
        this.tableOpening.note = response.note;
        this.stateOfHeader = 'SHOW_TABLE_OPENING_INFO';
        this.tableOpeningNote = null;
        this.errorAtModalAction = false;
        this.ongoingModalAction = false;
      }
    },

    async editTableOpeningMinimumConsumption() {
      this.ongoingModalAction = true;
      this.errorAtModalAction = false;
      this.errorMessage = "";
      this.minimumConsumptionOfSelectedTable = this.minimumConsumptionOfSelectedTable == '' ? 0 : this.minimumConsumptionOfSelectedTable;
      let minimumConsumptionAsString = `${this.minimumConsumptionOfSelectedTable}`;
      let response = await StoreApi.editMinimumConsumption(this.tableOpening.restaurant.id, this.tableOpening.id, minimumConsumptionAsString, this.authToken, this.jwt);
      if (response.error) {
        this.errorAtModalAction = true;
        this.ongoingModalAction = false;
        this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
      } else {
        this.tableOpening.minimumConsumption = response.minimumConsumption;
        this.stateOfHeader = 'SHOW_TABLE_OPENING_INFO';
        this.tableOpeningNote = null;
        this.errorAtModalAction = false;
        this.ongoingModalAction = false;
      }
    },

    async restartCashRegister() {

      this.$confirm({
        message: "Είστε σίγουρος για την επανεκκίνηση της online ταμειακής;",
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.restartingCashRegister = true;
            this.successfullAction = false;
            this.errorAtModalAction = false;
            this.errorMessage = "";
            this.successfullMessage = "";

            setTimeout(() => {
              this.restartingCashRegister = false;
              this.successfullAction = true;
              this.successfullMessage = "Η online ταμειακή επανεκκινήθηκε επιτυχώς";
              setTimeout(() => {
                this.successfullAction = false;
                this.successfullMessage = ""
              }, 5000);
            }, 1700);

            // let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
            // let response = await StoreApi.restartCashRegister(restaurantIds, this.authToken, this.jwt);
            // if (response.error) {
            //   this.restartingCashRegister = false;
            //   this.errorAtModalAction = true;
            //   this.errorMessage = 'Κάτι πήγε λάθος κατά την επανεκκίνηση της online ταμειακής, δοκιμάστε ξανά.'
            // } else {
            //   setTimeout(() => {
            //     this.restartingCashRegister = false;
            //     this.successfullAction = true;
            //     this.successfullMessage = "Η online ταμειακή επανεκκινήθηκε επιτυχώς";
            //     setTimeout(() => {
            //       this.successfullAction = false;
            //       this.successfullMessage = ""
            //     }, 5000);
            //   }, 1300);
            // }
          }
        }
      });
    },

    async putDiscount() {
      if (this.closeTableDiscount == null || this.closeTableDiscount <= 0 || this.closeTableDiscount == '') {
        this.errorAtModalAction = true;
        this.errorMessage = "Δεν έχετε πληκτρολογήσει κάποια έκπτωση για το τραπέζι";
        return;
      }

      if (!this.ongoingModalAction) {
        this.$confirm({
          message: `Είστε σίγουρος για την έκπτωση; *ΠΡΟΣΟΧΗ* η έκπτωση είναι μη αναστρέψιμη`,
          button: {
            yes: 'Ναι',
            no: 'Ακύρωση'
          },
          callback: async confirm => {
            if (confirm) {
              this.ongoingModalAction = true;
              this.errorAtModalAction = false;
              this.errorMessage = "";

              let discount = this.closeTableDiscount == null || this.closeTableDiscount <= 0 ? 0 : this.closeTableDiscount > 100 ? 100 : this.closeTableDiscount;

              let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
              let userId = adminAcountOfUserForCurrentRestaurant ? adminAcountOfUserForCurrentRestaurant.userId : null;

              let response = await StoreApi.putDiscount(this.tableOpening.id, this.tableOpening.restaurant.id, userId, discount, this.authToken, this.jwt);
              if (response.error) {
                this.errorAtModalAction = true;
                this.ongoingModalAction = false;
                this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
              } else {
                this.resetOfStateOnChangeOfOrders = true;
                this.$emit("update-selected-tableOpening", response);
                this.ongoingModalAction = false;
              }
            }
          }
        });
      }

    },

    async payPartial(paymentType) {
      if (!this.ongoingModalAction) {
        let message = '';
        if (this.tableOpening.restaurant.publishesReceipts) {
          let appendMsg = this.receiptOnPartialPayment ? ' και να εκδοθεί *ΑΠΟΔΕΙΞΗ* μαζί;' : ';';
          appendMsg = this.receiptOnPartialPayment && paymentType == 'CARD_TERMINAL' ? appendMsg + ' **ΠΡΟΣΟΧΗ** Αν έχετε συνδέσει το POS στο πρόγραμμα θα ενεργοποιηθεί και θα πρέπει να γίνει πληρωμή, ώστε να βγει η απόδειξη.' : appendMsg;
          message = `Είστε σίγουρος για την πληρωμή των επιλεγμένων προϊόντων ${paymentType == 'CASH' ? 'με μετρητά' : paymentType == 'BANK_ACCOUNT' ? 'σε τράπεζα' : 'με κάρτα'}${appendMsg}`
        } else {
          message = `Είστε σίγουρος για την πληρωμή των επιλεγμένων προϊόντων ${paymentType == 'CASH' ? 'με μετρητά' : paymentType == 'BANK_ACCOUNT' ? 'σε τράπεζα' : 'με κάρτα'};`;
        }
        this.$confirm({
          message: message,
          button: {
            yes: 'Ναι',
            no: 'Ακύρωση'
          },
          callback: async confirm => {
            if (confirm) {
              this.ongoingModalAction = true;
              this.errorAtModalAction = false;
              this.errorMessage = "";

              let discount = ((this.priceOfSelectedProductsAfterDiscount != 0) || (this.priceOfSelectedProductsAfterDiscount == '' && this.selectedProductsDiscount == null)) ? this.selectedProductsDiscount : 100;
              discount = discount != null && discount < 0 ? null : discount != null && discount > 100 ? 100 : discount;

              let payload = {
                tableOpeningId: this.tableOpening.id,
                orderProductsForPayment: this.selectedOrderProducts,
                paymentType: paymentType,
                discount: discount,
                irisPayment: this.irisPayment,
                cardTip: this.cardTip != null && this.cardTip > 0 ? this.cardTip : 0
              }

              if (paymentType == 'CARD_TERMINAL' && this.cardTerminals.length >= 1 && this.selectedCardTerminal != 'JUST_MARK_PAID' && this.selectedCardTerminal != null) {
                payload.cardTerminalId = this.selectedCardTerminal;
              }

              let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
              let receiptOnPartialPayment = ((this.priceOfSelectedProductsAfterDiscount != 0) || (this.priceOfSelectedProductsAfterDiscount == '' && this.selectedProductsDiscount == null)) ? this.receiptOnPartialPayment : false;

              let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
              let userId = adminAcountOfUserForCurrentRestaurant ? adminAcountOfUserForCurrentRestaurant.userId : null;

              let response = await StoreApi.payPartialBeforeClose(restaurantIds, payload, receiptOnPartialPayment, userId, this.tableOpening.restaurant.paidToExternalServer, this.authToken, this.jwt);
              if (response.error) {
                this.errorAtModalAction = true;
                this.ongoingModalAction = false;
                this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
              } else {
                let showError = response.errorResponseMessage != null && response.errorResponseMessage.trim().length > 0;
                this.resetOfStateOnChangeOfOrders = showError ? false : true;
                this.$emit("update-selected-tableOpening", response);
                if (!showError) {
                  this.receiptOnPartialPayment = this.tableOpening != null && this.tableOpening.table != null && this.userCanPublishReceipts ? this.tableOpening.table.defaultReceiptOnOpenTable || this.userPublishesReceiptAlways : false;
                  this.selectedOrderProducts = [];
                  this.allItemsSelected = false;
                  this.priceOfSelectedItems = 0;
                  this.selectedCardTerminal = null;
                  this.errorAtModalAction = false;
                } else {
                  this.errorAtModalAction = true;
                  this.errorMessage = response.errorResponseMessage == 'RECEIPT_ERROR' ? 'Κάτι πήγε λάθος κατά την έκδοση απόδειξης, δοκιμάστε ξανά.' : 'Κάτι πήγε λάθος, δοκιμάστε ξανά.';
                }
                this.ongoingModalAction = false;
              }
            }
          }
        });
      }

    },

    async executeOrders(isFirstTime) {
      let againWord = isFirstTime ? ' ' : ' ξανά ';
      this.$confirm({
        message: `Είστε σίγουρος πως θέλετε να μαρκάρετε${againWord}την παραγγελία ως εκτελεσμένη και να ειδοποιηθεί ο πελάτης ότι είναι έτοιμη;`,
        button: {
          yes: 'Ναι',
          no: 'Ακύρωση'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let response = await StoreApi.executeOrders(this.tableOpening.id, this.tableOpening.restaurant.id, this.authToken, this.jwt);

            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος κατά το μαρκάρισμα της παραγγελίας σαν εκτελεσμένη, δοκιμάστε ξανά.'
            } else {
              for (let order of this.ordersOfSelectedTableOpening) {
                order.hasBeenExecuted = true;
              }
              this.tableOpening.allOrdersExecuted = true;
              this.ongoingModalAction = false;
              this.successfullAction = true;
              this.successfullMessage = "Ο πελάτης που υπέβαλε την παραγγελία ειδοποιήθηκε επιτυχώς!"
              setTimeout(() => {
                this.successfullAction = false;
                this.successfullMessage = ""
              }, 5000);
            }
          }
        }
      });
    },

    async chargeToRoom() {
      this.errorMessage = "";
      if (this.selectedRoomIdToCharge == 0 || this.selectedRoomIdToCharge == null) {
        this.errorAtModalAction = true;
        this.ongoingModalAction = false;
        this.errorMessage = 'Επιλέξτε δωμάτιο που θα γίνει η χρέωση.'
        return;
      }

      this.$confirm({
        message: `Είστε σίγουρος για την χρέωση στο δωμάτιο των επιλεγμένων προϊόντων`,
        button: {
          yes: 'Ναι',
          no: 'Ακύρωση'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let payload = {
              tableOpeningId: this.tableOpening.id,
              orderProductsForPayment: this.selectedOrderProducts,
              paymentType: "ROOM_CHARGE",
              chargingRoomId: this.selectedRoomIdToCharge
            }

            let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
            let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

            let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
            let response = await StoreApi.chargeToRoom(restaurantIds, payload, this.receiptOnPartialPayment, userId, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
            } else {
              let showError = response.errorResponseMessage != null && response.errorResponseMessage.trim().length > 0;
              this.resetOfStateOnChangeOfOrders = showError ? false : true;
              this.$emit("update-selected-tableOpening", response);
              if (!showError) {
                this.receiptOnPartialPayment = this.tableOpening != null && this.tableOpening.table != null && this.userCanPublishReceipts ? this.tableOpening.table.defaultReceiptOnOpenTable || this.userPublishesReceiptAlways : false;
                this.selectedOrderProducts = [];
                this.allItemsSelected = false;
                this.priceOfSelectedItems = 0;
                this.errorAtModalAction = false;
              } else {
                this.errorAtModalAction = true;
                this.errorMessage = response.errorResponseMessage == 'RECEIPT_ERROR' ? 'Κάτι πήγε λάθος κατά την έκδοση απόδειξης, δοκιμάστε ξανά.' : 'Κάτι πήγε λάθος, δοκιμάστε ξανά.';
              }
              this.ongoingModalAction = false;

            }
          }
        }
      });
    },

    toggleAllItemsSelected() {
      this.allItemsSelected = !this.allItemsSelected;
      this.onAllItemsSelectedChange();
    },

    onAllItemsSelectedChange() {
      if (this.allItemsSelected) {
        this.selectAllItemsForPayment();
      } else {
        this.deselectAllItemsForPayment();
      }
    },

    selectAllItemsForPayment() {
      this.errorAtModalAction = false;
      this.errorMessage = "";
      var productsToBePaid = this.$refs.productToBePaid;
      if (productsToBePaid != null && productsToBePaid.length > 0) {
        productsToBePaid.forEach(productToBePaid => productToBePaid.selectAllQuantity())
      }
    },

    deselectAllItemsForPayment() {
      this.errorAtAction = false;
      this.errorMessageDuringAction = "";
      var productsToBePaid = this.$refs.productToBePaid;
      if (productsToBePaid != null && productsToBePaid.length > 0) {
        productsToBePaid.forEach(productToBePaid => productToBePaid.deselectAllQuantity())
      }
      this.selectedOrderProducts = [];
      this.priceOfSelectedItems = 0;
    },

    async cancelProducts() {

      this.$confirm({
        message: `Είστε σίγουρος για την ακύρωση των επιλεγμένων προϊόντων;`,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let payload = {
              tableOpeningId: this.tableOpening.id,
              orderProductsForPayment: this.selectedOrderProducts,
            }

            let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
            let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

            let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
            let response = await StoreApi.cancelProducts(restaurantIds, payload, userId, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
            } else {
              this.$emit("update-selected-tableOpening", response);
              this.selectedOrderProducts = [];
              this.allItemsSelected = false;
              this.priceOfSelectedItems = 0;
              this.errorAtModalAction = false;
              this.ongoingModalAction = false;
            }
          }
        }
      });
    },

    async treatProducts() {

      let message = '';
      if (this.tableOpening.restaurant.publishesReceipts) {
        let appendMsg = this.receiptOnPartialPayment ? ' και να εκδοθεί *ΑΠΟΔΕΙΞΗ ΑΥΤΟΠΑΡΑΔΟΣΗΣ* μαζί;' : ';';
        message = `Είστε σίγουρος πως θέλετε να κεράσετε τα επιλεγμένα προϊόντα${appendMsg}`
      } else {
        message = `Είστε σίγουρος πως θέλετε να κεράσετε τα επιλεγμένα προϊόντα;`;
      }

      this.$confirm({
        message: message,
        button: {
          yes: 'Ναι',
          no: 'Ακύρωση'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let payload = {
              tableOpeningId: this.tableOpening.id,
              orderProductsForPayment: this.selectedOrderProducts,
            }

            let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
            let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

            let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
            let response = await StoreApi.treatProducts(restaurantIds, payload, this.receiptOnPartialPayment, userId, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
            } else {
              this.$emit("update-selected-tableOpening", response);
              this.receiptOnPartialPayment = this.tableOpening != null && this.tableOpening.table != null && this.userCanPublishReceipts ? this.tableOpening.table.defaultReceiptOnOpenTable || this.userPublishesReceiptAlways : false;
              this.selectedOrderProducts = [];
              this.allItemsSelected = false;
              this.priceOfSelectedItems = 0;
              this.errorAtModalAction = false;
              this.ongoingModalAction = false;
            }
          }
        }
      });
    },

    async reOrder() {

      if (this.tableOpening.id != null && this.tableOpening.currentlyOpen && this.ordersOfSelectedTableOpening.length >= 150) {
        this.$confirm({
          message: `Αυτό το τραπέζι έχει ήδη 150 παραγγελίες, που είναι το μέγιστο επιτρεπτό όριο. Παρακαλώ κλείστε το τραπέζι και ανοίξτε το ξανά για να συνεχίσετε.`,
          button: {
            yes: 'ΟΚ'
          },
          callback: async confirm => {
            if (confirm) {
            } else {
            }
          }
        });
      } else if (!this.ongoingModalAction) {
        let message = `Είστε σίγουρος πως θέλετε να παραγγείλετε ξανά τα επιλεγμένα προϊόντα`
        message = this.receiptOnPartialPayment ? message + ' και να βγεί και *Aπόδειξη* μαζί;' : message + ';'

        this.$confirm({
          message: message,
          button: {
            yes: 'Ναι',
            no: 'Ακύρωση'
          },
          callback: async confirm => {
            if (confirm) {
              this.ongoingModalAction = true;
              this.errorAtModalAction = false;
              this.errorMessage = "";

              let payload = {
                tableOpeningId: this.tableOpening.id,
                orderProductsForPayment: this.selectedOrderProducts,
              }

              let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
              let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

              let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
              let response = await StoreApi.reOrder(restaurantIds, payload, this.receiptOnPartialPayment, this.language, userId, this.authToken, this.jwt);
              if (response.error) {
                this.errorAtModalAction = true;
                this.ongoingModalAction = false;
                this.errorMessage = response.message[this.language];
              } else {
                this.$emit("update-selected-tableOpening", response);
                this.receiptOnPartialPayment = this.tableOpening != null && this.tableOpening.table != null && this.userCanPublishReceipts ? this.tableOpening.table.defaultReceiptOnOpenTable || this.userPublishesReceiptAlways : false;
                this.selectedOrderProducts = [];
                this.allItemsSelected = false;
                this.priceOfSelectedItems = 0;
                this.errorAtModalAction = false;
                this.ongoingModalAction = false;
              }
            }
          }
        });
      }

    },

    async printOrder(order) {
      if (this.printingOrderId != order.id) {

        this.$confirm({
          message: 'Είστε σίγουρος για την επανεκτυπώση της παραγγελίας;',
          button: {
            yes: 'Ναι',
            no: 'Όχι'
          },
          callback: async confirm => {
            if (confirm) {
              this.printingOrderId = order.id;
              let orderId = order.id;
              let restaurantId = order.restaurant.id;
              await OrderApi.sendForPrint(orderId, restaurantId, false, this.authToken, this.jwt);
              setTimeout(() => {
                this.printingOrderId = null;
              }, 1600);
            }
          }
        });
      }
    },

    async closeTable() {
      if (!this.ongoingModalAction) {
        LogApi.closeTableButtonPressed(this.tableOpening.id, this.paymentType, this.authToken);
        LogApi.closeTableConfirmed(this.tableOpening.id, this.authToken);
        this.ongoingModalAction = true;
        this.errorAtModalAction = false;
        this.errorMessage = "";

        if (!this.userCanPublishReceipts) {
          this.typeOfReceiptAfterClose = 'NO_RECEIPT_AFTER_CLOSE';
          this.selectedCardTerminal = 'JUST_MARK_PAID';
        }

        if (this.paymentType == 'CASH_AND_CARD_TERMINAL' && this.amountRemainingToBePaid != (Number(this.amountPayedByCard) + Number(this.amountPayedByCash))) {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Το ποσό εξόφλησης μετρητών μαζί με το ποσό εξόφλησης κάρτας, δεν αθροίζουν το συνολικό ποσό της παραγγελίας.'
          LogApi.closeTableNotCorrectlyInputsFilled(this.tableOpening.id, "AMOUNT_CARD_AND_AMOUNT_CASH_NOT_SUMMING_TOTAL", this.authToken);
          return;
        }

        if (this.paymentType == 'ROOM_CHARGE' && this.selectedRoomIdToChargeOnClose == 0) {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Επιλέξτε δωμάτιο χρέωσης'
          LogApi.closeTableNotCorrectlyInputsFilled(this.tableOpening.id, "ROOM_CHARGE_ROOM_NOT_SELECTED", this.authToken);
          return;
        }

        if (((this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) || (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts <= 0 && this.tableOpening.minimumConsumption > 0 && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00') || this.tableOpening.table.type == 'HOTEL_ROOM' || this.tableOpening.table.supportsOnCreditPayment) && this.paymentType == 'CARD_TERMINAL' && ((this.finalPriceAfterDiscount != 0) || (this.finalPriceAfterDiscount == '' && this.closeTableDiscount == null)) && this.cardTerminals.length > 0 && this.selectedCardTerminal == null) {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Επιλέξτε το τερματικό κάρτας στο οποίο θα γίνει η πληρωμή'
          return;
        }

        if (((this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) || (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts <= 0 && this.tableOpening.minimumConsumption > 0 && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00')) && (this.paymentType == 'CASH' || this.paymentType == 'BANK_ACCOUNT' || (this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length == 0)) && this.tableOpening.restaurant.publishesReceipts && this.typeOfReceiptAfterClose == null && ((this.finalPriceAfterDiscount != 0) || (this.finalPriceAfterDiscount == '' && this.closeTableDiscount == null)) && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00') {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Επιλέξτε αν θέλετε να βγει και η τελική απόδειξη μαζί.'
          return;
        }

        if ((this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) && this.paymentType == 'ROOM_CHARGE' && this.tableOpening.restaurant.publishesReceipts && this.typeOfReceiptAfterClose == null && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00') {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Επιλέξτε αν θέλετε να βγει και απόδειξη επί πιστώσει μαζί.'
          return;
        }

        if (this.paymentType == 'CARD_TERMINAL' && (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) && this.cardTerminals.length > 0 && this.selectedCardTerminal != 'JUST_MARK_PAID' && this.selectedCardTerminal != null && this.amountToBeChargedToPosOnTableClose == null) {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Επιλέξτε το ποσό πληρωμής προς το τερματικό κάρτας'
          return;
        }

        if (this.tableOpening.restaurant.publishesReceipts && this.receiptOrIvoiceType == 'INVOICE' && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00' && (((this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) && (this.paymentType == 'CASH' || this.paymentType == 'BANK_ACCOUNT' || (this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length == 0)) && this.typeOfReceiptAfterClose != null && this.typeOfReceiptAfterClose != 'NO_RECEIPT_AFTER_CLOSE') || (this.paymentType == 'CARD_TERMINAL' && (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) && this.cardTerminals.length > 0 && this.selectedCardTerminal != 'JUST_MARK_PAID' && this.selectedCardTerminal != null))) {
          if (this.vat == null || this.vat.trim().length == 0) {
            this.ongoingModalAction = false;
            this.errorAtModalAction = true;
            this.errorMessage = 'Συμπληρώστε το ΑΦΜ. Διαφορετικά επιλέξτε απόδειξη αντί για τιμολόγιο';
            return;
          } else if (this.companyName == null || this.companyName.trim().length == 0) {
            this.ongoingModalAction = false;
            this.errorAtModalAction = true;
            this.errorMessage = 'Συμπληρώστε το όνομα της εταιρείας. Διαφορετικά επιλέξτε απόδειξη αντί για τιμολόγιο';
            return;
          } else if (this.address == null || this.address.trim().length == 0) {
            this.ongoingModalAction = false;
            this.errorAtModalAction = true;
            this.errorMessage = 'Συμπληρώστε την οδό μαζί με αριθμό. Διαφορετικά επιλέξτε απόδειξη αντί για τιμολόγιο';
            return;
          } else if (this.city == null || this.city.trim().length == 0) {
            this.ongoingModalAction = false;
            this.errorAtModalAction = true;
            this.errorMessage = 'Συμπληρώστε την πόλη. Διαφορετικά επιλέξτε απόδειξη αντί για τιμολόγιο';
            return;
          } else if (this.postalCode == null || this.postalCode.trim().length == 0) {
            this.ongoingModalAction = false;
            this.errorAtModalAction = true;
            this.errorMessage = 'Συμπληρώστε τον Τ.Κ. Διαφορετικά επιλέξτε απόδειξη αντί για τιμολόγιο';
            return;
          }
        }

        if (this.paymentType == 'ROOM_CHARGE') {
          await this.chargeToRoomAndCloseTable();
          this.ongoingModalAction = false;
        } else {
          if (this.userPublishesReceiptAlways && this.typeOfReceiptAfterClose != null && this.tableOpening.table.type != 'HOTEL_ROOM') {
            let questionForReceiptExist = this.tableOpening.restaurant.publishesReceipts && this.userCanPublishReceipts && ((this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) || (this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts <= 0 && this.tableOpening.minimumConsumption > 0 && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00')) && (this.paymentType == 'CASH' || this.paymentType == 'BANK_ACCOUNT' || (this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length == 0)) && ((this.finalPriceAfterDiscount != 0) || (this.finalPriceAfterDiscount == '' && this.closeTableDiscount == null));
            if (questionForReceiptExist && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00') {
              this.ongoingModalAction = false;
              this.$confirm({
                message: 'Είστε σίγουρος για το κλείσιμο του τραπεζιού;',
                button: {
                  yes: 'Ναι',
                  no: 'Όχι'
                },
                callback: async confirm => {
                  if (confirm) {
                    await this.finalizeCloseOfTable();
                  }
                }
              });
            } else {
              await this.finalizeCloseOfTable();
            }
          } else {
            await this.finalizeCloseOfTable();
          }
        }
      }
    },

    async finalizeCloseOfTable() {
      this.ongoingModalAction = true;
      let invoiceDetailsRequest = null;
      if (this.receiptOrIvoiceType == 'INVOICE') {
        invoiceDetailsRequest = {
          vat: this.vat,
          companyName: this.companyName,
          country: this.invoiceCountry,
          address: this.address,
          city: this.city,
          postalCode: this.postalCode,
          comments: this.invoiceComments
        };
      }

      let discount = ((this.finalPriceAfterDiscount != 0) || (this.finalPriceAfterDiscount == '' && this.closeTableDiscount == null)) ? this.closeTableDiscount : 100;
      discount = discount != null && discount < 0 ? null : discount != null && discount > 100 ? 100 : discount;

      let closeTableOpeningRequest = {
        tableOpeningId: this.tableOpening.id,
        paymentType: this.paymentType,
        amountPayedByCash: this.amountPayedByCash,
        amountPayedByCard: this.amountPayedByCard,
        invoiceDetailsRequest: invoiceDetailsRequest,
        discount: discount,
        irisPayment: this.irisPayment,
        cardTip: this.cardTip != null && this.cardTip > 0 ? this.cardTip : 0
      }

      let restaurantId = this.tableOpening.restaurant.id;
      let typeOfReceiptAfterClose = !this.tableOpening.restaurant.publishesReceipts ? null : this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length > 0 && this.selectedCardTerminal != 'JUST_MARK_PAID' ? this.amountToBeChargedToPosOnTableClose : this.paymentType == 'CASH' || this.paymentType == 'BANK_ACCOUNT' || (this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length == 0) ? this.typeOfReceiptAfterClose : null;
      typeOfReceiptAfterClose = ((this.finalPriceAfterDiscount != 0) || (this.finalPriceAfterDiscount == '' && this.closeTableDiscount == null)) ? typeOfReceiptAfterClose : null;

      typeOfReceiptAfterClose = this.amountRemainingToBePaidToFixed == '0.00' || this.amountRemainingToBePaidToFixed == '-0.00' ? null : typeOfReceiptAfterClose;

      let cardTerminalId = typeOfReceiptAfterClose != null && this.tableOpening.restaurant.publishesReceipts && this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length >= 1 && this.selectedCardTerminal != 'JUST_MARK_PAID' ? this.selectedCardTerminal : null;

      let response = null;
      if (this.assignedTablesOnly && this.waiterOfcurrentUser && this.waiterOfcurrentUser.ableToViewAllOpenTables && this.userIdToCloseTable != null) {
        response = await StoreApi.closeTableOpeningBySpecificUserForRestaurant(restaurantId, closeTableOpeningRequest, typeOfReceiptAfterClose, cardTerminalId, this.userIdToCloseTable, this.tableOpening.restaurant.paidToExternalServer, this.authToken, this.jwt);
      } else {
        response = await StoreApi.closeTableOpeningForRestaurant(restaurantId, closeTableOpeningRequest, typeOfReceiptAfterClose, cardTerminalId, this.tableOpening.restaurant.paidToExternalServer, this.authToken, this.jwt);
      }

      if (response.error) {
        LogApi.closeTableError(this.tableOpening.id, this.authToken);
        this.errorAtModalAction = true;
        this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
      } else {
        if (!this.tableOpening.restaurant.publishesReceipts) {
          LogApi.tableClosedSuccesfully(this.tableOpening.id, this.authToken);
          this.$emit("set-selected-tableOpening", response);
          this.stateOfModal = 'SHOW_ORDERS'
        } else {
          let showError = response.errorResponseMessage != null && response.errorResponseMessage.trim().length > 0;
          if (showError) {
            this.resetOfStateOnChangeOfOrders = false;
            this.$emit("update-selected-tableOpening", response);
            this.errorAtModalAction = true;
            this.errorMessage = response.errorResponseMessage == 'RECEIPT_ERROR' ? 'Κάτι πήγε λάθος , δοκιμάστε ξανά' : 'Κάτι πήγε λάθος, δοκιμάστε ξανά.';
          } else {
            this.resetOfStateOnChangeOfOrders = true;
            LogApi.tableClosedSuccesfully(this.tableOpening.id, this.authToken);
            this.$emit("set-selected-tableOpening", response);
            this.stateOfModal = 'SHOW_ORDERS'
          }
        }
      }
      this.ongoingModalAction = false;
    },

    async chargeToRoomAndCloseTable() {
      let orderProductsToChargeToRoom = []
      this.ordersOfSelectedTableOpening.forEach(async order => {
        for (let orderProduct of order.products) {
          let quantityToBeChargedToRoom = orderProduct.quantity - orderProduct.quantityCanceled - orderProduct.quantityPayedBeforeClose - orderProduct.quantityPayedByCardBeforeClose - orderProduct.quantityChargedToRoom - orderProduct.quantityTreated;
          if (quantityToBeChargedToRoom > 0) {
            let orderProductToBeChargedToRoom = {
              id: orderProduct.id,
              quantityToBePaid: quantityToBeChargedToRoom
            }
            orderProductsToChargeToRoom.push(orderProductToBeChargedToRoom);
          }
        }
      })

      let payload = {
        tableOpeningId: this.tableOpening.id,
        orderProductsForPayment: orderProductsToChargeToRoom,
        paymentType: "ROOM_CHARGE",
        chargingRoomId: this.selectedRoomIdToChargeOnClose
      }
      let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);

      let publishOnCreditReceipt = false;
      if ((this.amountPendingReceipt + this.totalPriceOfOpenTempReceipts > 0) && this.paymentType == 'ROOM_CHARGE' && this.tableOpening.restaurant.publishesReceipts && this.typeOfReceiptAfterClose != null && this.typeOfReceiptAfterClose != 'NO_RECEIPT_AFTER_CLOSE' && this.amountRemainingToBePaidToFixed != '0.00' && this.amountRemainingToBePaidToFixed != '-0.00') {
        publishOnCreditReceipt = true;
      }

      let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
      let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

      let chargeToRoomResponse = await StoreApi.chargeToRoom(restaurantIds, payload, publishOnCreditReceipt, userId, this.authToken, this.jwt);

      if (chargeToRoomResponse.error) {
        this.errorAtModalAction = true;
        this.ongoingModalAction = false;
        this.errorMessage = 'Κάτι πήγε λάθος κατά την χρέωση στο δωμάτιο, δοκιμάστε ξανά.'
      } else {
        let showError = chargeToRoomResponse.errorResponseMessage != null && chargeToRoomResponse.errorResponseMessage.trim().length > 0;
        this.resetOfStateOnChangeOfOrders = showError ? false : true;
        if (!showError) {
          this.errorMessage = '';
          this.errorAtModalAction = false;

          let closeTableOpeningRequest = {
            tableOpeningId: this.tableOpening.id,
            paymentType: 'ROOM_CHARGE',
            amountPayedByCash: 0,
            amountPayedByCard: 0,
            cardTip: 0
          }

          let restaurantId = this.tableOpening.restaurant.id;
          let typeOfReceiptAfterClose = null; //TODO finalize what happens with receipts when charge to room
          let cardTerminalId = typeOfReceiptAfterClose != null && this.tableOpening.restaurant.publishesReceipts && this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length >= 1 && this.selectedCardTerminal != 'JUST_MARK_PAID' ? this.selectedCardTerminal : null;
          let response = await StoreApi.closeTableOpeningForRestaurant(restaurantId, closeTableOpeningRequest, typeOfReceiptAfterClose, cardTerminalId, this.tableOpening.restaurant.paidToExternalServer, this.authToken, this.jwt);
          if (response.error) {
            this.errorAtModalAction = true;
            this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
          } else {
            this.$emit("update-selected-tableOpening", response);
          }
        } else {
          this.$emit("update-selected-tableOpening", chargeToRoomResponse);
          this.errorAtModalAction = true;
          this.errorMessage = chargeToRoomResponse.errorResponseMessage == 'RECEIPT_ERROR' ? 'Κάτι πήγε λάθος κατά την έκδοση απόδειξης, δοκιμάστε ξανά.' : 'Κάτι πήγε λάθος, δοκιμάστε ξανά.';
        }
        this.ongoingModalAction = false;

      }

    },

    async transferTable() {
      if (!this.ongoingModalAction) {
        this.ongoingModalAction = true;
        this.errorAtModalAction = false;
        this.errorMessage = "";
        if (this.selectedTableIdToTrasfer == 0 || this.selectedTableIdToTrasfer == null) {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Επιλέξτε τραπέζι μεταφοράς.'
          return;
        }

        if (this.selectedTableIdToTrasfer == this.tableOpening.table.id && this.tableOpening.restaurant.id == this.selectedRestaurantIdToTranferTable) {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Το τραπέζι μεταφοράς που επιλέξατε είναι ίδιο με το ήδη υπάρχων. Επιλέξτε κάποιο άλλο για να γίνει η μεταφορά.'
          return;
        }

        if (this.selectedOrderProducts.length > 0) {
          await this.partialTransfer();
          return;
        }

        let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.tableOpening.restaurant.id);
        let pdaUserId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

        let response = await StoreApi.transferTableOpening(this.tableOpening.id, this.selectedTableIdToTrasfer, this.tableOpening.restaurant.id, this.selectedRestaurantIdToTranferTable, pdaUserId, this.authToken, this.jwt);
        if (response.error) {
          this.errorAtModalAction = true;
          this.ongoingModalAction = false;
          this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
        } else {
          this.ongoingModalAction = false;
          this.ongoingModalAction = false;
          this.tableOpening.transferred = true;
          this.stateOfModal = 'SHOW_ORDERS'
          setTimeout(() => {

            this.$confirm({
              message: `Το τραπέζι μεταφέρθηκε`,
              button: {
                yes: 'ΟΚ'
              },
              callback: async confirm => {
                if (confirm) {
                  this.onCloseClick();
                  this.$emit("reload-tables-screen");
                } else {
                  this.onCloseClick();
                  this.$emit("reload-tables-screen");
                }
              }
            });
          }, 350);
        }
      }

    },

    async partialTransfer() {
      this.ongoingModalAction = true;
      this.errorAtModalAction = false;
      this.errorMessage = "";

      let payload = {
        tableOpeningId: this.tableOpening.id,
        orderProductsForPayment: this.selectedOrderProducts,
        tranferTableId: this.selectedTableIdToTrasfer,
        departmentIdToTransferTable: this.selectedRestaurantIdToTranferTable
      }

      let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id);
      let response = await StoreApi.partialTransfer(restaurantIds, payload, this.authToken, this.jwt);
      if (response.error) {
        this.errorAtModalAction = true;
        this.ongoingModalAction = false;
        this.errorMessage = 'Κάτι πήγε λάθος, δοκιμάστε ξανά.'
      } else {
        this.changeModalState('SHOW_ORDERS');
        this.$emit("reload-tables-screen");
        this.$emit("update-selected-tableOpening", response);
        this.selectedOrderProducts = [];
        this.allItemsSelected = false;
        this.priceOfSelectedItems = 0;
        this.errorAtModalAction = false;
        this.ongoingModalAction = false;
      }

    },

    async printTempReceipt(receiptId) {
      let restaurantId = this.tableOpening.restaurant.id;
      await StoreApi.sendTempReceiptForPrint(receiptId, restaurantId, this.authToken, this.jwt);
    },

    async printFinalReceipt(receiptId) {
      let restaurantId = this.tableOpening.restaurant.id;
      await StoreApi.sendFinalReceiptForPrint(receiptId, restaurantId, this.authToken, this.jwt);
    },

    calculateTotalOfReceipt(items) {
      let total = 0;
      items.forEach(item => total = total + item.totalPrice);
      return total.toFixed(2);
    },

    async selectTerminalOrSendPaymentToPos(receipt) {
      if (this.cardTerminals.length >= 1) {
        this.selectedOnCreditReceipt = receipt;
        this.stateOfModal = "CARD_TERMINAL_SELECTION";
        return;
      } else {
        await this.sendPaymentToPos(receipt);
      }
    },

    async sendPaymentToPos(receipt) {
      if (!this.ongoingModalAction) {
        this.$confirm({
          message: `Είστε σίγουρος για την εντολή πληρωμής προς το POS;`,
          button: {
            yes: 'Ναι',
            no: 'Όχι'
          },
          callback: async confirm => {
            if (confirm) {
              this.ongoingModalAction = true;
              this.errorAtModalAction = false;
              this.errorMessage = "";

              let cardTerminalId = this.cardTerminals.length >= 1 && this.selectedCardTerminal != 'JUST_MARK_PAID' ? this.selectedCardTerminal : null;
              let restaurantId = this.tableOpening.restaurant.id;
              let response = await StoreApi.updateReceiptToCardPayment(receipt.id, restaurantId, cardTerminalId, this.authToken, this.jwt);
              if (response.error) {
                this.errorAtModalAction = true;
                this.ongoingModalAction = false;
                this.errorMessage = 'Κάτι πήγε λάθος κατά την εντολή πληρωμής στo POS, δοκιμάστε ξανά.'
              } else {
                this.$emit("update-selected-tableOpening", response);
                this.selectedOrderProductsForReceipt = [];
                this.priceOfSelectedItemsForReceipt = 0;
                this.selectedOrderProducts = [];
                this.allItemsSelected = false;
                this.priceOfSelectedItems = 0
                this.selectedTempReceipts = [];
                this.selectedOnCreditReceipt = null;
                this.totalAmountOfSelectedTempReceipts = 0;

                this.errorAtModalAction = false;
                this.ongoingModalAction = false;
              }
            }
          }
        });
      }

    },

    cancelTempReceipts() {
      this.$confirm({
        message: `Είστε σίγουρος για την διαγραφή (ακύρωση) των επιλεγμένων προσωρινών αποδείξεων;`,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.ongoingModalAction = true;
            this.errorAtModalAction = false;
            this.errorMessage = "";

            let receiptIds = this.selectedTempReceipts.map(selectedTempReceipt => selectedTempReceipt.id);
            let restaurantId = this.tableOpening.restaurant.id;

            let response = await StoreApi.cancelTempReceipts(receiptIds, restaurantId, this.authToken, this.jwt);
            if (response.error) {
              this.errorAtModalAction = true;
              this.ongoingModalAction = false;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την διαγραφή, δοκιμάστε ξανά.'
            } else {
              this.$emit("update-selected-tableOpening", response);
              this.selectedOrderProductsForReceipt = [];
              this.priceOfSelectedItemsForReceipt = 0;
              this.selectedOrderProducts = [];
              this.allItemsSelected = false;
              this.priceOfSelectedItems = 0
              this.selectedTempReceipts = [];
              this.totalAmountOfSelectedTempReceipts = 0;

              this.errorAtModalAction = false;
              this.ongoingModalAction = false;
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>
#modal-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  z-index: 205 !important;
}

.iris-logo {
  width: 57px;
}

.modal-container-top-screen {
  margin-top: 1vh;
  align-items: flex-start;
}

.modal-container-centered {
  align-items: center;
}

.mb-2 {
  margin-bottom: 8px;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.pl-1 {
  padding-left: 4px;
}

.pt-1 {
  padding-top: 4px;
}

.pb-1 {
  padding-bottom: 4px;
}

.alert-secondary {
  color: #343536;
  background-color: #dbdcdd;
  border-color: #d2d3d4;
}

#modal {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 98vw;
  height: 98vh;
  min-width: 200px;
  min-height: 97%;
  max-height: 95%;
  background: #f5f5f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16), 0 2px 4px rgba(0, 0, 0, 0.23);
  overflow-y: scroll;

  opacity: 1;
  border-radius: 12px;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  z-index: 202 !important;
}

.cash-selected-payment {
  background-color: #198b4a;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

.card-selected-payment {
  background-color: #17a2b8;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

.bank-account-selected-payment {
  background-color: #0275d8;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

.cash-and-card-selected-payment {
  background-color: #6c757d;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

.room-charge-selected-payment {
  background-color: #ffc107;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

#tip-input-container {
  width: 90%;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  color: black;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 0px 0 1px 0 !important;
}

#tip-input-on-close-container {
  width: 90%;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  color: black;
  margin-top: 6px;
  margin-bottom: 14px;
  padding: 0px 0 1px 0 !important;
}

#change-amount-input-container,
#received-amount-input-container,
#pda-discount-input-container {
  width: 90%;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  color: black;
  padding: 0px 0 1px 0 !important;
}

#pda-discount-options {
  display: flex;
  flex-direction: row;
  margin-top: 6px;
  justify-content: flex-start;
}

.pda-discount-option {
  display: flex;
  flex-direction: row;
  color: #6d6d6d;
  cursor: pointer;
}

.pda-discount-option-title {
  font-size: 14px;
}

.pda-discount-type-input {
  accent-color: #198b4a;
  margin-bottom: 6px;
  margin-right: 5px;
}

#received-amount-header,
#change-header,
#pda-discount-header {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
}

#card-tip-input,
#edit-consumption-input,
#change-input,
#pda-discount-input {
  margin-left: 4px;
  background-color: #f7f7f7;
  font-size: 15px;
  font-weight: 600;
  width: 130px;
  padding-left: 5px;
  padding-bottom: 1px;
  color: #198b4a;

  border-radius: 5px;
  margin-bottom: 7px;
  box-shadow: inset 1px 1px 2px rgba(116, 135, 150, 0.36),
    inset -1px -1px 2px rgba(116, 135, 150, 0.36);
}

.light-blue-bgr {
  background: #eef6ff !important;
}

.light-green-bgr {
  background: #f3fef8 !important;
}

#write-note-header {
  margin-bottom: 0px !important;
  margin-left: 10px;
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
  color: #d40a87;
}

#edit-consumption-header,
#select-user-header {
  margin-bottom: 0px !important;
  margin-left: 10px;
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
  color: #00596f;
}

#edit-note-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-left: 4px;
  padding-right: 4px;
}

#edit-consumption-container,
#edit-user-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  padding-left: 4px;
  padding-right: 4px;
}

#note-textarea {
  width: 97%;
  height: 70px;
  padding: 6px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
  margin-bottom: 7px;
  margin-top: 5px;
  margin-right: 6px;
  margin-left: 6px;
}

#add-discount-header {
  margin-bottom: 0px !important;
  margin-left: 10px;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #00459b;
}

#total-for-discount {
  margin-bottom: 0px !important;
  margin-left: 10px;
  font-size: 16px;
  font-weight: 600;
}

#discount-state-container {
  width: 100%;
  padding: 8px 6px 4px 10px;
}

#header-and-content-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#modal::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

#close-modal {
  position: sticky;
  top: 2%;
  left: 93%;
  background: white;
  border-radius: 100%;
  min-height: 4.5vh;
  height: 40% !important;
  width: 4.5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 4px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.24), 2px 2px 4px rgba(0, 0, 0, 0.36);
}

.lower-cause-no-image {
  top: 3% !important;
}

#wide-image {
  margin-top: -4.5vh;
  max-height: 65vh;
  width: 100%;
  object-fit: cover;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

#modal-content-container {
  margin-top: 2.5vh;
  margin-bottom: 40px;
}

#temp-receipts-list-title {
  margin-left: 8px;
  font-size: 17px;
  font-weight: 700;
  color: #006adb;
}

#invoice-details-title {
  margin-left: 8px;
  font-size: 17px;
  font-weight: 700;
  color: #262626;
  margin-bottom: 0px;
}

#invoice-payment-method {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #262626;
  margin-bottom: 5px;
}

#invoice-total {
  margin-top: 4px;
  font-size: 17px;
  font-weight: 700;
  color: #262626;
  margin-bottom: 0px;
}

#final-receipts-list-title {
  margin-left: 8px;
  font-size: 17px;
  font-weight: 700;
  color: #198b4a;
}

#show-also-closed-receipts-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  color: #003340;
}

.no-temp-receipts-msg {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 0px;
  color: #e97b38;
  margin-left: 10px;
}

#closed-receipts-toggle-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 14px;
}

.order-content-container {
  display: flex;
  flex-direction: column;
}

#close-table-opening-container {
  display: flex;
  flex-direction: column;
  padding-left: 8px;
  padding-right: 8px;
}

#transfer-table-opening-container {
  display: flex;
  flex-direction: column;
  padding-left: 8px;
  padding-right: 8px;
}

#room-charge-container {
  display: flex;
  flex-direction: column;
  padding-left: 8px;
  padding-right: 8px;
}

.order-header-container {
  padding-left: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.order-header-info-container {
  display: flex;
  flex-direction: column;
}

.order-header-info {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0px;
  color: #393939;
}

.order-header-date {
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 0px;
  color: #424242;
}

.total-selected-price-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  margin-right: 0px;
}

.payment-type-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
  margin-right: 0px;
}

.order-note-container {
  padding-left: 8px;
}

.note-title {
  font-size: 15px;
  font-weight: 800;
  margin-right: 6px;
}

.payment-option {
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.align-center {
  align-items: center;
}

.mb-7 {
  margin-bottom: 7px;
}

.close-table-payment {
  margin-bottom: 0px;
}

.payment-type-icon {
  margin-left: 6px;
  margin-top: 0px;
  color: rgb(95, 95, 95);
}

.greenColor {
  color: #198b4a !important;
}

.cardTerminalColor {
  color: #17a2b8 !important;
}

.bankAccountColor {
  color: #0275d8 !important;
}

.payment-option > h6 {
  font-size: 14px;
}

.close-table-payment-type-input {
  accent-color: #198b4a;
  margin-right: 5px;
}

.input {
  accent-color: #198b4a;
  margin-bottom: 6px;
  margin-right: 5px;
}

.order-note-content {
  font-size: 15px;
  font-weight: 500;
}

#error-message-container {
  font-size: 15px;
  font-weight: 600;
  color: red;
  margin-top: 8px;
  margin-left: 4px;
}

#success-message-container {
  font-size: 15px;
  font-weight: 700;
  color: #198b4a;
  margin-top: 4px;
  margin-left: 4px;
  margin-bottom: 4px;
}

#open-table-modal-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  flex-shrink: 0;
  width: 100%;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.24), 0 2px 4px rgba(0, 0, 0, 0.36);
  position: sticky;
  top: 0;
  z-index: 20;
}

#open-table-modal-footer {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: sticky;
  bottom: 0;
  background-color: white;
}

.bottom-amount-and-option-container {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  justify-content: space-between;
  align-items: center;
}

.selected-items-price-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.invoice-selection {
  margin-right: 8px;
}

.receipt-selection {
  margin-right: 6px;
  display: flex;
  align-items: center;
}

#amount-of-selected-temp-receipts {
  color: #393939;
  margin-bottom: 0px;
  margin-left: 8px;
  font-size: 14px;
  font-weight: 700;
}

#amount-of-invoice {
  color: #393939;
  margin-bottom: 0px;
  margin-left: 8px;
  font-size: 14px;
  font-weight: 700;
  margin-top: 4px;
}

#amount-for-partial-payment {
  color: #393939;
  margin-bottom: 0px;
  margin-top: 7px;
  margin-left: 8px;
  font-size: 14px;
  font-weight: 700;
}

#bottom-buttons-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 0 4px;
  justify-content: space-between;
  padding-bottom: 6px;
  padding-right: 4px;
  padding-left: 4px;
  width: 100%;
}

#table-and-close-button {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
}

#item-description-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 95%;
  margin: 0% 8px 1% 8px;
}

#header-details-container {
  display: flex;
  flex-direction: column;
}

#all-buttons-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

#action-buttons-container {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  margin-bottom: 6px;
}

.action-button {
  padding: 4px 8px 4px 8px;
  border-radius: 6px;
  cursor: pointer;
}

.order-buttons {
  display: flex;
  flex-direction: column;
}

#go-to-close-table-opening-button {
  color: white;
  background-color: #007bff;
  margin-right: 10px;
}

#close-table-opening-button {
  color: white;
  background-color: #007bff;
}

#publish-invoice-button {
  color: white;
  background-color: #5cb85c;
  margin-right: 0px;
  margin-top: 10px;
}

#publish-self-delivery-temp-receipt-btn {
  color: white;
  background-color: #007bff;
  margin-right: 10px;
}

#add-note-button {
  color: rgb(255, 255, 255);
  background-color: #f430a8;
  margin-right: 8px !important;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 4px;
  font-size: 13px;
  padding-left: 6px;
}

#add-discount-button {
  color: rgb(255, 255, 255);
  background-color: #00459b;
  margin-right: 0px;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 4px;
  font-size: 13px;
  padding-left: 6px;
}

#edit-min-consumption-button {
  color: rgb(255, 255, 255);
  background-color: #01d51d;
  margin-right: 0px;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 4px;
  font-size: 13px;
  padding-left: 6px;
}

#change-user-button {
  color: rgb(255, 255, 255);
  background-color: #00596f;
  margin-right: 0px;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 4px;
  font-size: 13px;
  padding-left: 6px;
}

#execute-button {
  background-color: #ffffff;
  border: 1px solid #6c757d;
  color: #6c757d;
  margin-right: 0px;
  margin-left: 2px;
  margin-right: 4px;
  font-size: 13px;
  padding: 3px 6px 3px 4px;
  cursor: pointer;
}

#re-execute-button {
  background-color: #ffffff;
  color: #198b4a;
  margin-right: 0px;
  margin-left: 2px;
  margin-right: 6px;
  font-size: 16px;
  padding: 0px 0px 0px 0px;
  cursor: pointer;
}

#switch-to-receipts-view-button {
  color: rgb(255, 255, 255);
  background-color: rgb(98, 98, 98);
  margin-right: 0px;
  margin-left: 2px !important;
  margin-bottom: 2px;
  font-size: 13px;
}

#switch-to-self-delivery-receipt-btn {
  color: rgb(255, 255, 255);
  background-color: #6f2c91;
  font-size: 13px;
}

#restart-cash-register-btn {
  color: #ffffff;
  background-color: #17a2b8;
  font-size: 13px;
  margin-left: 4px;
}

#pay-cash-button {
  color: white;
  background-color: #5cb85c;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 5px 8px 5px 8px;
}

#search-company-button {
  color: white;
  background-color: #006adb;
  font-size: 14px;
  font-weight: 600;
  margin-top: 0px !important;
  margin-left: 6px;
}

#on-credit-receipt-btn {
  color: white;
  background-color: #f2b600;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
}

#bank-account-receipt-btn {
  color: white;
  background-color: #6c757d;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
}

#self-delivery-receipt-btn {
  color: white;
  background-color: #6f2c91;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
}

#cancel-receipts-btn {
  color: white;
  background-color: #dc3545;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
}

#publish-temp-receipt-button {
  color: white;
  background-color: #006adb;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
}

#pay-card-button {
  color: white;
  background-color: #17a2b8;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 5px 8px 5px 8px;
}

#cancel-products-button {
  color: white;
  background-color: #d9534f;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 5px 8px 5px 8px;
}

#reorder-products-button {
  color: white;
  background-color: #6c757d;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 5px 8px 5px 8px;
}

#treat-products-button {
  color: white;
  background-color: #6f2c91;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 5px 8px 5px 8px;
}

#partial-bank-account-button {
  color: white;
  background-color: #0275d8;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 5px 8px 5px 8px;
}

#choose-products-for-temp-receipt-title {
  padding-left: 8px;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #0057b4;
}

#choose-products-for-final-receipt-title {
  padding-left: 8px;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #198b4a;
}

#published-receipt-for-all-products-title {
  padding-left: 6px;
  padding-right: 6px;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #e97b38;
  text-align: center;
}

#charge-room-btn {
  color: white;
  background-color: #ffc107;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 5px 8px 5px 8px;
}

.break-2nd {
  width: 48%;
  flex-grow: 1;
}

#total-receipt-cash-button {
  color: white;
  background-color: #e97b38;
  font-weight: 500 !important;
  font-size: 14px !important;
}

#temp-history-receipts-button {
  color: white;
  background-color: #006adb;
  margin-left: 8px;
  font-size: 14px;
}

#final-history-receipts-button {
  color: white;
  background-color: #5cb85c;
  margin-left: 8px;
  font-size: 14px;
}

#total-receipt-card-button {
  color: white;
  background-color: #17a2b8;
}

#back-to-orders-button {
  color: white;
  background-color: #5a6268;
  font-size: 14px;
}

#transfer-table-opening-button {
  color: #212529;
  background-color: #ffc107;
  margin-right: 10px;
}

#note-buttons-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 8px;
}

#edit-consumption-buttons-container,
#change-user-buttons-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 8px;
}

#save-note-button {
  color: #ffffff;
  background-color: #d40a87;
  margin-left: 6px;
}

#save-discount-button {
  color: #ffffff;
  background-color: #00459b;
  margin-left: 6px;
}

#save-assigned-user-button {
  color: #ffffff;
  background-color: #00596f;
  margin-left: 6px;
}

#cancel-note-button {
  color: white;
  background-color: #5a6268;
  margin-right: 6px;
}

#card-terminal-send-transaction {
  color: #ffffff;
  background-color: #17a2b8;
  margin-right: 10px;
}

#charge-room-button {
  color: #212529;
  background-color: #ffc107;
  margin-right: 12px;
}

#table-closed-container-info {
  padding: 4px 8px 4px 8px;
  border-radius: 6px;
  color: #212529;
  background-color: #ffc107;
  opacity: 0.65;
  margin-bottom: 6px;
  text-align: center;
}

.greenEye {
  color: #198b4a;
  background-color: #ffffff;
  border: 1px solid;
}

.greyEye {
  color: #414141;
  background-color: #ffffff;
  border: 1px solid;
}

#hide-details-button {
  color: #212529;
  background-color: #ffc107;
}

#print-whole-order-button {
  color: white;
  background-color: #198b4a;
  margin-bottom: 6px;
  margin-left: 4px;
}

#open-table-button {
  color: white;
  background-color: #198b4a;
}

#assign-table-button {
  color: white;
  background-color: #006adb;
}

#new-order-button {
  width: 40px;
  color: white;
  background-color: #198b4a;
  margin-right: 10px;
}

#repeat-order-button {
  width: 40px;
  color: white;
  background-color: #6c757d;
  margin-right: 10px;
}

.amount-paid-by-title {
  margin-top: 10px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}

#invoice-info-container {
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  flex-direction: column;
}

.invoice-info-title {
  margin-top: 7px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}

.invoice-search-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.payed-by-input {
  background-color: white;
  border: 1px solid;
  border-color: rgb(183, 183, 183);
  padding: 2px 0px 2px 4px;
  border-radius: 4px;
  width: 250px;
}

.invoice-info-input {
  background-color: white;
  border: 1px solid;
  border-color: rgb(183, 183, 183);
  padding: 2px 0px 2px 4px;
  border-radius: 4px;
  width: 90%;
}

.execute-order-button {
  color: green;
  border: 1px solid;
}

.print-just-order-button {
  color: #212529;
  background-color: #ababab;
  margin-right: 6px;
}

.payed-already-container {
  display: flex;
  align-items: center;
}

.payed-already-info {
  color: #414141;
  margin-bottom: 0px;
  white-space: pre-wrap;
  font-weight: 600;
  font-size: 14px;
}

.payed-already-icon-card {
  font-size: 15px;
  margin-left: 5px;
  color: #17a2b8;
  margin-bottom: 0px;
}

.payed-already-icon-bank {
  font-size: 15px;
  margin-left: 5px;
  color: #0275d8;
  margin-bottom: 0px;
}

.payed-already-icon-cash {
  font-size: 15px;
  margin-left: 5px;
  color: #198b4a;
  margin-bottom: 0px;
}

.bed-payed-already-icon-cash {
  font-size: 15px;
  margin-left: 5px;
  color: #003340;
  margin-bottom: 0px;
}

.treated-icon-cash {
  font-size: 15px;
  margin-left: 5px;
  color: #6f2c91;
  margin-bottom: 0px;
}

.canceled-icon-cash {
  font-size: 15px;
  margin-left: 5px;
  color: #d9534f;
  margin-bottom: 0px;
}

.discounts-icon {
  font-size: 15px;
  margin-left: 5px;
  color: #198b4a;
  margin-bottom: 0px;
}

.item-description {
  color: #414141;
  margin-bottom: 0px;
  white-space: pre-wrap;
  font-weight: 600;
  font-size: 16px;
}

select {
  width: 80%;
  display: flex;
  justify-self: center;
  -webkit-appearance: auto !important;
  box-shadow: inset 0px 0px 2px rgba(116, 135, 150, 0.2),
    inset 1px 1px 2px rgba(116, 135, 150, 0.36);
  border-radius: 6px;
  margin-bottom: 0.5rem;
  padding: 4px;
  color: #198b4a !important;
  font-weight: bold;
  background: #f7f7f7;
}

#invoice-country-select {
  justify-self: flex-start !important;
  background-color: #ffffff !important;
  width: 90;
}

#room-to-charge-select {
  justify-self: flex-start !important;
}

@media screen and (max-width: 800px) {
  select {
    font-size: 14.5px;
  }
}

option {
  color: #198b4a !important;
  font-weight: 600;
}

#table-opening-date {
  margin-top: 4px;
  color: #585858;
  font-size: 12px;
}

.switch {
  margin-left: 8px;
  margin-right: 4px;
  margin-top: 3px;
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  width: 30px !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

@media only screen and (max-width: 1018px) {
  .no-image-width {
    width: 90%;
  }
}

@media screen and (max-width: 1018px) {
  .modal-bigger {
    max-height: 92% !important;
  }

  .modal-smaller {
    max-height: 80% !important;
  }

  #wide-image {
    max-height: 45vh;
  }

  #close-modal {
    width: 4.5vh;
    min-height: 4.5vh;
    top: 1%;
    margin-right: 8px;
  }

  #wide-image {
    margin-top: -4.5vh;
  }

  #plus,
  #minus {
    width: 23px;
    height: 23px;
  }

  #plus,
  #minus,
  #current-quantity,
  h4 {
    font-size: 14px !important;
  }

  #current-quantity {
    margin: 0vw 3vw 0 3vw;
  }

  #item-name {
    margin: 10px 8px 0 8px;
  }

  #show-more {
    margin-top: 1%;
  }
}

@media screen and (max-width: 753px) {
  #item-name {
    font-size: 18px;
  }

  .item-description {
    font-size: 15px;
  }

  #price > h5 {
    font-size: 14px;
  }
}

@media (max-width: 360px) {
  #item-name {
    font-size: 16px;
    margin-right: 13.5%;
  }

  #show-more {
    font-size: 11px;
  }

  #plus,
  #minus {
    width: 19px;
    height: 19px;
  }

  #plus,
  #minus,
  #current-quantity,
  h4 {
    font-size: 12px !important;
  }

  #price > h5 {
    font-size: 12px;
  }

  #regular-price > h5 {
    font-size: 12px;
  }

  #membership-price > h5 {
    font-size: 12px;
  }
}

@media screen and (max-width: 350px) {
  #close-modal {
    min-height: 3.5vh;
    width: 3.5vh;
    margin-right: 5%;
  }

  #times {
    font-size: 0.85rem;
  }

  #wide-image {
    margin-top: -3.5vh;
  }
}

@media (max-width: 300px) {
  #item-name {
    font-size: 15px;
  }

  .item-description {
    font-size: 14px;
  }

  #show-more {
    font-size: 10px;
  }

  #price > h5 {
    font-size: 10px;
  }

  #regular-price > h5 {
    font-size: 10px;
  }

  #membership-price > h5 {
    font-size: 10px;
  }

  select {
    font-size: 12px;
  }
}

@media screen and (max-height: 300px) {
  #modal {
    min-height: 100%;
  }
}
</style>



